module.exports = [
	{
		"fund_id": "FSUSA072BK",
		"percent_rated": 0.840584994055134,
		"percent_rated_long": 0.8587315612859707,
		"long_equity_assets": 67412644336.33811,
		"long_cbond_assets": 1884933426.318033,
		"long_equity_weight": 0.8601303019882156,
		"long_cbond_weight": 0.02405021154662928,
		"c2_asset": 2324775527.6026673,
		"c2_count": 167,
		"c2_weight": 0.029662237645435692,
		"co_asset": 1059410764.3993454,
		"co_count": 240,
		"co_weight": 0.013517216386973641,
		"og_asset": 4789553362.972362,
		"og_count": 511,
		"og_weight": 0.0611107904316615,
		"mc50_asset": 975641476.042277,
		"mc50_count": 53,
		"mc50_weight": 0.012448388661830333,
		"ut_asset": 2615118546.42446,
		"ut_count": 341,
		"ut_weight": 0.033366777512072295,
		"ff_hi_asset": 3241496974.533428,
		"ff_hi_count": 202,
		"ff_hi_weight": 0.04135885484166391,
		"ff_all_asset": 6571612173.254639,
		"ff_all_count": 801,
		"ff_all_weight": 0.08384840587070776,
		"cl_asset": 11823424036.92696,
		"cl_count": 214,
		"cl_weight": 0.15085723735561649,
		"fossil_bank_asset": 3143920213.337288,
		"fossil_bank_count": 65,
		"fossil_bank_weight": 0.040113855036346575,
		"fossil_insure_asset": 1586467792.6767025,
		"fossil_insure_count": 28,
		"fossil_insure_weight": 0.02024203374668738,
		"df_p_asset": 398173900.78540075,
		"df_p_count": 78,
		"df_p_weight": 0.005080373880864978,
		"df_c_asset": 5989402785.186484,
		"df_c_count": 160,
		"df_c_weight": 0.0764198894297721,
		"df_f_asset": 2331984610.848748,
		"df_f_count": 41,
		"df_f_weight": 0.02975421966172588,
		"df_all_asset": 8565331192.684477,
		"df_all_count": 259,
		"df_all_weight": 0.10928663276633271,
		"equileap_count": 3472,
		"dei_asset": 39934110779.8372,
		"dei_count": 2827,
		"dei_weight": 0.5095266489372379,
		"rji_asset": 39934110779.8372,
		"rji_count": 2827,
		"rji_weight": 0.5095266489372379,
		"hrc_asset": 35089760126.54247,
		"hrc_count": 762,
		"hrc_weight": 0.4477166898208716,
		"wff_gun_manufacturers_asset": 64407054.282703936,
		"wff_gun_manufacturers_count": 13,
		"wff_gun_manufacturers_weight": 0.0008217814268486061,
		"wff_gun_retailers_asset": 300032261.7009541,
		"wff_gun_retailers_count": 5,
		"wff_gun_retailers_weight": 0.003828166694893181,
		"wff_civ_asset": 364439315.983658,
		"wff_civ_count": 18,
		"wff_civ_weight": 0.004649948121741787,
		"wff_major_military_contractors_asset": 2460955423.981166,
		"wff_major_military_contractors_count": 231,
		"wff_major_military_contractors_weight": 0.03139978193775509,
		"wff_cluster_munitions_asset": 954499374.3864982,
		"wff_cluster_munitions_count": 32,
		"wff_cluster_munitions_weight": 0.01217863270638789,
		"wff_nuclear_weapons_asset": 1486472822.5465977,
		"wff_nuclear_weapons_count": 76,
		"wff_nuclear_weapons_weight": 0.01896617956974409,
		"wff_mil_asset": 2460955423.981166,
		"wff_mil_count": 231,
		"wff_mil_weight": 0.03139978193775509,
		"wff_hi_asset": 1686037590.122912,
		"wff_hi_count": 87,
		"wff_hi_weight": 0.02151246306732076,
		"wff_all_asset": 2765766650.5779443,
		"wff_all_count": 239,
		"wff_all_weight": 0.035288924322884184,
		"t_asset": 409408283.6588304,
		"t_count": 17,
		"t_weight": 0.005223715433903056,
		"t_m_asset": 524387482.12002695,
		"t_m_count": 9,
		"t_m_weight": 0.006690756130324492,
		"t_all_asset": 933795765.7788574,
		"t_all_count": 26,
		"t_all_weight": 0.011914471564227548,
		"ip_divest_asset": 1684447430.5873108,
		"ip_divest_count": 55,
		"ip_divest_weight": 0.021492173929948517,
		"pp_divest_asset": 136918584.6189087,
		"pp_divest_count": 16,
		"pp_divest_weight": 0.001746969351157457,
		"borders_divest_asset": 786816086.662901,
		"borders_divest_count": 28,
		"borders_divest_weight": 0.010039130861771344,
		"pff_prisons_asset": 6928004915.973398,
		"pff_prisons_count": 50,
		"pff_prisons_weight": 0.08839568628729653,
		"pff_borders_asset": 6557215603.985281,
		"pff_borders_count": 57,
		"pff_borders_weight": 0.08366471740105709,
		"pff_high_asset": 800393867.0636991,
		"pff_high_count": 33,
		"pff_high_weight": 0.010212372253967747,
		"pff_extreme_asset": 9194248.497662826,
		"pff_extreme_count": 5,
		"pff_extreme_weight": 0.00011731110409188563,
		"pff_all_asset": 8431406449.996045,
		"pff_all_count": 85,
		"pff_all_weight": 0.10757786239385526,
		"pff_prisons_high_asset": 136918584.6189087,
		"pff_prisons_high_count": 16,
		"pff_prisons_high_weight": 0.001746969351157457,
		"pff_borders_high_asset": 786816086.662901,
		"pff_borders_high_count": 28,
		"pff_borders_high_weight": 0.010039130861771344,
		"fund_family_label": "Vanguard",
		"fund_legal_name": "Vanguard Target Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 15.2528,
		"fossil_insure_score": 17.04,
		"grade_gender_equality": 3,
		"gef_grp_norm": 54.25925925925926,
		"gef_percent_rated": 0.7372399684611465,
		"gef_score": 54.12053794768862,
		"strategy_name": "Vanguard Target Retirement Series",
		"net_assets": 76682961342,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 691414232805,
		"ticker": "VFIFX",
		"investment_vehicle_name": "Vanguard Target Retirement 2050 Fund",
		"legal_type": "FO",
		"prospectus_date": "2025-01-31",
		"investment_vehicle_id": "FOUSA05HZH",
		"tickers": "VFIFX",
		"strategy_fund_legal_names": "Vanguard Target Retirement 2020 Fund, Vanguard Target Retirement 2025 Fund, Vanguard Target Retirement 2030 Fund, Vanguard Target Retirement 2035 Fund, Vanguard Target Retirement 2040 Fund, Vanguard Target Retirement 2045 Fund, Vanguard Target Retirement 2050 Fund, Vanguard Target Retirement 2055 Fund, Vanguard Target Retirement 2060 Fund, Vanguard Target Retirement 2065 Fund, Vanguard Target Retirement 2070 Fund, Vanguard Target Retirement Income",
		"strategy_tickers": "VTWNX, VTTVX, VTHRX, VTTHX, VFORX, VTIVX, VFIFX, VFFVX, VTTSX, VLXVX, VSVNX, VTINX",
		"strategy_name_query": "vanguard-target-retirement-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00491
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00244
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00138
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00134
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00134
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00072
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00059
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00055
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00054
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00491
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00244
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00189
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00139
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00928
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.0009
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00055
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00024
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00022
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00928
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00096
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.0009
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00072
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00928
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00491
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00244
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00189
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00262
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00225
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00223
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00175
					},
					{
						"standard_name": "Royal Bank of Canada",
						"long_weight": 0.00174
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00928
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00163
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00112
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.0011
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00091
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00072
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00068
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00049
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00028
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00027
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00653
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00262
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00223
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00175
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00167
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01727
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.004
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.0038
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.0038
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00369
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00071
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Poongsan Corp",
						"long_weight": 0.00001
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00369
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00011
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Sportsman's Warehouse Holdings Inc",
						"long_weight": 0
					},
					{
						"standard_name": "Big 5 Sporting Goods Corp",
						"long_weight": 0
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02656
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01727
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01553
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00928
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.004
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02656
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01727
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01553
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00232
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00223
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00172
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00114
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.001
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00071
					}
				]
			},
			"is_pff_extreme": {
				"count": 5,
				"list": [
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00004
					},
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0.00002
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0.00002
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00002
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00194
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.0015
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00131
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00122
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00131
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00114
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.001
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00099
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00194
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00131
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00122
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00114
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00235
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00097
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.0009
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00034
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00033
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00193
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.0017
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00165
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00132
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00006
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"JBS SA",
				"Tyson Foods Inc"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"Palantir Technologies Inc"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FTSP0L2050",
		"percent_rated": 0.8046484504630091,
		"percent_rated_long": 0.8087382316472244,
		"long_equity_assets": 31513122436.269264,
		"long_cbond_assets": 696321703.9630175,
		"long_equity_weight": 0.8080657449501519,
		"long_cbond_weight": 0.01785521944313075,
		"c2_asset": 1034444199.6253154,
		"c2_count": 65,
		"c2_weight": 0.026525423638044086,
		"co_asset": 419687447.419172,
		"co_count": 43,
		"co_weight": 0.010761708889077955,
		"og_asset": 2067350121.526529,
		"og_count": 212,
		"og_weight": 0.05301140245313924,
		"mc50_asset": 427573814.00646496,
		"mc50_count": 8,
		"mc50_weight": 0.01096393266757527,
		"ut_asset": 1188159751.3476887,
		"ut_count": 88,
		"ut_weight": 0.030467028347769834,
		"ff_hi_asset": 1453279296.0067964,
		"ff_hi_count": 72,
		"ff_hi_weight": 0.03726527637251141,
		"ff_all_asset": 2837125390.9510474,
		"ff_all_count": 274,
		"ff_all_weight": 0.07275013281188714,
		"cl_asset": 5609488349.860179,
		"cl_count": 110,
		"cl_weight": 0.1438396144776186,
		"fossil_bank_asset": 1586323094.2021074,
		"fossil_bank_count": 34,
		"fossil_bank_weight": 0.040676811872273816,
		"fossil_insure_asset": 881023569.4401535,
		"fossil_insure_count": 19,
		"fossil_insure_weight": 0.022591381364955657,
		"df_p_asset": 182619750.61728516,
		"df_p_count": 18,
		"df_p_weight": 0.004682771919018942,
		"df_c_asset": 3171999656.9184713,
		"df_c_count": 111,
		"df_c_weight": 0.08133704525576989,
		"df_f_asset": 1328035345.4971066,
		"df_f_count": 24,
		"df_f_weight": 0.03405374611638444,
		"df_all_asset": 4599142255.368206,
		"df_all_count": 144,
		"df_all_weight": 0.117932119238001,
		"equileap_count": 2218,
		"dei_asset": 20451408168.87195,
		"dei_count": 2846,
		"dei_weight": 0.5244190705215184,
		"rji_asset": 20451408168.87195,
		"rji_count": 2846,
		"rji_weight": 0.5244190705215184,
		"hrc_asset": 17134937098.383312,
		"hrc_count": 752,
		"hrc_weight": 0.4393774605826812,
		"wff_gun_manufacturers_asset": 25840967.506746486,
		"wff_gun_manufacturers_count": 7,
		"wff_gun_manufacturers_weight": 0.0006626192215893864,
		"wff_gun_retailers_asset": 155650192.27812082,
		"wff_gun_retailers_count": 5,
		"wff_gun_retailers_weight": 0.003991213147133136,
		"wff_civ_asset": 181491159.7848673,
		"wff_civ_count": 12,
		"wff_civ_weight": 0.004653832368722521,
		"wff_major_military_contractors_asset": 1276528965.464685,
		"wff_major_military_contractors_count": 123,
		"wff_major_military_contractors_weight": 0.032733009288900716,
		"wff_cluster_munitions_asset": 540751099.1908382,
		"wff_cluster_munitions_count": 21,
		"wff_cluster_munitions_weight": 0.013866047094633405,
		"wff_nuclear_weapons_asset": 738429887.6636773,
		"wff_nuclear_weapons_count": 41,
		"wff_nuclear_weapons_weight": 0.018934965853515333,
		"wff_mil_asset": 1276528965.464685,
		"wff_mil_count": 123,
		"wff_mil_weight": 0.032733009288900716,
		"wff_hi_asset": 872617259.0595825,
		"wff_hi_count": 47,
		"wff_hi_weight": 0.022375825084434874,
		"wff_all_asset": 1432602133.7934558,
		"wff_all_count": 129,
		"wff_all_weight": 0.03673506847194019,
		"t_asset": 225493167.93952292,
		"t_count": 9,
		"t_weight": 0.005782140601926083,
		"t_m_asset": 275647473.7154237,
		"t_m_count": 8,
		"t_m_weight": 0.0070682072727621115,
		"t_all_asset": 501140641.6549466,
		"t_all_count": 17,
		"t_all_weight": 0.012850347874688193,
		"ip_divest_asset": 840349360.7815655,
		"ip_divest_count": 31,
		"ip_divest_weight": 0.021548405227429793,
		"pp_divest_asset": 73353553.95388621,
		"pp_divest_count": 12,
		"pp_divest_weight": 0.0018809464006736343,
		"borders_divest_asset": 412534695.6687709,
		"borders_divest_count": 25,
		"borders_divest_weight": 0.010578296607945854,
		"pff_prisons_asset": 3335401092.491526,
		"pff_prisons_count": 44,
		"pff_prisons_weight": 0.08552701732309818,
		"pff_borders_asset": 3248059138.412948,
		"pff_borders_count": 55,
		"pff_borders_weight": 0.0832873775879167,
		"pff_high_asset": 422504727.5185594,
		"pff_high_count": 28,
		"pff_high_weight": 0.010833950144981706,
		"pff_extreme_asset": 7406846.4647714,
		"pff_extreme_count": 3,
		"pff_extreme_weight": 0.00018992782826872013,
		"pff_all_asset": 4132896100.4506865,
		"pff_all_count": 78,
		"pff_all_weight": 0.10597654272331232,
		"pff_prisons_high_asset": 73353553.95388621,
		"pff_prisons_high_count": 12,
		"pff_prisons_high_weight": 0.0018809464006736343,
		"pff_borders_high_asset": 412534695.6687709,
		"pff_borders_high_count": 25,
		"pff_borders_high_weight": 0.010578296607945854,
		"fund_family_label": "Thrift Savings Plan",
		"fund_legal_name": "L 2050",
		"category_group": "Allocation Funds",
		"portfolio_date": "2024-10-01",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 14.2619,
		"fossil_insure_score": 17.9391,
		"grade_gender_equality": 2,
		"gef_grp_norm": 64.62962962962962,
		"gef_percent_rated": 0.7926608061871798,
		"gef_score": 54.26254976837795,
		"strategy_name": "TSP Lifecycle Funds",
		"net_assets": 38800000000,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 205300000000,
		"ticker": "N",
		"investment_vehicle_name": "L 2050",
		"legal_type": "TSP",
		"prospectus_date": "",
		"investment_vehicle_id": "STSP0L2050",
		"tickers": "N",
		"strategy_fund_legal_names": "L 2025, L 2030, L 2035, L 2040, L 2045, L 2050, L 2055, L 2060, L 2065, L Income",
		"strategy_tickers": "",
		"strategy_name_query": "tsp-lifecycle-funds",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00408
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00202
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.002
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00198
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00198
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00104
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00082
					},
					{
						"standard_name": "Anglo American PLC",
						"long_weight": 0.00055
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00053
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00408
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00278
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00202
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.002
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00868
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00084
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00051
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00024
					},
					{
						"standard_name": "CLP Holdings Ltd",
						"long_weight": 0.00022
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00868
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00122
					},
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.00113
					},
					{
						"standard_name": "Enel SpA",
						"long_weight": 0.00113
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00104
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00868
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00408
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00278
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00202
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00285
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00234
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00231
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00207
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00868
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00255
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00165
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00146
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00134
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00104
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00097
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00053
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.0004
					},
					{
						"standard_name": "UPM-Kymmene Oyj",
						"long_weight": 0.00023
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00607
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00285
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00234
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00231
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01544
					},
					{
						"standard_name": "Nestle SA",
						"long_weight": 0.00446
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00392
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00374
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00338
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00059
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00005
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0.00001
					},
					{
						"standard_name": "National Presto Industries Inc",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Smith & Wesson Brands Inc",
						"long_weight": 0.00001
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00374
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00019
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00005
					},
					{
						"standard_name": "Sportsman's Warehouse Holdings Inc",
						"long_weight": 0
					},
					{
						"standard_name": "Big 5 Sporting Goods Corp",
						"long_weight": 0
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02608
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01544
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01497
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00868
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00392
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02608
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01544
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01497
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00228
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00216
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00159
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00149
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00089
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00065
					}
				]
			},
			"is_pff_extreme": {
				"count": 3,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00009
					},
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00007
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00004
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00192
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00152
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00149
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00137
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00152
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00149
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00122
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00118
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00192
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00152
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00149
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00137
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00237
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00138
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00089
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00059
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00052
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00259
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00177
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00146
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00114
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00006
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"Mitsubishi Corp"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"Palantir Technologies Inc"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA07X4H",
		"percent_rated": 0.8465941271731131,
		"percent_rated_long": 0.8516812198246797,
		"long_equity_assets": 28894642360.37863,
		"long_cbond_assets": 511799402.65950876,
		"long_equity_weight": 0.8493021297706937,
		"long_cbond_weight": 0.01504335361804401,
		"c2_asset": 755848348.3913463,
		"c2_count": 29,
		"c2_weight": 0.02221670038569807,
		"co_asset": 262947196.22637695,
		"co_count": 17,
		"co_weight": 0.007728824291610581,
		"og_asset": 1676379786.8095977,
		"og_count": 99,
		"og_weight": 0.049273941704647425,
		"mc50_asset": 21256941.153060436,
		"mc50_count": 4,
		"mc50_weight": 0.0006248066741417859,
		"ut_asset": 636677531.1463625,
		"ut_count": 46,
		"ut_weight": 0.018713904689861238,
		"ff_hi_asset": 774536550.157347,
		"ff_hi_count": 32,
		"ff_hi_weight": 0.022766003933514703,
		"ff_all_asset": 2068824917.4823682,
		"ff_all_count": 124,
		"ff_all_weight": 0.06080910732952331,
		"cl_asset": 5321186882.847912,
		"cl_count": 82,
		"cl_weight": 0.1564059972137821,
		"fossil_bank_asset": 794570464.4600717,
		"fossil_bank_count": 35,
		"fossil_bank_weight": 0.02335486209873218,
		"fossil_insure_asset": 260997257.90663865,
		"fossil_insure_count": 11,
		"fossil_insure_weight": 0.007671509625894348,
		"df_p_asset": 134655997.66154128,
		"df_p_count": 11,
		"df_p_weight": 0.003957952625749196,
		"df_c_asset": 2023471537.7994275,
		"df_c_count": 67,
		"df_c_weight": 0.05947603244745318,
		"df_f_asset": 699651915.224204,
		"df_f_count": 18,
		"df_f_weight": 0.020564914916990678,
		"df_all_asset": 2824538933.0772524,
		"df_all_count": 90,
		"df_all_weight": 0.08302185926246981,
		"equileap_count": 1155,
		"dei_asset": 20274874088.972965,
		"dei_count": 706,
		"dei_weight": 0.5959407121165611,
		"rji_asset": 20274874088.972965,
		"rji_count": 706,
		"rji_weight": 0.5959407121165611,
		"hrc_asset": 17418769431.304832,
		"hrc_count": 387,
		"hrc_weight": 0.5119910394280441,
		"wff_gun_manufacturers_asset": 90587879.8278305,
		"wff_gun_manufacturers_count": 1,
		"wff_gun_manufacturers_weight": 0.0026626555300330056,
		"wff_gun_retailers_asset": 1363890.3810114614,
		"wff_gun_retailers_count": 1,
		"wff_gun_retailers_weight": 0.00004008891997760716,
		"wff_civ_asset": 91951770.20884195,
		"wff_civ_count": 2,
		"wff_civ_weight": 0.0027027444500106125,
		"wff_major_military_contractors_asset": 2080478012.0968988,
		"wff_major_military_contractors_count": 69,
		"wff_major_military_contractors_weight": 0.06115162750856216,
		"wff_cluster_munitions_asset": 1126236540.6268628,
		"wff_cluster_munitions_count": 17,
		"wff_cluster_munitions_weight": 0.03310354496346287,
		"wff_nuclear_weapons_asset": 1513653103.580718,
		"wff_nuclear_weapons_count": 33,
		"wff_nuclear_weapons_weight": 0.044490905565521544,
		"wff_mil_asset": 2080478012.0968988,
		"wff_mil_count": 69,
		"wff_mil_weight": 0.06115162750856216,
		"wff_hi_asset": 1800819209.812946,
		"wff_hi_count": 37,
		"wff_hi_weight": 0.052931597877236065,
		"wff_all_asset": 2081841902.4779103,
		"wff_all_count": 70,
		"wff_all_weight": 0.06119171642853976,
		"t_asset": 852495786.0648137,
		"t_count": 8,
		"t_weight": 0.025057464899382143,
		"t_m_asset": 143307502.0640625,
		"t_m_count": 7,
		"t_m_weight": 0.004212246865599602,
		"t_all_asset": 995803288.1288762,
		"t_all_count": 15,
		"t_all_weight": 0.029269711764981745,
		"ip_divest_asset": 1335926141.5555985,
		"ip_divest_count": 25,
		"ip_divest_weight": 0.03926696524180988,
		"pp_divest_asset": 97139405.2454356,
		"pp_divest_count": 7,
		"pp_divest_weight": 0.002855224948993827,
		"borders_divest_asset": 698808724.0579203,
		"borders_divest_count": 14,
		"borders_divest_weight": 0.020540130943394574,
		"pff_prisons_asset": 2777519003.8739986,
		"pff_prisons_count": 27,
		"pff_prisons_weight": 0.0816397993803669,
		"pff_borders_asset": 3591015925.5865793,
		"pff_borders_count": 33,
		"pff_borders_weight": 0.10555096808615408,
		"pff_high_asset": 698911603.7454171,
		"pff_high_count": 15,
		"pff_high_weight": 0.020543154892838606,
		"pff_extreme_asset": 0,
		"pff_extreme_count": 0,
		"pff_extreme_weight": 0,
		"pff_all_asset": 3885143360.5379753,
		"pff_all_count": 47,
		"pff_all_weight": 0.1141962751923168,
		"pff_prisons_high_asset": 97139405.2454356,
		"pff_prisons_high_count": 7,
		"pff_prisons_high_weight": 0.002855224948993827,
		"pff_borders_high_asset": 698808724.0579203,
		"pff_borders_high_count": 14,
		"pff_borders_high_weight": 0.020540130943394574,
		"fund_family_label": "American Funds/Capital Group",
		"fund_legal_name": "American Funds 2050 Target Date Retirement Fund®",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 5,
		"fossil_bank_score": 8.6453,
		"fossil_insure_score": 6.2173,
		"grade_gender_equality": 2,
		"gef_grp_norm": 68.7037037037037,
		"gef_percent_rated": 0.7648608712128063,
		"gef_score": 54.381573872064784,
		"strategy_name": "Capital American Target Date Retirement Series",
		"net_assets": 33817197166,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 311053054829,
		"ticker": "RFITX",
		"investment_vehicle_name": "American Funds 2050 Trgt Date Retire R6",
		"legal_type": "FO",
		"prospectus_date": "2025-01-01",
		"investment_vehicle_id": "F000002Q7W",
		"tickers": "RFITX, AALTX, RCITX, RDITX, RBITX, RHITX, REITX, RBHEX, CCITX, FBITX, FAITX, DITFX, RAITX",
		"strategy_fund_legal_names": "American Funds 2010 Target Date Retirement Fund®, American Funds 2015 Target Date Retirement Fund®, American Funds 2020 Target Date Retirement Fund®, American Funds 2025 Target Date Retirement Fund®, American Funds 2030 Target Date Retirement Fund®, American Funds 2035 Target Date Retirement Fund®, American Funds 2040 Target Date Retirement Fund®, American Funds 2045 Target Date Retirement Fund®, American Funds 2050 Target Date Retirement Fund®, American Funds 2055 Target Date Retirement Fund®, American Funds 2060 Target Date Retirement Fund®, American Funds 2065 Target Date Retirement Fund, American Funds 2070 Target Date Retirement Fund",
		"strategy_tickers": "AAATX, CCATX, FAATX, FBATX, DJTFX, RAATX, RBATX, RBEAX, RCATX, RDATX, REATX, RHATX, RFTTX, AABTX, CCBTX, FAKTX, FBBTX, FDBTX, RAJTX, RBJTX, RBEJX, RCJTX, RDBTX, REJTX, RHBTX, RFJTX, AACTX, CCCTX, FAOTX, FBCTX, FCCTX, RACTX, RBCTX, RBEHX, RCCTX, RDCTX, RECTX, RHCTX, RRCTX, AADTX, CCDTX, FAPTX, FBDTX, FDDTX, RADTX, RBDTX, RBEDX, RCDTX, RDDTX, REDTX, RHDTX, RFDTX, AAETX, CCETX, FAETX, FBETX, FCETX, RAETX, RBETX, RBEEX, RCETX, RDETX, REETX, RHETX, RFETX, AAFTX, CCFTX, FAQTX, FBFTX, FDFTX, RAFTX, RBFTX, RBEFX, RCFTX, RDFTX, REFTX, RHFTX, RFFTX, AAGTX, CCGTX, FAUTX, FBGTX, FCGTX, RAKTX, RBKTX, RBEKX, RCKTX, RDGTX, REGTX, RHGTX, RFGTX, AAHTX, CCHTX, FATTX, FBHTX, FCHTX, RAHTX, RBHTX, RBHHX, RCHTX, RDHTX, REHTX, RHHTX, RFHTX, AALTX, CCITX, FAITX, FBITX, DITFX, RAITX, RBITX, RBHEX, RCITX, RDITX, REITX, RHITX, RFITX, AAMTX, CCJTX, FAJTX, FBJTX, FCJTX, RAMTX, RBMTX, RBEMX, RCMTX, RDJTX, REKTX, RHJTX, RFKTX, AANTX, CCKTX, FAWTX, FBKTX, FCKTX, RANTX, RBNTX, RBENX, RCNTX, RDKTX, REMTX, RHKTX, RFUTX, AAOTX, CCLTX, FAXTX, FBMTX, FCQTX, RAQTX, RBOTX, RBEOX, RCPTX, RDLTX, REOTX, RHLTX, RFVTX, AAFJX, CCGDX, FATSX, FBAJX, FCBEX, RAADX, RAABX, RBAHX, RCADX, RCAEX, REAGX, RAAJX, RFBFX",
		"strategy_name_query": "capital-american-target-date-retirement-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00358
					},
					{
						"standard_name": "Canadian Natural Resources Ltd",
						"long_weight": 0.00288
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00276
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00203
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00187
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "CenterPoint Energy Inc",
						"long_weight": 0.00208
					},
					{
						"standard_name": "Vale SA",
						"long_weight": 0.00111
					},
					{
						"standard_name": "FirstEnergy Corp",
						"long_weight": 0.00099
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00084
					},
					{
						"standard_name": "Grupo Mexico SAB de CV",
						"long_weight": 0.00068
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00358
					},
					{
						"standard_name": "Canadian Natural Resources Ltd",
						"long_weight": 0.00288
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00276
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00215
					},
					{
						"standard_name": "Blackstone Inc",
						"long_weight": 0.00209
					}
				]
			},
			"is_mc50": {
				"count": 4,
				"list": [
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00024
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0002
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00011
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00008
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Constellation Energy Corp",
						"long_weight": 0.00296
					},
					{
						"standard_name": "CenterPoint Energy Inc",
						"long_weight": 0.00208
					},
					{
						"standard_name": "Sempra",
						"long_weight": 0.00159
					},
					{
						"standard_name": "DTE Energy Co",
						"long_weight": 0.00154
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00106
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00358
					},
					{
						"standard_name": "Constellation Energy Corp",
						"long_weight": 0.00296
					},
					{
						"standard_name": "Canadian Natural Resources Ltd",
						"long_weight": 0.00288
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00276
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00215
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00237
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00216
					},
					{
						"standard_name": "Banco Bilbao Vizcaya Argentaria SA",
						"long_weight": 0.00212
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00199
					},
					{
						"standard_name": "Truist Financial Corp",
						"long_weight": 0.0019
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00378
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00102
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00089
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00063
					},
					{
						"standard_name": "American International Group Inc",
						"long_weight": 0.00048
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00166
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00084
					},
					{
						"standard_name": "JBS SA",
						"long_weight": 0.00036
					},
					{
						"standard_name": "Bunge Global SA",
						"long_weight": 0.00032
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00032
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00742
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00237
					},
					{
						"standard_name": "Banco Bilbao Vizcaya Argentaria SA",
						"long_weight": 0.00212
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Citigroup Inc",
						"long_weight": 0.00147
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01671
					},
					{
						"standard_name": "Starbucks Corp",
						"long_weight": 0.00435
					},
					{
						"standard_name": "The Home Depot Inc",
						"long_weight": 0.00405
					},
					{
						"standard_name": "Nestle SA",
						"long_weight": 0.00355
					},
					{
						"standard_name": "Mondelez International Inc",
						"long_weight": 0.0028
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00266
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00004
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03464
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01776
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01671
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00214
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00164
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03464
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01776
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01671
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00763
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.005
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00763
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00499
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00164
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00092
					}
				]
			},
			"is_pff_extreme": {
				"count": 0,
				"list": []
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00876
					},
					{
						"standard_name": "TransDigm Group Inc",
						"long_weight": 0.00774
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00763
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00499
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00418
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "TransDigm Group Inc",
						"long_weight": 0.00774
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00763
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00499
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.003
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00266
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00876
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00763
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00499
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00418
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00316
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.01616
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00539
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00162
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00124
					},
					{
						"standard_name": "ITC Ltd",
						"long_weight": 0.00056
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00262
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00063
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00044
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00035
					},
					{
						"standard_name": "Lions Gate Entertainment Corp",
						"long_weight": 0.00018
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"JBS SA",
				"Tyson Foods Inc",
				"International Paper Co"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"RTX Corp",
				"Airbus SE",
				"Northrop Grumman Corp"
			],
			"gff": [
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA0A7L8",
		"percent_rated": 0.8660814642606034,
		"percent_rated_long": 0.8753807448066475,
		"long_equity_assets": 17867140381.66394,
		"long_cbond_assets": 218292700.78195915,
		"long_equity_weight": 0.8755630928446809,
		"long_cbond_weight": 0.010697236835851796,
		"c2_asset": 654627289.3487473,
		"c2_count": 117,
		"c2_weight": 0.03207941964294013,
		"co_asset": 277879447.07180345,
		"co_count": 114,
		"co_weight": 0.01361723157253773,
		"og_asset": 1316352503.9547853,
		"og_count": 329,
		"og_weight": 0.06450666670864073,
		"mc50_asset": 256138837.05033895,
		"mc50_count": 28,
		"mc50_weight": 0.012551852595034515,
		"ut_asset": 683806828.3497679,
		"ut_count": 174,
		"ut_weight": 0.03350933662292505,
		"ff_hi_asset": 894790001.346777,
		"ff_hi_count": 134,
		"ff_hi_weight": 0.04384837664507783,
		"ff_all_asset": 1773103488.1035526,
		"ff_all_count": 454,
		"ff_all_weight": 0.0868893365594668,
		"cl_asset": 3238741487.8148293,
		"cl_count": 173,
		"cl_weight": 0.15871160428703412,
		"fossil_bank_asset": 941412300.903168,
		"fossil_bank_count": 65,
		"fossil_bank_weight": 0.04613306036743874,
		"fossil_insure_asset": 444547314.920081,
		"fossil_insure_count": 24,
		"fossil_insure_weight": 0.021784640051670995,
		"df_p_asset": 103885621.66312777,
		"df_p_count": 46,
		"df_p_weight": 0.005090821153384238,
		"df_c_asset": 1661088996.6958954,
		"df_c_count": 132,
		"df_c_weight": 0.08140016747894836,
		"df_f_asset": 678322603.498142,
		"df_f_count": 36,
		"df_f_weight": 0.033240587132498875,
		"df_all_asset": 2402894868.823917,
		"df_all_count": 200,
		"df_all_weight": 0.11775169490956619,
		"equileap_count": 2339,
		"dei_asset": 10576978777.08946,
		"dei_count": 2851,
		"dei_weight": 0.5183153013408267,
		"rji_asset": 10576978777.08946,
		"rji_count": 2851,
		"rji_weight": 0.5183153013408267,
		"hrc_asset": 9423322706.62149,
		"hrc_count": 770,
		"hrc_weight": 0.46178142655386945,
		"wff_gun_manufacturers_asset": 14521660.802333267,
		"wff_gun_manufacturers_count": 7,
		"wff_gun_manufacturers_weight": 0.0007116208846929198,
		"wff_gun_retailers_asset": 77386220.87799768,
		"wff_gun_retailers_count": 5,
		"wff_gun_retailers_weight": 0.0037922419283746176,
		"wff_civ_asset": 91907881.68033095,
		"wff_civ_count": 12,
		"wff_civ_weight": 0.004503862813067538,
		"wff_major_military_contractors_asset": 669123705.823533,
		"wff_major_military_contractors_count": 158,
		"wff_major_military_contractors_weight": 0.032789803452139596,
		"wff_cluster_munitions_asset": 267721713.4084022,
		"wff_cluster_munitions_count": 24,
		"wff_cluster_munitions_weight": 0.013119460999707436,
		"wff_nuclear_weapons_asset": 410686352.1089254,
		"wff_nuclear_weapons_count": 58,
		"wff_nuclear_weapons_weight": 0.020125314121929066,
		"wff_mil_asset": 669123705.823533,
		"wff_mil_count": 158,
		"wff_mil_weight": 0.032789803452139596,
		"wff_hi_asset": 468047734.7471149,
		"wff_hi_count": 66,
		"wff_hi_weight": 0.02293625692081601,
		"wff_all_asset": 746639071.1232414,
		"wff_all_count": 164,
		"wff_all_weight": 0.03658837398637286,
		"t_asset": 114152021.86835846,
		"t_count": 13,
		"t_weight": 0.0055939168320468325,
		"t_m_asset": 145794633.324105,
		"t_m_count": 9,
		"t_m_weight": 0.007144534455240087,
		"t_all_asset": 259946655.19246343,
		"t_all_count": 22,
		"t_all_weight": 0.012738451287286918,
		"ip_divest_asset": 444944226.53894335,
		"ip_divest_count": 32,
		"ip_divest_weight": 0.021804090347419147,
		"pp_divest_asset": 36541300.855901025,
		"pp_divest_count": 13,
		"pp_divest_weight": 0.001790673477149963,
		"borders_divest_asset": 210186607.60857892,
		"borders_divest_count": 26,
		"borders_divest_weight": 0.010300005054035407,
		"pff_prisons_asset": 1827569842.2759266,
		"pff_prisons_count": 47,
		"pff_prisons_weight": 0.0895584111005768,
		"pff_borders_asset": 1742468012.119045,
		"pff_borders_count": 56,
		"pff_borders_weight": 0.08538807270130114,
		"pff_high_asset": 214402291.223959,
		"pff_high_count": 30,
		"pff_high_weight": 0.010506590825786817,
		"pff_extreme_asset": 2680644.5389486384,
		"pff_extreme_count": 3,
		"pff_extreme_weight": 0.0001313625668799102,
		"pff_all_asset": 2237618842.416873,
		"pff_all_count": 82,
		"pff_all_weight": 0.1096524923643991,
		"pff_prisons_high_asset": 36541300.855901025,
		"pff_prisons_high_count": 13,
		"pff_prisons_high_weight": 0.001790673477149963,
		"pff_borders_high_asset": 210186607.60857892,
		"pff_borders_high_count": 26,
		"pff_borders_high_weight": 0.010300005054035407,
		"fund_family_label": "Fidelity Investments",
		"fund_legal_name": "Fidelity Freedom Index 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 17.2083,
		"fossil_insure_score": 18.0427,
		"grade_gender_equality": 2,
		"gef_grp_norm": 72.96296296296296,
		"gef_percent_rated": 0.764246783601945,
		"gef_score": 54.580624973095496,
		"strategy_name": "Fidelity Freedom Index Series",
		"net_assets": 20187348758,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 162081913659,
		"ticker": "FFOPX",
		"investment_vehicle_name": "Fidelity Freedom Index 2050 Instl Prem",
		"legal_type": "FO",
		"prospectus_date": "2024-05-30",
		"investment_vehicle_id": "F00000VQAG",
		"tickers": "FFOPX, FRLPX, FAVQX, FIPFX",
		"strategy_fund_legal_names": "Fidelity Freedom Index 2010 Fund, Fidelity Freedom Index 2015 Fund, Fidelity Freedom Index 2020 Fund, Fidelity Freedom Index 2025 Fund, Fidelity Freedom Index 2030 Fund, Fidelity Freedom Index 2035 Fund, Fidelity Freedom Index 2040 Fund, Fidelity Freedom Index 2045 Fund, Fidelity Freedom Index 2050 Fund, Fidelity Freedom Index 2055 Fund, Fidelity Freedom Index 2060 Fund, Fidelity Freedom Index 2065 Fund, Fidelity Freedom Index 2070 Fund, Fidelity Freedom Index Income Fund",
		"strategy_tickers": "FFWTX, FKIFX, FCYPX, FATUX, FIWFX, FLIFX, FFYPX, FATVX, FIWTX, FPIFX, FKIPX, FATYX, FFEDX, FQIFX, FLIPX, FATZX, FFEGX, FXIFX, FMKPX, FAUYX, FFEZX, FIHFX, FNIPX, FAVNX, FFIZX, FBIFX, FPIPX, FAVOX, FFOLX, FIOFX, FQIPX, FAVPX, FFOPX, FIPFX, FRLPX, FAVQX, FFLDX, FDEWX, FTYPX, FAVRX, FFLEX, FDKLX, FUIPX, FAVUX, FFIKX, FFIJX, FVIPX, FAVVX, FRBUX, FRBVX, FRBWX, FAVWX, FFGZX, FIKFX, FAPIX, FATQX",
		"strategy_name_query": "fidelity-freedom-index-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00496
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00294
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00268
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00184
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00163
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00163
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.0008
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00063
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00056
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00054
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00496
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00294
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00268
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00232
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00184
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00935
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00091
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00056
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00026
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00024
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00935
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.0014
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00097
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00091
					},
					{
						"standard_name": "Enel SpA",
						"long_weight": 0.00087
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00935
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00496
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00294
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00268
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00232
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00268
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00265
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00226
					},
					{
						"standard_name": "Royal Bank of Canada",
						"long_weight": 0.00211
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00211
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00935
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00196
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00135
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00112
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00108
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.0008
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00073
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.0005
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.0003
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00027
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00657
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00268
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00265
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00211
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00207
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0172
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00402
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00383
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00383
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00365
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00067
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0.00001
					},
					{
						"standard_name": "National Presto Industries Inc",
						"long_weight": 0
					},
					{
						"standard_name": "Smith & Wesson Brands Inc",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00365
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00011
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Sportsman's Warehouse Holdings Inc",
						"long_weight": 0
					},
					{
						"standard_name": "Big 5 Sporting Goods Corp",
						"long_weight": 0
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02674
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0172
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01572
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00935
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00402
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02674
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0172
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01572
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00268
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00246
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00169
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00166
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.0009
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.0007
					}
				]
			},
			"is_pff_extreme": {
				"count": 3,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00007
					},
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00004
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00002
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00206
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00169
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.00151
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00132
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00169
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00132
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00126
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.0009
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00206
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00169
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00132
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00126
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00237
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00108
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00098
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00044
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00039
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00206
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00195
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00171
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00133
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00007
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"JBS SA",
				"Tyson Foods Inc"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"RTX Corp"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA0720M",
		"percent_rated": 0.7876332592376574,
		"percent_rated_long": 0.8366545404222183,
		"long_equity_assets": 16155296868.135454,
		"long_cbond_assets": 134025829.67874938,
		"long_equity_weight": 0.8358770207713971,
		"long_cbond_weight": 0.006934512694672472,
		"c2_asset": 689943782.3149228,
		"c2_count": 69,
		"c2_weight": 0.03569777503740215,
		"co_asset": 187706202.1172535,
		"co_count": 52,
		"co_weight": 0.009711941679979288,
		"og_asset": 1148202449.892929,
		"og_count": 198,
		"og_weight": 0.05940813411803866,
		"mc50_asset": 171587985.23424318,
		"mc50_count": 11,
		"mc50_weight": 0.008877983182138768,
		"ut_asset": 402546252.9974744,
		"ut_count": 86,
		"ut_weight": 0.020827791988266467,
		"ff_hi_asset": 847633495.8553392,
		"ff_hi_count": 77,
		"ff_hi_weight": 0.04385665995522978,
		"ff_all_asset": 1523192887.4714525,
		"ff_all_count": 271,
		"ff_all_weight": 0.07881018487200135,
		"cl_asset": 2078388217.0139654,
		"cl_count": 96,
		"cl_weight": 0.10753605860815824,
		"fossil_bank_asset": 971616340.9910673,
		"fossil_bank_count": 29,
		"fossil_bank_weight": 0.0502715474107009,
		"fossil_insure_asset": 536238389.29678446,
		"fossil_insure_count": 18,
		"fossil_insure_weight": 0.02774503934698544,
		"df_p_asset": 66060926.71331248,
		"df_p_count": 20,
		"df_p_weight": 0.0034180003661482858,
		"df_c_asset": 1177480488.8841615,
		"df_c_count": 85,
		"df_c_weight": 0.060922983409003414,
		"df_f_asset": 468100742.0065531,
		"df_f_count": 19,
		"df_f_weight": 0.024219589206129922,
		"df_all_asset": 1696746291.1459222,
		"df_all_count": 117,
		"df_all_weight": 0.08778985904278584,
		"equileap_count": 2533,
		"dei_asset": 8892620234.85755,
		"dei_count": 1417,
		"dei_weight": 0.46010525027399624,
		"rji_asset": 8892620234.85755,
		"rji_count": 1417,
		"rji_weight": 0.46010525027399624,
		"hrc_asset": 7824678348.490335,
		"hrc_count": 628,
		"hrc_weight": 0.4048498074542296,
		"wff_gun_manufacturers_asset": 25667034.26090002,
		"wff_gun_manufacturers_count": 4,
		"wff_gun_manufacturers_weight": 0.0013280154679395028,
		"wff_gun_retailers_asset": 59522359.411959976,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.0030796941003719026,
		"wff_civ_asset": 85189393.67286,
		"wff_civ_count": 7,
		"wff_civ_weight": 0.004407709568311405,
		"wff_major_military_contractors_asset": 1063342434.4122367,
		"wff_major_military_contractors_count": 109,
		"wff_major_military_contractors_weight": 0.05501746661736757,
		"wff_cluster_munitions_asset": 485520167.3933067,
		"wff_cluster_munitions_count": 20,
		"wff_cluster_munitions_weight": 0.025120872389885474,
		"wff_nuclear_weapons_asset": 706182059.4040269,
		"wff_nuclear_weapons_count": 45,
		"wff_nuclear_weapons_weight": 0.03653794546487801,
		"wff_mil_asset": 1063342434.4122367,
		"wff_mil_count": 109,
		"wff_mil_weight": 0.05501746661736757,
		"wff_hi_asset": 865106110.3958588,
		"wff_hi_count": 48,
		"wff_hi_weight": 0.044760695152256905,
		"wff_all_asset": 1122869040.2689202,
		"wff_all_count": 114,
		"wff_all_weight": 0.058097380429304867,
		"t_asset": 79346188.1087232,
		"t_count": 7,
		"t_weight": 0.004105381403216583,
		"t_m_asset": 117239822.14709263,
		"t_m_count": 6,
		"t_m_weight": 0.006066002627619345,
		"t_all_asset": 196586010.25581583,
		"t_all_count": 13,
		"t_all_weight": 0.01017138403083593,
		"ip_divest_asset": 468977354.12007916,
		"ip_divest_count": 45,
		"ip_divest_weight": 0.02426494522328065,
		"pp_divest_asset": 7223482.335597964,
		"pp_divest_count": 10,
		"pp_divest_weight": 0.000373743852778318,
		"borders_divest_asset": 128855147.27153273,
		"borders_divest_count": 23,
		"borders_divest_weight": 0.006666980959342736,
		"pff_prisons_asset": 1269698083.6844828,
		"pff_prisons_count": 39,
		"pff_prisons_weight": 0.06569433295668231,
		"pff_borders_asset": 1251702999.0572066,
		"pff_borders_count": 44,
		"pff_borders_weight": 0.06476326509395273,
		"pff_high_asset": 128859145.85739027,
		"pff_high_count": 25,
		"pff_high_weight": 0.006667187846660324,
		"pff_extreme_asset": 3998.5858575498614,
		"pff_extreme_count": 2,
		"pff_extreme_weight": 2.0688731758930354e-7,
		"pff_all_asset": 1547944232.2516994,
		"pff_all_count": 64,
		"pff_all_weight": 0.08009082245507204,
		"pff_prisons_high_asset": 7223482.335597964,
		"pff_prisons_high_count": 10,
		"pff_prisons_high_weight": 0.000373743852778318,
		"pff_borders_high_asset": 128855147.27153273,
		"pff_borders_high_count": 23,
		"pff_borders_high_weight": 0.006666980959342736,
		"fund_family_label": "Fidelity Investments",
		"fund_legal_name": "Fidelity Freedom 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"fossil_bank_score": 21.8961,
		"fossil_insure_score": 22.8964,
		"grade_gender_equality": 3,
		"gef_grp_norm": 59.62962962962963,
		"gef_percent_rated": 0.6990430869734048,
		"gef_score": 54.18842332716476,
		"strategy_name": "Fidelity Freedom Series",
		"net_assets": 18124450834,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 184172075730,
		"ticker": "FZTKX",
		"investment_vehicle_name": "Fidelity Freedom 2050 K6",
		"legal_type": "FO",
		"prospectus_date": "2024-05-30",
		"investment_vehicle_id": "F00000YHGH",
		"tickers": "FZTKX, FNSBX, FFFHX",
		"strategy_fund_legal_names": "Fidelity Freedom 2010 Fund, Fidelity Freedom 2015 Fund, Fidelity Freedom 2020 Fund, Fidelity Freedom 2025 Fund, Fidelity Freedom 2030 Fund, Fidelity Freedom 2035 Fund, Fidelity Freedom 2040 Fund, Fidelity Freedom 2045 Fund, Fidelity Freedom 2050 Fund, Fidelity Freedom 2055 Fund, Fidelity Freedom 2060 Fund, Fidelity Freedom 2065 Fund, Fidelity Freedom 2070 Fund, Fidelity Freedom Income Fund",
		"strategy_tickers": "FFFCX, FSNKX, FOTKX, FFVFX, FSNLX, FPTKX, FFFDX, FSNOX, FATKX, FFTWX, FSNPX, FDTKX, FFFEX, FSNQX, FGTKX, FFTHX, FSNUX, FWTKX, FFFFX, FSNVX, FHTKX, FFFGX, FSNZX, FJTKX, FFFHX, FNSBX, FZTKX, FDEEX, FNSDX, FCTKX, FDKVX, FNSFX, FVTKX, FFSFX, FFSDX, FFSZX, FRBDX, FRBEX, FRBHX, FFFAX, FNSHX, FYTKX",
		"strategy_name_query": "fidelity-freedom-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00981
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00673
					},
					{
						"standard_name": "Imperial Oil Ltd",
						"long_weight": 0.00226
					},
					{
						"standard_name": "Canadian Natural Resources Ltd",
						"long_weight": 0.00162
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.0014
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Vale SA",
						"long_weight": 0.00129
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00123
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.0008
					},
					{
						"standard_name": "Anglo American PLC",
						"long_weight": 0.00074
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.0007
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00981
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00673
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00468
					},
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.00274
					},
					{
						"standard_name": "Imperial Oil Ltd",
						"long_weight": 0.00226
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00739
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.0007
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00044
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00018
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00006
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00739
					},
					{
						"standard_name": "PG&E Corp",
						"long_weight": 0.00152
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00114
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00075
					},
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.00073
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00981
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00739
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00673
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00468
					},
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.00274
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.0095
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00594
					},
					{
						"standard_name": "Banco Santander SA",
						"long_weight": 0.00317
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00298
					},
					{
						"standard_name": "China Construction Bank Corp",
						"long_weight": 0.00263
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00739
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00365
					},
					{
						"standard_name": "Tokio Marine Holdings Inc",
						"long_weight": 0.00265
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.00251
					},
					{
						"standard_name": "Hannover Rueck SE",
						"long_weight": 0.00218
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.0008
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00075
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00054
					},
					{
						"standard_name": "Sumitomo Forestry Co Ltd",
						"long_weight": 0.00027
					},
					{
						"standard_name": "Tyson Foods Inc",
						"long_weight": 0.00025
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00594
					},
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00561
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00189
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.0018
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00134
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01416
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00673
					},
					{
						"standard_name": "Compass Group PLC",
						"long_weight": 0.00356
					},
					{
						"standard_name": "Lvmh Moet Hennessy Louis Vuitton SE",
						"long_weight": 0.00353
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00318
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 4,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00118
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00015
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00199
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00039
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01788
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01442
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01416
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00739
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00199
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01788
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01442
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01416
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00318
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00189
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00189
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00118
					},
					{
						"standard_name": "Thomson Reuters Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00064
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00058
					}
				]
			},
			"is_pff_extreme": {
				"count": 2,
				"list": [
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00707
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.0056
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00479
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00413
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.0056
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00479
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00413
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00236
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00189
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00707
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00479
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00413
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00254
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00221
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00118
					},
					{
						"standard_name": "ITC Ltd",
						"long_weight": 0.00039
					},
					{
						"standard_name": "KT&G Corp",
						"long_weight": 0.00014
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00012
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00322
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.0018
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00066
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00037
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00001
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"Glencore PLC"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"Airbus SE",
				"Northrop Grumman Corp",
				"Thomson Reuters Corp"
			],
			"gff": [
				"Northrop Grumman Corp",
				"Olin Corp",
				"NOF Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA07VNR",
		"percent_rated": 0.9368802336462349,
		"percent_rated_long": 0.9417463009984617,
		"long_equity_assets": 15153687050.288485,
		"long_cbond_assets": 28900265.7352145,
		"long_equity_weight": 0.9570665583847169,
		"long_cbond_weight": 0.001825263895962464,
		"c2_asset": 635345591.4069823,
		"c2_count": 41,
		"c2_weight": 0.040126737244531335,
		"co_asset": 229123403.3292512,
		"co_count": 31,
		"co_weight": 0.014470824581635082,
		"og_asset": 1263085428.8162382,
		"og_count": 112,
		"og_weight": 0.07977311530133704,
		"mc50_asset": 157988010.98924354,
		"mc50_count": 8,
		"mc50_weight": 0.00997810245399278,
		"ut_asset": 544110917.0967097,
		"ut_count": 57,
		"ut_weight": 0.03436459794089428,
		"ff_hi_asset": 779183065.4602156,
		"ff_hi_count": 48,
		"ff_hi_weight": 0.04921112943252087,
		"ff_all_asset": 1649166838.7475817,
		"ff_all_count": 153,
		"ff_all_weight": 0.10415699000015337,
		"cl_asset": 2268957788.9258795,
		"cl_count": 74,
		"cl_weight": 0.14330133748711327,
		"fossil_bank_asset": 390618899.2143664,
		"fossil_bank_count": 22,
		"fossil_bank_weight": 0.024670450450143298,
		"fossil_insure_asset": 304493903.3102581,
		"fossil_insure_count": 14,
		"fossil_insure_weight": 0.019231024840567074,
		"df_p_asset": 114229573.80348939,
		"df_p_count": 15,
		"df_p_weight": 0.0072144359787196044,
		"df_c_asset": 1146464774.7133946,
		"df_c_count": 73,
		"df_c_weight": 0.0724076650522732,
		"df_f_asset": 427957044.15781784,
		"df_f_count": 18,
		"df_f_weight": 0.027028628348295055,
		"df_all_asset": 1670399168.692682,
		"df_all_count": 98,
		"df_all_weight": 0.1054979674718149,
		"equileap_count": 1205,
		"dei_asset": 9816924392.247503,
		"dei_count": 988,
		"dei_weight": 0.6200108271229233,
		"rji_asset": 9816924392.247503,
		"rji_count": 988,
		"rji_weight": 0.6200108271229233,
		"hrc_asset": 8078033650.66516,
		"hrc_count": 492,
		"hrc_weight": 0.5101871141261858,
		"wff_gun_manufacturers_asset": 19591849.28547578,
		"wff_gun_manufacturers_count": 1,
		"wff_gun_manufacturers_weight": 0.0012373690776255944,
		"wff_gun_retailers_asset": 47487183.098661736,
		"wff_gun_retailers_count": 1,
		"wff_gun_retailers_weight": 0.0029991641469694907,
		"wff_civ_asset": 67079032.38413751,
		"wff_civ_count": 2,
		"wff_civ_weight": 0.004236533224595085,
		"wff_major_military_contractors_asset": 725262806.6729565,
		"wff_major_military_contractors_count": 58,
		"wff_major_military_contractors_weight": 0.04580566933997178,
		"wff_cluster_munitions_asset": 161035817.77273238,
		"wff_cluster_munitions_count": 15,
		"wff_cluster_munitions_weight": 0.010170593821883324,
		"wff_nuclear_weapons_asset": 366673970.6874962,
		"wff_nuclear_weapons_count": 31,
		"wff_nuclear_weapons_weight": 0.023158152468805256,
		"wff_mil_asset": 725262806.6729565,
		"wff_mil_count": 58,
		"wff_mil_weight": 0.04580566933997178,
		"wff_hi_asset": 373509529.34045964,
		"wff_hi_count": 33,
		"wff_hi_weight": 0.023589868167626163,
		"wff_all_asset": 772749989.7716182,
		"wff_all_count": 59,
		"wff_all_weight": 0.04880483348694128,
		"t_asset": 36682233.2605629,
		"t_count": 4,
		"t_weight": 0.002316752261284423,
		"t_m_asset": 60178916.49040244,
		"t_m_count": 5,
		"t_m_weight": 0.0038007402621987162,
		"t_all_asset": 96861149.75096534,
		"t_all_count": 9,
		"t_all_weight": 0.006117492523483139,
		"ip_divest_asset": 328951085.8909389,
		"ip_divest_count": 20,
		"ip_divest_weight": 0.020775675425114628,
		"pp_divest_asset": 7212824.00028918,
		"pp_divest_count": 5,
		"pp_divest_weight": 0.0004555427744602944,
		"borders_divest_asset": 143369497.7683922,
		"borders_divest_count": 16,
		"borders_divest_weight": 0.009054836050869104,
		"pff_prisons_asset": 1343794409.8142798,
		"pff_prisons_count": 28,
		"pff_prisons_weight": 0.08487047981851326,
		"pff_borders_asset": 1344909079.6361458,
		"pff_borders_count": 34,
		"pff_borders_weight": 0.08494087939893274,
		"pff_high_asset": 143369497.7683922,
		"pff_high_count": 16,
		"pff_high_weight": 0.009054836050869104,
		"pff_extreme_asset": 0,
		"pff_extreme_count": 0,
		"pff_extreme_weight": 0,
		"pff_all_asset": 1676194051.1365397,
		"pff_all_count": 48,
		"pff_all_weight": 0.10586395682994153,
		"pff_prisons_high_asset": 7212824.00028918,
		"pff_prisons_high_count": 5,
		"pff_prisons_high_weight": 0.0004555427744602944,
		"pff_borders_high_asset": 143369497.7683922,
		"pff_borders_high_count": 16,
		"pff_borders_high_weight": 0.009054836050869104,
		"fund_family_label": "T. Rowe Price",
		"fund_legal_name": "T. Rowe Price Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 3,
		"grade_military": 5,
		"grade_tobacco": 3,
		"fossil_bank_score": 9.7696,
		"fossil_insure_score": 15.9607,
		"grade_gender_equality": 4,
		"gef_grp_norm": 28.14814814814815,
		"gef_percent_rated": 0.8463041071011487,
		"gef_score": 53.4694530318983,
		"strategy_name": "T. Rowe Price Retirement Series",
		"net_assets": 15751234959,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 166873081237,
		"ticker": "TRJLX",
		"investment_vehicle_name": "T. Rowe Price Retirement 2050 I",
		"legal_type": "FO",
		"prospectus_date": "2024-08-01",
		"investment_vehicle_id": "F00001GGK0",
		"tickers": "TRJLX, TRRMX, PARFX, RRTFX",
		"strategy_fund_legal_names": "T. Rowe Price Retirement 2005 Fund, T. Rowe Price Retirement 2010 Fund, T. Rowe Price Retirement 2015 Fund, T. Rowe Price Retirement 2020 Fund, T. Rowe Price Retirement 2025 Fund, T. Rowe Price Retirement 2030 Fund, T. Rowe Price Retirement 2035 Fund, T. Rowe Price Retirement 2040 Fund, T. Rowe Price Retirement 2045 Fund, T. Rowe Price Retirement 2050 Fund, T. Rowe Price Retirement 2055 Fund, T. Rowe Price Retirement 2060 Fund, T. Rowe Price Retirement 2065 Fund, T. Rowe Price Retirement Income 2025 Fund",
		"strategy_tickers": "TRRFX, PARGX, TRAJX, RRTLX, TRRAX, PARAX, TRPUX, RRTAX, TRRGX, PARHX, TRUBX, RRTMX, TRRBX, PARBX, TRDBX, RRTBX, TRRHX, PARJX, TREHX, RRTNX, TRRCX, PARCX, TRFHX, RRTCX, TRRJX, PARKX, TRFJX, RRTPX, TRRDX, PARDX, TRHDX, RRTDX, TRRKX, PARLX, TRIKX, RRTRX, TRRMX, PARFX, TRJLX, RRTFX, TRRNX, PAROX, TRJMX, RRTVX, TRRLX, TRRYX, TRLNX, TRRZX, TRSJX, PASUX, TRMOX, RRSUX, TRATX, TRAVX",
		"strategy_name_query": "t-rowe-price-retirement-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00438
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00348
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00275
					},
					{
						"standard_name": "EQT Corp",
						"long_weight": 0.00275
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Ameren Corp",
						"long_weight": 0.00322
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00148
					},
					{
						"standard_name": "Grupo Mexico SAB de CV",
						"long_weight": 0.00109
					},
					{
						"standard_name": "Sumitomo Corp",
						"long_weight": 0.00096
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00089
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00454
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00438
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00348
					},
					{
						"standard_name": "Schlumberger Ltd",
						"long_weight": 0.00342
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00829
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00089
					},
					{
						"standard_name": "Electric Power Development Co Ltd",
						"long_weight": 0.00028
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.0002
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00012
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00829
					},
					{
						"standard_name": "Ameren Corp",
						"long_weight": 0.00322
					},
					{
						"standard_name": "Xcel Energy Inc",
						"long_weight": 0.00245
					},
					{
						"standard_name": "Atmos Energy Corp",
						"long_weight": 0.00194
					},
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.00165
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00829
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00454
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00438
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00348
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "ING Groep NV",
						"long_weight": 0.00304
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00255
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00237
					},
					{
						"standard_name": "The Goldman Sachs Group Inc",
						"long_weight": 0.00229
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00224
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00829
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00243
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.00166
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00151
					},
					{
						"standard_name": "Tokio Marine Holdings Inc",
						"long_weight": 0.00113
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00398
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00067
					},
					{
						"standard_name": "Klabin SA",
						"long_weight": 0.00047
					},
					{
						"standard_name": "Stora Enso Oyj",
						"long_weight": 0.00044
					},
					{
						"standard_name": "Wilmar International Ltd",
						"long_weight": 0.00042
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00878
					},
					{
						"standard_name": "ING Groep NV",
						"long_weight": 0.00304
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00255
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00224
					},
					{
						"standard_name": "United Overseas Bank Ltd",
						"long_weight": 0.00141
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01943
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00473
					},
					{
						"standard_name": "McDonald's Corp",
						"long_weight": 0.00421
					},
					{
						"standard_name": "Unilever PLC",
						"long_weight": 0.00357
					},
					{
						"standard_name": "Colgate-Palmolive Co",
						"long_weight": 0.00325
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00124
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.003
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02739
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01943
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01478
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00829
					},
					{
						"standard_name": "McDonald's Corp",
						"long_weight": 0.00421
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02739
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01943
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01478
					},
					{
						"standard_name": "Thermo Fisher Scientific Inc",
						"long_weight": 0.00326
					},
					{
						"standard_name": "Accenture PLC",
						"long_weight": 0.0027
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Teledyne Technologies Inc",
						"long_weight": 0.00185
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00179
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00124
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00107
					},
					{
						"standard_name": "Booz Allen Hamilton Holding Corp",
						"long_weight": 0.0008
					}
				]
			},
			"is_pff_extreme": {
				"count": 0,
				"list": []
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "Keysight Technologies Inc",
						"long_weight": 0.00524
					},
					{
						"standard_name": "AMETEK Inc",
						"long_weight": 0.00385
					},
					{
						"standard_name": "Parker Hannifin Corp",
						"long_weight": 0.00321
					},
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00309
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00215
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00192
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00179
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00124
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00107
					},
					{
						"standard_name": "Thales",
						"long_weight": 0.001
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00309
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00215
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.0021
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00192
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00179
					}
				]
			},
			"is_t": {
				"count": 4,
				"list": [
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00119
					},
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00052
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00039
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00022
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00218
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00079
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00043
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00038
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00002
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"International Paper Co"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"Teledyne Technologies Inc",
				"L3Harris Technologies Inc",
				"Northrop Grumman Corp"
			],
			"gff": [
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA0BDPU",
		"percent_rated": 0.9152459390435352,
		"percent_rated_long": 0.9234949141348402,
		"long_equity_assets": 8743828480.941835,
		"long_cbond_assets": 318089750.8237816,
		"long_equity_weight": 0.9232771280135238,
		"long_cbond_weight": 0.03358768898900959,
		"c2_asset": 268853066.17642957,
		"c2_count": 138,
		"c2_weight": 0.028388695791327585,
		"co_asset": 117185847.55818777,
		"co_count": 136,
		"co_weight": 0.012373871812922394,
		"og_asset": 580071482.0975478,
		"og_count": 396,
		"og_weight": 0.06125082773534504,
		"mc50_asset": 128624321.79327755,
		"mc50_count": 28,
		"mc50_weight": 0.013581681602838678,
		"ut_asset": 330406982.2707943,
		"ut_count": 221,
		"ut_weight": 0.03488828838894781,
		"ff_hi_asset": 391529775.58069265,
		"ff_hi_count": 155,
		"ff_hi_weight": 0.04134235792911891,
		"ff_all_asset": 803034392.9449382,
		"ff_all_count": 565,
		"ff_all_weight": 0.08479389659006946,
		"cl_asset": 1533153040.9763846,
		"cl_count": 185,
		"cl_weight": 0.16188848392476754,
		"fossil_bank_asset": 366247603.4529195,
		"fossil_bank_count": 63,
		"fossil_bank_weight": 0.03867276630538664,
		"fossil_insure_asset": 200727607.40032658,
		"fossil_insure_count": 25,
		"fossil_insure_weight": 0.02119520176745705,
		"df_p_asset": 42825425.44528615,
		"df_p_count": 66,
		"df_p_weight": 0.004522016402456019,
		"df_c_asset": 771717465.5170903,
		"df_c_count": 149,
		"df_c_weight": 0.08148708391907378,
		"df_f_asset": 275408495.27629876,
		"df_f_count": 36,
		"df_f_weight": 0.02908089575446908,
		"df_all_asset": 1072534147.1671933,
		"df_all_count": 233,
		"df_all_weight": 0.11325087737611896,
		"equileap_count": 3323,
		"dei_asset": 5757813157.480068,
		"dei_count": 2924,
		"dei_weight": 0.6079782108333467,
		"rji_asset": 5757813157.480068,
		"rji_count": 2924,
		"rji_weight": 0.6079782108333467,
		"hrc_asset": 4777951462.4650135,
		"hrc_count": 751,
		"hrc_weight": 0.5045127902117249,
		"wff_gun_manufacturers_asset": 8053234.431375549,
		"wff_gun_manufacturers_count": 10,
		"wff_gun_manufacturers_weight": 0.0008503560166151778,
		"wff_gun_retailers_asset": 39986350.631975636,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.004222233207307329,
		"wff_civ_asset": 48039585.063351184,
		"wff_civ_count": 13,
		"wff_civ_weight": 0.005072589223922507,
		"wff_major_military_contractors_asset": 316302782.7566028,
		"wff_major_military_contractors_count": 184,
		"wff_major_military_contractors_weight": 0.033398999703931224,
		"wff_cluster_munitions_asset": 122455019.80960235,
		"wff_cluster_munitions_count": 30,
		"wff_cluster_munitions_weight": 0.012930253520763327,
		"wff_nuclear_weapons_asset": 189564086.78486082,
		"wff_nuclear_weapons_count": 72,
		"wff_nuclear_weapons_weight": 0.02001642484212825,
		"wff_mil_asset": 316302782.7566028,
		"wff_mil_count": 184,
		"wff_mil_weight": 0.033398999703931224,
		"wff_hi_asset": 216036705.0133543,
		"wff_hi_count": 82,
		"wff_hi_weight": 0.022811717885933384,
		"wff_all_asset": 356795312.09318084,
		"wff_all_count": 190,
		"wff_all_weight": 0.03767468126302925,
		"t_asset": 52841388.708556995,
		"t_count": 14,
		"t_weight": 0.005579620610516329,
		"t_m_asset": 68752012.64756992,
		"t_m_count": 9,
		"t_m_weight": 0.0072596530136373886,
		"t_all_asset": 121593401.35612692,
		"t_all_count": 23,
		"t_all_weight": 0.012839273624153718,
		"ip_divest_asset": 223289541.04949376,
		"ip_divest_count": 42,
		"ip_divest_weight": 0.023577558345864103,
		"pp_divest_asset": 19250540.651627854,
		"pp_divest_count": 15,
		"pp_divest_weight": 0.002032700426853305,
		"borders_divest_asset": 102910321.41198519,
		"borders_divest_count": 27,
		"borders_divest_weight": 0.010866492429866589,
		"pff_prisons_asset": 929220255.9355829,
		"pff_prisons_count": 48,
		"pff_prisons_weight": 0.09811809678816863,
		"pff_borders_asset": 874418304.9991708,
		"pff_borders_count": 55,
		"pff_borders_weight": 0.09233145676196142,
		"pff_high_asset": 105009961.3975577,
		"pff_high_count": 32,
		"pff_high_weight": 0.011088197324921088,
		"pff_extreme_asset": 1942496.1383164963,
		"pff_extreme_count": 5,
		"pff_extreme_weight": 0.0002051117836621875,
		"pff_all_asset": 1126144079.826112,
		"pff_all_count": 82,
		"pff_all_weight": 0.11891164997318086,
		"pff_prisons_high_asset": 19250540.651627854,
		"pff_prisons_high_count": 15,
		"pff_prisons_high_weight": 0.002032700426853305,
		"pff_borders_high_asset": 102910321.41198519,
		"pff_borders_high_count": 27,
		"pff_borders_high_weight": 0.010866492429866589,
		"fund_family_label": "BlackRock/iShares",
		"fund_legal_name": "BlackRock LifePath® Index 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 15.1216,
		"fossil_insure_score": 18.1007,
		"grade_gender_equality": 3,
		"gef_grp_norm": 46.85185185185185,
		"gef_percent_rated": 0.8128689827687525,
		"gef_score": 53.907153444007626,
		"strategy_name": "BlackRock LifePath Index",
		"net_assets": 9385071282,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 78687089491,
		"ticker": "LIPKX",
		"investment_vehicle_name": "BlackRock LifePath® Index 2050 K",
		"legal_type": "FO",
		"prospectus_date": "2025-04-30",
		"investment_vehicle_id": "F00000MAPG",
		"tickers": "LIPKX, LIPPX, LIPIX, LIPAX",
		"strategy_fund_legal_names": "BlackRock LifePath® Index 2030 Fund, BlackRock LifePath® Index 2035 Fund, BlackRock LifePath® Index 2040 Fund, BlackRock LifePath® Index 2045 Fund, BlackRock LifePath® Index 2050 Fund, BlackRock LifePath® Index 2055 Fund, BlackRock LifePath® Index 2060 Fund, BlackRock LifePath® Index 2065 Fund, BlackRock LifePath® Index 2070 Fund, BlackRock LifePath® Index Retirement Fund",
		"strategy_tickers": "LINIX, LINAX, LIDPX, LINKX, LIJIX, LIJAX, LIJPX, LIJKX, LIKIX, LIKAX, LIKPX, LIKKX, LIHIX, LIHAX, LIHPX, LIHKX, LIPIX, LIPAX, LIPPX, LIPKX, LIVIX, LIVAX, LIVPX, LIVKX, LIZIX, LIZAX, LIZPX, LIZKX, LIWIX, LIWAX, LIWPX, LIWKX, LIYIX, LIYAX, LIYKX, LIYPX, LIRIX, LIRAX, LIRPX, LIRKX",
		"strategy_name_query": "blackrock-lifepath-index",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00555
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.0029
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00194
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00144
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00123
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00121
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00064
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00062
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.0006
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.0005
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00555
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.0029
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00194
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00173
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00155
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.01036
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.001
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00062
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00028
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.0002
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.01036
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00155
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00107
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.001
					},
					{
						"standard_name": "Enel SpA",
						"long_weight": 0.00069
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.01036
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00555
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.0029
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00194
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00173
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00295
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00251
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00194
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00175
					},
					{
						"standard_name": "The Goldman Sachs Group Inc",
						"long_weight": 0.00175
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.01036
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.0013
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00102
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.0009
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00064
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00059
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00033
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.0003
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00025
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00732
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00295
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00194
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00175
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00143
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01897
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00446
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00427
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00425
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00405
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00074
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0.00001
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00405
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00012
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00005
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02968
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01897
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01772
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.01036
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00446
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02968
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01897
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01772
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00263
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00216
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00187
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00185
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.001
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00097
					},
					{
						"standard_name": "General Dynamics Corp",
						"long_weight": 0.00079
					}
				]
			},
			"is_pff_extreme": {
				"count": 5,
				"list": [
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00006
					},
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00005
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0.00003
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0.00003
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00229
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00187
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.00169
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00147
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00136
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00187
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00147
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.001
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00097
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00095
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00229
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00187
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00147
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00136
					},
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.00114
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00262
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00108
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00084
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00036
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00034
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00216
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.0019
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00162
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00147
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00008
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"JBS SA",
				"Tyson Foods Inc"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"RTX Corp"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA0A1NN",
		"percent_rated": 0.8706499013445091,
		"percent_rated_long": 0.8713052444302507,
		"long_equity_assets": 6212600168.506028,
		"long_cbond_assets": 203480662.7756691,
		"long_equity_weight": 0.8708230531983447,
		"long_cbond_weight": 0.028521979077842697,
		"c2_asset": 197103272.6679129,
		"c2_count": 98,
		"c2_weight": 0.027628057342266293,
		"co_asset": 90030891.69207929,
		"co_count": 108,
		"co_weight": 0.012619671934290826,
		"og_asset": 396079564.37182456,
		"og_count": 272,
		"og_weight": 0.05551865663337641,
		"mc50_asset": 88379940.75292373,
		"mc50_count": 27,
		"mc50_weight": 0.012388257373797415,
		"ut_asset": 228698261.35766685,
		"ut_count": 168,
		"ut_weight": 0.0320567415920681,
		"ff_hi_asset": 280332222.2152108,
		"ff_hi_count": 114,
		"ff_hi_weight": 0.03929429788462168,
		"ff_all_asset": 552567853.9059553,
		"ff_all_count": 392,
		"ff_all_weight": 0.07745369291218279,
		"cl_asset": 1178966998.2982788,
		"cl_count": 157,
		"cl_weight": 0.16525635212817555,
		"fossil_bank_asset": 277818071.0923795,
		"fossil_bank_count": 57,
		"fossil_bank_weight": 0.03894188815317224,
		"fossil_insure_asset": 146014887.5729653,
		"fossil_insure_count": 23,
		"fossil_insure_weight": 0.020466974657936142,
		"df_p_asset": 34467317.39990794,
		"df_p_count": 45,
		"df_p_weight": 0.004831299900145045,
		"df_c_asset": 602559768.3679172,
		"df_c_count": 128,
		"df_c_weight": 0.08446108279825443,
		"df_f_asset": 232083872.9356464,
		"df_f_count": 34,
		"df_f_weight": 0.03253130434056521,
		"df_all_asset": 856103838.3685449,
		"df_all_count": 194,
		"df_all_weight": 0.12000047293598742,
		"equileap_count": 2239,
		"dei_asset": 4021833515.938264,
		"dei_count": 2632,
		"dei_weight": 0.5637422732528766,
		"rji_asset": 4021833515.938264,
		"rji_count": 2632,
		"rji_weight": 0.5637422732528766,
		"hrc_asset": 3497274769.434562,
		"hrc_count": 736,
		"hrc_weight": 0.4902146299437309,
		"wff_gun_manufacturers_asset": 4838918.586218778,
		"wff_gun_manufacturers_count": 7,
		"wff_gun_manufacturers_weight": 0.0006782734673302782,
		"wff_gun_retailers_asset": 31164373.940274045,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.004368324780220088,
		"wff_civ_asset": 36003292.52649282,
		"wff_civ_count": 10,
		"wff_civ_weight": 0.005046598247550365,
		"wff_major_military_contractors_asset": 224098788.0211303,
		"wff_major_military_contractors_count": 138,
		"wff_major_military_contractors_weight": 0.03141203127667848,
		"wff_cluster_munitions_asset": 89030645.20084774,
		"wff_cluster_munitions_count": 24,
		"wff_cluster_munitions_weight": 0.012479466918706402,
		"wff_nuclear_weapons_asset": 136157792.8675033,
		"wff_nuclear_weapons_count": 55,
		"wff_nuclear_weapons_weight": 0.019085301111553734,
		"wff_mil_asset": 224098788.0211303,
		"wff_mil_count": 138,
		"wff_mil_weight": 0.03141203127667848,
		"wff_hi_asset": 154699189.0871913,
		"wff_hi_count": 63,
		"wff_hi_weight": 0.021684257237595844,
		"wff_all_asset": 255363581.32746214,
		"wff_all_count": 142,
		"wff_all_weight": 0.0357944318861132,
		"t_asset": 37893728.86589781,
		"t_count": 11,
		"t_weight": 0.005311581587908101,
		"t_m_asset": 52007419.22535602,
		"t_m_count": 9,
		"t_m_weight": 0.007289904125550983,
		"t_all_asset": 89901148.09125383,
		"t_all_count": 20,
		"t_all_weight": 0.012601485713459084,
		"ip_divest_asset": 156092162.01498616,
		"ip_divest_count": 31,
		"ip_divest_weight": 0.02187951090033021,
		"pp_divest_asset": 13285670.668900486,
		"pp_divest_count": 12,
		"pp_divest_weight": 0.001862258632758879,
		"borders_divest_asset": 71373447.20463888,
		"borders_divest_count": 25,
		"borders_divest_weight": 0.010004449268619337,
		"pff_prisons_asset": 693997740.5433257,
		"pff_prisons_count": 43,
		"pff_prisons_weight": 0.09727798585789597,
		"pff_borders_asset": 660887434.3066555,
		"pff_borders_count": 53,
		"pff_borders_weight": 0.09263689884323252,
		"pff_high_asset": 72838798.03109257,
		"pff_high_count": 28,
		"pff_high_weight": 0.01020984817504952,
		"pff_extreme_asset": 952382.7018357303,
		"pff_extreme_count": 3,
		"pff_extreme_weight": 0.00013349592597801423,
		"pff_all_asset": 837569179.2848426,
		"pff_all_count": 76,
		"pff_all_weight": 0.11740246115742782,
		"pff_prisons_high_asset": 13285670.668900486,
		"pff_prisons_high_count": 12,
		"pff_prisons_high_weight": 0.001862258632758879,
		"pff_borders_high_asset": 71373447.20463888,
		"pff_borders_high_count": 25,
		"pff_borders_high_weight": 0.010004449268619337,
		"fund_family_label": "TIAA Investments/Nuveen",
		"fund_legal_name": "Nuveen Lifecycle Index 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 14.6508,
		"fossil_insure_score": 17.2154,
		"grade_gender_equality": 2,
		"gef_grp_norm": 78.88888888888889,
		"gef_percent_rated": 0.7657253907934104,
		"gef_score": 54.630746465899975,
		"strategy_name": "Nuveen Lifecycle Index Series",
		"net_assets": 7128800606,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 60985627408,
		"ticker": "TLLIX",
		"investment_vehicle_name": "Nuveen Lifecycle Index 2050 R6",
		"legal_type": "FO",
		"prospectus_date": "2024-10-01",
		"investment_vehicle_id": "F000003V0I",
		"tickers": "TLLIX, TLLRX, TLLPX, TLLHX",
		"strategy_fund_legal_names": "Nuveen Lifecycle Index 2010 Fund, Nuveen Lifecycle Index 2015 Fund, Nuveen Lifecycle Index 2020 Fund, Nuveen Lifecycle Index 2025 Fund, Nuveen Lifecycle Index 2030 Fund, Nuveen Lifecycle Index 2035 Fund, Nuveen Lifecycle Index 2040 Fund, Nuveen Lifecycle Index 2045 Fund, Nuveen Lifecycle Index 2050 Fund, Nuveen Lifecycle Index 2055 Fund, Nuveen Lifecycle Index 2060 Fund, Nuveen Lifecycle Index 2065 Fund",
		"strategy_tickers": "TLTHX, TLTPX, TLTIX, TLTRX, TLFAX, TLFPX, TLFIX, TLGRX, TLWHX, TLWPX, TLWIX, TLWRX, TLQHX, TLVPX, TLQIX, TLQRX, TLHHX, TLHPX, TLHIX, TLHRX, TLYHX, TLYPX, TLYIX, TLYRX, TLZHX, TLPRX, TLZIX, TLZRX, TLMHX, TLMPX, TLXIX, TLMRX, TLLHX, TLLPX, TLLIX, TLLRX, TTIHX, TTIPX, TTIIX, TTIRX, TVIHX, TVIPX, TVIIX, TVITX, TFIHX, TFIPX, TFITX, TFIRX",
		"strategy_name_query": "nuveen-lifecycle-index-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00492
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00269
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00241
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.0016
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00152
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00152
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.0006
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00059
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00055
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00492
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00269
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00241
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00215
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.0016
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00927
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.0009
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00055
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00026
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00021
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00927
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00142
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00097
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.0009
					},
					{
						"standard_name": "Constellation Energy Corp",
						"long_weight": 0.00077
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00927
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00492
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00269
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00241
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00215
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00303
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00261
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00257
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00202
					},
					{
						"standard_name": "The Goldman Sachs Group Inc",
						"long_weight": 0.00186
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00927
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00163
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00119
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00114
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00093
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00065
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00051
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00029
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00027
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00733
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00303
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00261
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00202
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.0018
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01962
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00458
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00422
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00405
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00393
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00062
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Smith & Wesson Brands Inc",
						"long_weight": 0
					},
					{
						"standard_name": "National Presto Industries Inc",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00422
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00012
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00003
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02908
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01962
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01809
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00927
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00458
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02908
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01962
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01809
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00271
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00261
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00174
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00127
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00093
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00072
					}
				]
			},
			"is_pff_extreme": {
				"count": 3,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00008
					},
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00003
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00002
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00219
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00174
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.00166
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00136
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00127
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00174
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00136
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00127
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00116
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00093
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00219
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00174
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00136
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00127
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00122
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00238
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00095
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00094
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00036
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00034
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00204
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00193
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.0019
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00133
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00006
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"JBS SA",
				"Tyson Foods Inc"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"RTX Corp"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA08I1X",
		"percent_rated": 0.8822315062736381,
		"percent_rated_long": 0.8839321041064029,
		"long_equity_assets": 2950463707.630056,
		"long_cbond_assets": 85279749.27997527,
		"long_equity_weight": 0.8840850375503394,
		"long_cbond_weight": 0.025553457969842555,
		"c2_asset": 103929033.40452579,
		"c2_count": 114,
		"c2_weight": 0.031141580614056922,
		"co_asset": 47305258.00905096,
		"co_count": 147,
		"co_weight": 0.014174677253309956,
		"og_asset": 203304195.6554845,
		"og_count": 350,
		"og_weight": 0.060918626785819475,
		"mc50_asset": 26173142.82808875,
		"mc50_count": 28,
		"mc50_weight": 0.007842592301725937,
		"ut_asset": 91568250.07513584,
		"ut_count": 206,
		"ut_weight": 0.027437761595488767,
		"ff_hi_asset": 129177722.47197723,
		"ff_hi_count": 131,
		"ff_hi_weight": 0.03870716705545894,
		"ff_all_asset": 245996514.26715577,
		"ff_all_count": 526,
		"ff_all_weight": 0.0737110702262534,
		"cl_asset": 507805402.98950416,
		"cl_count": 121,
		"cl_weight": 0.15216020370264177,
		"fossil_bank_asset": 141337010.75819874,
		"fossil_bank_count": 47,
		"fossil_bank_weight": 0.04235060954665443,
		"fossil_insure_asset": 27781463.437442344,
		"fossil_insure_count": 11,
		"fossil_insure_weight": 0.008324513900231374,
		"df_p_asset": 8593696.703956125,
		"df_p_count": 53,
		"df_p_weight": 0.0025750388501866975,
		"df_c_asset": 260773107.41489917,
		"df_c_count": 88,
		"df_c_weight": 0.07813876912460122,
		"df_f_asset": 117250775.29613765,
		"df_f_count": 25,
		"df_f_weight": 0.035133343891817034,
		"df_all_asset": 386611409.0433401,
		"df_all_count": 156,
		"df_all_weight": 0.11584530295951949,
		"equileap_count": 2541,
		"dei_asset": 1916646874.520999,
		"dei_count": 2657,
		"dei_weight": 0.5743093262423888,
		"rji_asset": 1916646874.520999,
		"rji_count": 2657,
		"rji_weight": 0.5743093262423888,
		"hrc_asset": 1701654416.1419187,
		"hrc_count": 542,
		"hrc_weight": 0.5098883963568344,
		"wff_gun_manufacturers_asset": 4638756.399855473,
		"wff_gun_manufacturers_count": 11,
		"wff_gun_manufacturers_weight": 0.0013899696903058177,
		"wff_gun_retailers_asset": 23627575.054388456,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.007079831392320797,
		"wff_civ_asset": 28266331.45424393,
		"wff_civ_count": 14,
		"wff_civ_weight": 0.008469801082626615,
		"wff_major_military_contractors_asset": 124830404.97159761,
		"wff_major_military_contractors_count": 167,
		"wff_major_military_contractors_weight": 0.0374045249163175,
		"wff_cluster_munitions_asset": 56660984.8189734,
		"wff_cluster_munitions_count": 19,
		"wff_cluster_munitions_weight": 0.01697805289445785,
		"wff_nuclear_weapons_asset": 70416309.70429696,
		"wff_nuclear_weapons_count": 57,
		"wff_nuclear_weapons_weight": 0.021099736169635824,
		"wff_mil_asset": 124830404.97159761,
		"wff_mil_count": 167,
		"wff_mil_weight": 0.0374045249163175,
		"wff_hi_asset": 88411561.71162453,
		"wff_hi_count": 63,
		"wff_hi_weight": 0.02649188283644065,
		"wff_all_asset": 148460389.3583293,
		"wff_all_count": 173,
		"wff_all_weight": 0.04448507824758967,
		"t_asset": 21440038.64321489,
		"t_count": 12,
		"t_weight": 0.006424351982350841,
		"t_m_asset": 44285071.16561633,
		"t_m_count": 9,
		"t_m_weight": 0.013269700184118454,
		"t_all_asset": 65725109.80883122,
		"t_all_count": 21,
		"t_all_weight": 0.019694052166469297,
		"ip_divest_asset": 72182013.73625721,
		"ip_divest_count": 40,
		"ip_divest_weight": 0.02162881656854446,
		"pp_divest_asset": 10271433.881065706,
		"pp_divest_count": 11,
		"pp_divest_weight": 0.0030777606194424007,
		"borders_divest_asset": 35098032.45871403,
		"borders_divest_count": 19,
		"borders_divest_weight": 0.010516870708818045,
		"pff_prisons_asset": 321993607.34954685,
		"pff_prisons_count": 32,
		"pff_prisons_weight": 0.09648304763363885,
		"pff_borders_asset": 308583049.78542113,
		"pff_borders_count": 36,
		"pff_borders_weight": 0.09246467138417318,
		"pff_high_asset": 36096516.767780624,
		"pff_high_count": 22,
		"pff_high_weight": 0.010816059285715888,
		"pff_extreme_asset": 1001514.0157889305,
		"pff_extreme_count": 4,
		"pff_extreme_weight": 0.00030009640652965686,
		"pff_all_asset": 379992489.84387666,
		"pff_all_count": 52,
		"pff_all_weight": 0.11386199185697397,
		"pff_prisons_high_asset": 10271433.881065706,
		"pff_prisons_high_count": 11,
		"pff_prisons_high_weight": 0.0030777606194424007,
		"pff_borders_high_asset": 35098032.45871403,
		"pff_borders_high_count": 19,
		"pff_borders_high_weight": 0.010516870708818045,
		"fund_family_label": "TIAA Investments/Nuveen",
		"fund_legal_name": "Nuveen Lifecycle 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 18.6121,
		"fossil_insure_score": 7.028,
		"grade_gender_equality": 2,
		"gef_grp_norm": 76.29629629629629,
		"gef_percent_rated": 0.7699908593589894,
		"gef_score": 54.62834565939766,
		"strategy_name": "Nuveen Lifecycle Series",
		"net_assets": 3330874566,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 32050860944,
		"ticker": "TFTIX",
		"investment_vehicle_name": "Nuveen Lifecycle 2050 R6",
		"legal_type": "FO",
		"prospectus_date": "2024-10-01",
		"investment_vehicle_id": "FOUSA06MDL",
		"tickers": "TFTIX, TLFRX, TCLPX, TFTHX",
		"strategy_fund_legal_names": "Nuveen Lifecycle 2010 Fund, Nuveen Lifecycle 2015 Fund, Nuveen Lifecycle 2020 Fund, Nuveen Lifecycle 2025 Fund, Nuveen Lifecycle 2030 Fund, Nuveen Lifecycle 2035 Fund, Nuveen Lifecycle 2040 Fund, Nuveen Lifecycle 2045 Fund, Nuveen Lifecycle 2050 Fund, Nuveen Lifecycle 2055 Fund, Nuveen Lifecycle 2060 Fund, Nuveen Lifecycle 2065 Fund",
		"strategy_tickers": "TCLHX, TCTPX, TCTIX, TCLEX, TCNHX, TCFPX, TCNIX, TCLIX, TCWHX, TCWPX, TCWIX, TCLTX, TCQHX, TCQPX, TCYIX, TCLFX, TCHHX, TCHPX, TCRIX, TCLNX, TCYHX, TCYPX, TCIIX, TCLRX, TCZHX, TCZPX, TCOIX, TCLOX, TTFHX, TTFPX, TTFIX, TTFRX, TFTHX, TCLPX, TFTIX, TLFRX, TTRHX, TTRPX, TTRIX, TTRLX, TLXHX, TLXPX, TLXNX, TLXRX, TSFHX, TSFPX, TSFTX, TSFRX",
		"strategy_name_query": "nuveen-lifecycle-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00513
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00423
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00361
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00259
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00192
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Alliant Energy Corp",
						"long_weight": 0.00235
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00192
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00181
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00158
					},
					{
						"standard_name": "RWE AG",
						"long_weight": 0.00108
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00637
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00513
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00423
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00361
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00346
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00293
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0024
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00181
					},
					{
						"standard_name": "AGL Energy Ltd",
						"long_weight": 0.00028
					},
					{
						"standard_name": "Electric Power Development Co Ltd",
						"long_weight": 0.00025
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00637
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00293
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0024
					},
					{
						"standard_name": "Alliant Energy Corp",
						"long_weight": 0.00235
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00188
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00637
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00513
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00423
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00361
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00346
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00457
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.00413
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00413
					},
					{
						"standard_name": "Citigroup Inc",
						"long_weight": 0.00378
					},
					{
						"standard_name": "Banco Bilbao Vizcaya Argentaria SA",
						"long_weight": 0.00345
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0024
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00232
					},
					{
						"standard_name": "American International Group Inc",
						"long_weight": 0.00133
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00131
					},
					{
						"standard_name": "Ping An Insurance (Group) Co. of China Ltd",
						"long_weight": 0.00086
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00158
					},
					{
						"standard_name": "PT Astra International Tbk",
						"long_weight": 0.0005
					},
					{
						"standard_name": "POSCO Holdings Inc",
						"long_weight": 0.00036
					},
					{
						"standard_name": "United Plantation Bhd",
						"long_weight": 0.00013
					},
					{
						"standard_name": "Sumitomo Forestry Co Ltd",
						"long_weight": 0
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00688
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.00413
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00413
					},
					{
						"standard_name": "Citigroup Inc",
						"long_weight": 0.00378
					},
					{
						"standard_name": "Banco Bilbao Vizcaya Argentaria SA",
						"long_weight": 0.00345
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02259
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00708
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00549
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00513
					},
					{
						"standard_name": "Lvmh Moet Hennessy Louis Vuitton SE",
						"long_weight": 0.00421
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00119
					},
					{
						"standard_name": "Poongsan Corp",
						"long_weight": 0.0002
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00708
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03395
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02259
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01462
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00708
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00549
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03395
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02259
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01462
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Accenture PLC",
						"long_weight": 0.00358
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00252
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.0017
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00119
					},
					{
						"standard_name": "Textron Inc",
						"long_weight": 0.00094
					}
				]
			},
			"is_pff_extreme": {
				"count": 4,
				"list": [
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0.0002
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0.0001
					},
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00512
					},
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.00485
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00365
					},
					{
						"standard_name": "Parker Hannifin Corp",
						"long_weight": 0.00277
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00512
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00365
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.0017
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00119
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.00485
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00365
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00224
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.0017
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00636
					},
					{
						"standard_name": "Scandinavian Tobacco Group AS",
						"long_weight": 0.00007
					},
					{
						"standard_name": "ITC Ltd",
						"long_weight": 0
					},
					{
						"standard_name": "Universal Corp",
						"long_weight": 0
					},
					{
						"standard_name": "KT&G Corp",
						"long_weight": 0
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00491
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00422
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00223
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00187
					},
					{
						"standard_name": "Lions Gate Entertainment Corp",
						"long_weight": 0.00003
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"JBS SA",
				"Glencore PLC",
				"PT Astra International Tbk"
			],
			"wff": [
				"RTX Corp",
				"Northrop Grumman Corp",
				"CRH PLC"
			],
			"tff": [
				"Philip Morris International Inc",
				"Scandinavian Tobacco Group AS",
				"ITC Ltd"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"Airbus SE"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA008T8",
		"percent_rated": 0.9178927329499599,
		"percent_rated_long": 0.9260038962998386,
		"long_equity_assets": 2951687031.672114,
		"long_cbond_assets": 87742312.95444494,
		"long_equity_weight": 0.9259836134136694,
		"long_cbond_weight": 0.027525934534056426,
		"c2_asset": 63842838.939468466,
		"c2_count": 40,
		"c2_weight": 0.020028350586432684,
		"co_asset": 11259593.830642067,
		"co_count": 23,
		"co_weight": 0.0035322848489671406,
		"og_asset": 202526753.6715404,
		"og_count": 116,
		"og_weight": 0.06353534543649596,
		"mc50_asset": 15848636.43415192,
		"mc50_count": 7,
		"mc50_weight": 0.004971928756505698,
		"ut_asset": 75250966.20078774,
		"ut_count": 52,
		"ut_weight": 0.023607232354848053,
		"ff_hi_asset": 79593140.07248145,
		"ff_hi_count": 46,
		"ff_hi_weight": 0.024969430246642704,
		"ff_all_asset": 233913571.75675154,
		"ff_all_count": 155,
		"ff_all_weight": 0.0733818091408938,
		"cl_asset": 466703959.226213,
		"cl_count": 59,
		"cl_weight": 0.14641126038147012,
		"fossil_bank_asset": 89083767.17616469,
		"fossil_bank_count": 12,
		"fossil_bank_weight": 0.027946766625713985,
		"fossil_insure_asset": 79665328.39911333,
		"fossil_insure_count": 10,
		"fossil_insure_weight": 0.024992076688092495,
		"df_p_asset": 3900510.0870343805,
		"df_p_count": 9,
		"df_p_weight": 0.0012236420683470947,
		"df_c_asset": 212705253.3345572,
		"df_c_count": 65,
		"df_c_weight": 0.06672847661739585,
		"df_f_asset": 69057614.87780297,
		"df_f_count": 7,
		"df_f_weight": 0.02166429539179579,
		"df_all_asset": 283540589.54496217,
		"df_all_count": 76,
		"df_all_weight": 0.08895046691571187,
		"equileap_count": 1500,
		"dei_asset": 2090234257.3108432,
		"dei_count": 1603,
		"dei_weight": 0.6557343816255715,
		"rji_asset": 2090234257.3108432,
		"rji_count": 1603,
		"rji_weight": 0.6557343816255715,
		"hrc_asset": 1724099901.5538492,
		"hrc_count": 641,
		"hrc_weight": 0.5408731479985476,
		"wff_gun_manufacturers_asset": 947105.6592701486,
		"wff_gun_manufacturers_count": 5,
		"wff_gun_manufacturers_weight": 0.0002971196848599121,
		"wff_gun_retailers_asset": 6040278.697789902,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.0018949160377062712,
		"wff_civ_asset": 6987384.357060051,
		"wff_civ_count": 8,
		"wff_civ_weight": 0.0021920357225661833,
		"wff_major_military_contractors_asset": 175455668.28914317,
		"wff_major_military_contractors_count": 78,
		"wff_major_military_contractors_weight": 0.05504278467634598,
		"wff_cluster_munitions_asset": 106872459.33023703,
		"wff_cluster_munitions_count": 15,
		"wff_cluster_munitions_weight": 0.03352731675246641,
		"wff_nuclear_weapons_asset": 86458148.26919131,
		"wff_nuclear_weapons_count": 33,
		"wff_nuclear_weapons_weight": 0.027123074934542666,
		"wff_mil_asset": 175455668.28914317,
		"wff_mil_count": 78,
		"wff_mil_weight": 0.05504278467634598,
		"wff_hi_asset": 137982967.23367593,
		"wff_hi_count": 37,
		"wff_hi_weight": 0.04328709826535987,
		"wff_all_asset": 181758533.11987978,
		"wff_all_count": 83,
		"wff_all_weight": 0.05702007748828653,
		"t_asset": 8538738.494846271,
		"t_count": 3,
		"t_weight": 0.0026787162191016668,
		"t_m_asset": 14702251.949657913,
		"t_m_count": 5,
		"t_m_weight": 0.004612292644708379,
		"t_all_asset": 23240990.444504183,
		"t_all_count": 8,
		"t_all_weight": 0.007291008863810046,
		"ip_divest_asset": 54526751.84742387,
		"ip_divest_count": 21,
		"ip_divest_weight": 0.01710576973832664,
		"pp_divest_asset": 2010285.6553108732,
		"pp_divest_count": 9,
		"pp_divest_weight": 0.0006306534382284778,
		"borders_divest_asset": 31606939.855999548,
		"borders_divest_count": 23,
		"borders_divest_weight": 0.009915518841517255,
		"pff_prisons_asset": 288669725.893609,
		"pff_prisons_count": 34,
		"pff_prisons_weight": 0.09055954543889148,
		"pff_borders_asset": 292766183.30277276,
		"pff_borders_count": 43,
		"pff_borders_weight": 0.09184465879719486,
		"pff_high_asset": 31622790.810045846,
		"pff_high_count": 24,
		"pff_high_weight": 0.009920491497339621,
		"pff_extreme_asset": 149070.94047027503,
		"pff_extreme_count": 2,
		"pff_extreme_weight": 0.00004676554344362246,
		"pff_all_asset": 346074778.9228333,
		"pff_all_count": 60,
		"pff_all_weight": 0.10856827667016021,
		"pff_prisons_high_asset": 2010285.6553108732,
		"pff_prisons_high_count": 9,
		"pff_prisons_high_weight": 0.0006306534382284778,
		"pff_borders_high_asset": 31606939.855999548,
		"pff_borders_high_count": 23,
		"pff_borders_high_weight": 0.009915518841517255,
		"fund_family_label": "Principal Funds",
		"fund_legal_name": "Principal LifeTime 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"fossil_bank_score": 11.7432,
		"fossil_insure_score": 19.9392,
		"grade_gender_equality": 4,
		"gef_grp_norm": 32.22222222222222,
		"gef_percent_rated": 0.8588662398790713,
		"gef_score": 53.57229404149224,
		"strategy_name": "Principal LifeTime Series",
		"net_assets": 3159455254,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 23355583336,
		"ticker": "PPLIX",
		"investment_vehicle_name": "Principal LifeTime 2050 Institutional",
		"legal_type": "FO",
		"prospectus_date": "2025-03-01",
		"investment_vehicle_id": "FOUSA02STA",
		"tickers": "PPLIX, PFLJX, PTEFX, PPEAX, PTERX",
		"strategy_fund_legal_names": "Principal LifeTime 2015 Fund, Principal LifeTime 2020 Fund, Principal LifeTime 2025 Fund, Principal LifeTime 2030 Fund, Principal LifeTime 2035 Fund, Principal LifeTime 2040 Fund, Principal LifeTime 2045 Fund, Principal LifeTime 2050 Fund, Principal LifeTime 2055 Fund, Principal LifeTime 2060 Fund, Principal LifeTime 2065, Principal LifeTime Strategic Income Fund, Principal Lifetime 2070 Fund",
		"strategy_tickers": "LTINX, LTAPX, LTPFX, PTBAX, PLWIX, PLFJX, PTBMX, PTBPX, LTSTX, LTVPX, LTPDX, PTCAX, PMTIX, PLTJX, PTCMX, PTCPX, LTIUX, LTAOX, LTPEX, PTDAX, PTDIX, PTDJX, PTDMX, PTDPX, LTRIX, LTRVX, LTRDX, PPEAX, PPLIX, PFLJX, PTERX, PTEFX, LTFIX, LTFDX, LTFPX, PLTZX, PLTAX, PLTCX, PLTOX, PLJIX, PLJCX, PLJEX, PALTX, PLSIX, PLSJX, PLSMX, PLSPX, PLTGX, PLTLX, PLTDX, PLTFX",
		"strategy_name_query": "principal-lifetime-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Suncor Energy Inc",
						"long_weight": 0.0063
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00411
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00268
					},
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Permian Resources Corp",
						"long_weight": 0.00098
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Pinnacle West Capital Corp",
						"long_weight": 0.00116
					},
					{
						"standard_name": "Alliant Energy Corp",
						"long_weight": 0.0004
					},
					{
						"standard_name": "Idacorp Inc",
						"long_weight": 0.00037
					},
					{
						"standard_name": "Adani Energy Solutions Ltd",
						"long_weight": 0.00027
					},
					{
						"standard_name": "JSW Infrastructure Ltd",
						"long_weight": 0.00025
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Brookfield Corp",
						"long_weight": 0.00706
					},
					{
						"standard_name": "KKR & Co Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "Suncor Energy Inc",
						"long_weight": 0.0063
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00411
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00316
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00411
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00028
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00023
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00018
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00008
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00411
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00316
					},
					{
						"standard_name": "Xcel Energy Inc",
						"long_weight": 0.00271
					},
					{
						"standard_name": "WEC Energy Group Inc",
						"long_weight": 0.00213
					},
					{
						"standard_name": "Entergy Corp",
						"long_weight": 0.00202
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Brookfield Corp",
						"long_weight": 0.00706
					},
					{
						"standard_name": "KKR & Co Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "Suncor Energy Inc",
						"long_weight": 0.0063
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00411
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00411
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00573
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00564
					},
					{
						"standard_name": "NatWest Group PLC",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00349
					},
					{
						"standard_name": "PNC Financial Services Group Inc",
						"long_weight": 0.00282
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Hannover Rueck SE",
						"long_weight": 0.00638
					},
					{
						"standard_name": "Sompo Holdings Inc",
						"long_weight": 0.00627
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00411
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00348
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00235
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Suzano SA",
						"long_weight": 0.00035
					},
					{
						"standard_name": "WH Group Ltd",
						"long_weight": 0.00028
					},
					{
						"standard_name": "Archer-Daniels-Midland Co",
						"long_weight": 0.00014
					},
					{
						"standard_name": "Tyson Foods Inc",
						"long_weight": 0.00012
					},
					{
						"standard_name": "Bunge Global SA",
						"long_weight": 0.0001
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00664
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00564
					},
					{
						"standard_name": "NatWest Group PLC",
						"long_weight": 0.00379
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00349
					},
					{
						"standard_name": "Citigroup Inc",
						"long_weight": 0.00175
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02149
					},
					{
						"standard_name": "Unilever PLC",
						"long_weight": 0.00971
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00767
					},
					{
						"standard_name": "Prada SpA",
						"long_weight": 0.00349
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00336
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00021
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0.00008
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0
					},
					{
						"standard_name": "National Presto Industries Inc",
						"long_weight": 0
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00186
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00001
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03199
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02149
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01834
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00767
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00411
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03199
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02149
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01834
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00628
					},
					{
						"standard_name": "Thermo Fisher Scientific Inc",
						"long_weight": 0.00292
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00628
					},
					{
						"standard_name": "General Dynamics Corp",
						"long_weight": 0.00067
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00053
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00053
					},
					{
						"standard_name": "Leidos Holdings Inc",
						"long_weight": 0.0005
					}
				]
			},
			"is_pff_extreme": {
				"count": 2,
				"list": [
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00003
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00002
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "TransDigm Group Inc",
						"long_weight": 0.0093
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00808
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00675
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00628
					},
					{
						"standard_name": "Fujitsu Ltd",
						"long_weight": 0.00404
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "TransDigm Group Inc",
						"long_weight": 0.0093
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00808
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00675
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00628
					},
					{
						"standard_name": "General Dynamics Corp",
						"long_weight": 0.00067
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00808
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00628
					},
					{
						"standard_name": "Heico Corp",
						"long_weight": 0.00367
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00075
					},
					{
						"standard_name": "CACI International Inc",
						"long_weight": 0.00074
					}
				]
			},
			"is_t": {
				"count": 3,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00236
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00031
					},
					{
						"standard_name": "Universal Corp",
						"long_weight": 0.00001
					}
				]
			},
			"is_t_m": {
				"count": 4,
				"list": [
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.0024
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00149
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00063
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00009
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"Suzano SA"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"Altria Group Inc",
				"Universal Corp"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"Airbus SE"
			],
			"gff": [
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp",
				"NOF Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA08DFY",
		"percent_rated": 0.8896970578318337,
		"percent_rated_long": 0.8897254324787125,
		"long_equity_assets": 2459159586.841634,
		"long_cbond_assets": 82725752.64066413,
		"long_equity_weight": 0.8880348329040698,
		"long_cbond_weight": 0.029873356050660615,
		"c2_asset": 78415005.96938021,
		"c2_count": 57,
		"c2_weight": 0.02831668879717752,
		"co_asset": 19069681.863949466,
		"co_count": 41,
		"co_weight": 0.006886312640382819,
		"og_asset": 174415504.03733394,
		"og_count": 123,
		"og_weight": 0.06298372981258961,
		"mc50_asset": 16282686.719787596,
		"mc50_count": 5,
		"mc50_weight": 0.005879892080939223,
		"ut_asset": 89113935.31162271,
		"ut_count": 63,
		"ut_weight": 0.032180212735001004,
		"ff_hi_asset": 94083387.65744041,
		"ff_hi_count": 60,
		"ff_hi_weight": 0.033974747261005786,
		"ff_all_asset": 222679522.97515702,
		"ff_all_count": 174,
		"ff_all_weight": 0.0804125010977322,
		"cl_asset": 419680639.5642241,
		"cl_count": 77,
		"cl_weight": 0.1515521923110107,
		"fossil_bank_asset": 136169219.47243413,
		"fossil_bank_count": 40,
		"fossil_bank_weight": 0.049172494012958874,
		"fossil_insure_asset": 63539330.816495694,
		"fossil_insure_count": 12,
		"fossil_insure_weight": 0.02294488707702436,
		"df_p_asset": 9482536.05422854,
		"df_p_count": 12,
		"df_p_weight": 0.003424268341705612,
		"df_c_asset": 231537014.4841215,
		"df_c_count": 53,
		"df_c_weight": 0.08361105764290326,
		"df_f_asset": 66278578.130639225,
		"df_f_count": 27,
		"df_f_weight": 0.023934065267782835,
		"df_all_asset": 306563168.4866027,
		"df_all_count": 90,
		"df_all_weight": 0.11070398747532532,
		"equileap_count": 1216,
		"dei_asset": 1649105708.910335,
		"dei_count": 1243,
		"dei_weight": 0.5955137358670518,
		"rji_asset": 1649105708.910335,
		"rji_count": 1243,
		"rji_weight": 0.5955137358670518,
		"hrc_asset": 1387972331.9724658,
		"hrc_count": 441,
		"hrc_weight": 0.5012150429332898,
		"wff_gun_manufacturers_asset": 7463614.504222944,
		"wff_gun_manufacturers_count": 2,
		"wff_gun_manufacturers_weight": 0.0026952092473309028,
		"wff_gun_retailers_asset": 9046587.928109007,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.00326684174629274,
		"wff_civ_asset": 16510202.432331951,
		"wff_civ_count": 5,
		"wff_civ_weight": 0.005962050993623643,
		"wff_major_military_contractors_asset": 80671595.44594814,
		"wff_major_military_contractors_count": 70,
		"wff_major_military_contractors_weight": 0.029131572902088655,
		"wff_cluster_munitions_asset": 37813818.04040577,
		"wff_cluster_munitions_count": 15,
		"wff_cluster_munitions_weight": 0.013655066456302798,
		"wff_nuclear_weapons_asset": 51274525.45422208,
		"wff_nuclear_weapons_count": 29,
		"wff_nuclear_weapons_weight": 0.01851590473738046,
		"wff_mil_asset": 80671595.44594814,
		"wff_mil_count": 70,
		"wff_mil_weight": 0.029131572902088655,
		"wff_hi_asset": 55754524.22632485,
		"wff_hi_count": 33,
		"wff_hi_weight": 0.020133691147942077,
		"wff_all_asset": 89718183.37405714,
		"wff_all_count": 73,
		"wff_all_weight": 0.0323984146483814,
		"t_asset": 8751476.02931735,
		"t_count": 4,
		"t_weight": 0.0031602729627401302,
		"t_m_asset": 20730206.81964118,
		"t_m_count": 5,
		"t_m_weight": 0.007485950016277811,
		"t_all_asset": 29481682.84895853,
		"t_all_count": 9,
		"t_all_weight": 0.010646222979017942,
		"ip_divest_asset": 26096597.24061656,
		"ip_divest_count": 16,
		"ip_divest_weight": 0.009423824095816255,
		"pp_divest_asset": 3885874.6963514267,
		"pp_divest_count": 4,
		"pp_divest_weight": 0.0014032404017717854,
		"borders_divest_asset": 26985571.27704243,
		"borders_divest_count": 14,
		"borders_divest_weight": 0.00974484429886351,
		"pff_prisons_asset": 245257507.06293997,
		"pff_prisons_count": 24,
		"pff_prisons_weight": 0.08856570775987319,
		"pff_borders_asset": 239946654.10040596,
		"pff_borders_count": 34,
		"pff_borders_weight": 0.08664788898617613,
		"pff_high_asset": 26985571.27704243,
		"pff_high_count": 14,
		"pff_high_weight": 0.00974484429886351,
		"pff_extreme_asset": 35295.054373238105,
		"pff_extreme_count": 1,
		"pff_extreme_weight": 0.00001274550780697138,
		"pff_all_asset": 294166789.1872498,
		"pff_all_count": 45,
		"pff_all_weight": 0.10622749205850907,
		"pff_prisons_high_asset": 3885874.6963514267,
		"pff_prisons_high_count": 4,
		"pff_prisons_high_weight": 0.0014032404017717854,
		"pff_borders_high_asset": 26985571.27704243,
		"pff_borders_high_count": 14,
		"pff_borders_high_weight": 0.00974484429886351,
		"fund_family_label": "JPMorgan",
		"fund_legal_name": "JPMorgan SmartRetirement® 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"fossil_bank_score": 19.6259,
		"fossil_insure_score": 18.0041,
		"grade_gender_equality": 2,
		"gef_grp_norm": 75.55555555555556,
		"gef_percent_rated": 0.8151074851347349,
		"gef_score": 54.59703346187071,
		"strategy_name": "JPM SmartRetirement Series",
		"net_assets": 2769126916,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 23788440542,
		"ticker": "JTSYX",
		"investment_vehicle_name": "JPMorgan SmartRetirement® 2050 R6",
		"legal_type": "FO",
		"prospectus_date": "2024-11-01",
		"investment_vehicle_id": "F00000U8A3",
		"tickers": "JTSYX, JTSIX, JTSAX, JTSSX, JTSZX, JTSPX, JTSQX, JTSCX",
		"strategy_fund_legal_names": "JPMorgan SmartRetirement® 2025 Fund, JPMorgan SmartRetirement® 2030 Fund, JPMorgan SmartRetirement® 2035 Fund, JPMorgan SmartRetirement® 2040 Fund, JPMorgan SmartRetirement® 2045 Fund, JPMorgan SmartRetirement® 2050 Fund, JPMorgan SmartRetirement® 2055 Fund, JPMorgan SmartRetirement® 2060 Fund, JPMorgan SmartRetirement® 2065 Fund, JPMorgan SmartRetirement® Income Fund",
		"strategy_tickers": "JNSAX, JNSCX, JNSSX, JNSZX, JNSPX, JNSQX, JNSIX, JNSYX, JSMAX, JSMCX, JSMSX, JSMZX, JSMNX, JSMQX, JSMIX, JSMYX, SRJAX, SRJCX, SRJSX, SRJZX, SRJPX, SRJQX, SRJIX, SRJYX, SMTAX, SMTCX, SMTSX, SMTZX, SMTPX, SMTQX, SMTIX, SMTYX, JSAAX, JSACX, JSASX, JSAZX, JSAPX, JSAQX, JSAIX, JSAYX, JTSAX, JTSCX, JTSSX, JTSZX, JTSPX, JTSQX, JTSIX, JTSYX, JFFAX, JFFCX, JFFSX, JFFRX, JFFPX, JFFQX, JFFIX, JFFYX, JAKAX, JAKCX, JAKSX, JAKZX, JAKPX, JAKQX, JAKIX, JAKYX, JSMEX, JSMHX, JSMJX, JSMKX, JSMPX, JSMLX, JSMMX, JSMOX, JSRAX, JSRCX, JSRSX, JSIZX, JSIPX, JSIQX, JSIIX, JSIYX",
		"strategy_name_query": "jpm-smartretirement-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00612
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.0041
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00338
					},
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00277
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00203
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00182
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00176
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00053
					},
					{
						"standard_name": "UltraTech Cement Ltd",
						"long_weight": 0.00032
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00025
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00612
					},
					{
						"standard_name": "Baker Hughes Co",
						"long_weight": 0.00502
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00428
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.0041
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00559
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00021
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00005
					},
					{
						"standard_name": "China Hongqiao Group Ltd",
						"long_weight": 0.00002
					},
					{
						"standard_name": "China Shenhua Energy Co Ltd",
						"long_weight": 0.00001
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00559
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00428
					},
					{
						"standard_name": "PG&E Corp",
						"long_weight": 0.00295
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00239
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00612
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00559
					},
					{
						"standard_name": "Baker Hughes Co",
						"long_weight": 0.00502
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00428
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00982
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00436
					},
					{
						"standard_name": "DBS Group Holdings Ltd",
						"long_weight": 0.00332
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00316
					},
					{
						"standard_name": "Banco Santander SA",
						"long_weight": 0.00247
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00559
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00481
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00316
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.00298
					},
					{
						"standard_name": "Tokio Marine Holdings Inc",
						"long_weight": 0.00225
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00239
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00052
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00025
					},
					{
						"standard_name": "Samsung C&T Corp",
						"long_weight": 0.00009
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00006
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00436
					},
					{
						"standard_name": "DBS Group Holdings Ltd",
						"long_weight": 0.00332
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00211
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00201
					},
					{
						"standard_name": "NatWest Group PLC",
						"long_weight": 0.00171
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02281
					},
					{
						"standard_name": "McDonald's Corp",
						"long_weight": 0.00698
					},
					{
						"standard_name": "Lowe's Companies Inc",
						"long_weight": 0.0049
					},
					{
						"standard_name": "Nestle SA",
						"long_weight": 0.0047
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00465
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 2,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00003
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.0024
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00082
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00005
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03143
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02281
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01042
					},
					{
						"standard_name": "McDonald's Corp",
						"long_weight": 0.00698
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00559
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03143
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02281
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01042
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00319
					},
					{
						"standard_name": "Thermo Fisher Scientific Inc",
						"long_weight": 0.00308
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00184
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00175
					},
					{
						"standard_name": "Regions Financial Corp",
						"long_weight": 0.00111
					},
					{
						"standard_name": "General Dynamics Corp",
						"long_weight": 0.00085
					}
				]
			},
			"is_pff_extreme": {
				"count": 1,
				"list": [
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00001
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.0043
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00398
					},
					{
						"standard_name": "Howmet Aerospace Inc",
						"long_weight": 0.00317
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00184
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00398
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00184
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00175
					},
					{
						"standard_name": "General Dynamics Corp",
						"long_weight": 0.00085
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.0043
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00398
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00184
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00175
					}
				]
			},
			"is_t": {
				"count": 4,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.0021
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00056
					},
					{
						"standard_name": "ITC Ltd",
						"long_weight": 0.00026
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00025
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00374
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00238
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00071
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00057
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00007
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"ITOCHU Corp",
				"International Paper Co",
				"Mitsubishi Corp"
			],
			"wff": [
				"RTX Corp",
				"Northrop Grumman Corp",
				"Eaton Corp PLC"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Berkshire Hathaway Inc"
			],
			"pff": [
				"The GEO Group Inc",
				"Northrop Grumman Corp",
				"Airbus SE"
			],
			"gff": [
				"Northrop Grumman Corp",
				"Olin Corp"
			],
			"ffb": [
				"Bank of America Corp",
				"Wells Fargo & Co",
				"DBS Group Holdings Ltd"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"Munchener Ruckversicherungs-Gesellschaft AG"
			]
		}
	},
	{
		"fund_id": "FS0000DV7F",
		"percent_rated": 0.7936550379599175,
		"percent_rated_long": 0.8437193308300207,
		"long_equity_assets": 2461632466.8986874,
		"long_cbond_assets": 19791003.006134335,
		"long_equity_weight": 0.8428872046317379,
		"long_cbond_weight": 0.006776634377801879,
		"c2_asset": 99325390.4234985,
		"c2_count": 80,
		"c2_weight": 0.0340099920718442,
		"co_asset": 27894777.926411454,
		"co_count": 60,
		"co_weight": 0.009551446735603906,
		"og_asset": 178230263.8236661,
		"og_count": 226,
		"og_weight": 0.06102779796545882,
		"mc50_asset": 26767987.759648565,
		"mc50_count": 12,
		"mc50_weight": 0.00916562268321567,
		"ut_asset": 64590802.96928818,
		"ut_count": 108,
		"ut_weight": 0.022116527179336782,
		"ff_hi_asset": 123935689.55043812,
		"ff_hi_count": 88,
		"ff_hi_weight": 0.042436800913210844,
		"ff_all_asset": 233641840.82144842,
		"ff_all_count": 307,
		"ff_all_weight": 0.080001267753473,
		"cl_asset": 346236033.8029679,
		"cl_count": 145,
		"cl_weight": 0.11855462852366361,
		"fossil_bank_asset": 136356874.9772856,
		"fossil_bank_count": 42,
		"fossil_bank_weight": 0.04668993715650969,
		"fossil_insure_asset": 72151407.61664212,
		"fossil_insure_count": 23,
		"fossil_insure_weight": 0.02470535268526726,
		"df_p_asset": 9464088.078371892,
		"df_p_count": 31,
		"df_p_weight": 0.003240596982707798,
		"df_c_asset": 189339895.6062898,
		"df_c_count": 125,
		"df_c_weight": 0.06483184532170008,
		"df_f_asset": 72461850.30324544,
		"df_f_count": 29,
		"df_f_weight": 0.024811651319132415,
		"df_all_asset": 268397984.78582874,
		"df_all_count": 173,
		"df_all_weight": 0.091902113807402,
		"equileap_count": 3011,
		"dei_asset": 1391131771.7248738,
		"dei_count": 1336,
		"dei_weight": 0.47633722178715265,
		"rji_asset": 1391131771.7248738,
		"rji_count": 1336,
		"rji_weight": 0.47633722178715265,
		"hrc_asset": 1187147819.2694216,
		"hrc_count": 640,
		"hrc_weight": 0.4064911071510697,
		"wff_gun_manufacturers_asset": 2290145.847381456,
		"wff_gun_manufacturers_count": 4,
		"wff_gun_manufacturers_weight": 0.0007841684969041254,
		"wff_gun_retailers_asset": 9187001.351693708,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.0031457197580892194,
		"wff_civ_asset": 11477147.199075162,
		"wff_civ_count": 7,
		"wff_civ_weight": 0.0039298882549933445,
		"wff_major_military_contractors_asset": 148238200.4354832,
		"wff_major_military_contractors_count": 123,
		"wff_major_military_contractors_weight": 0.050758220028727846,
		"wff_cluster_munitions_asset": 71897409.27685106,
		"wff_cluster_munitions_count": 23,
		"wff_cluster_munitions_weight": 0.02461838115174775,
		"wff_nuclear_weapons_asset": 98161825.2282212,
		"wff_nuclear_weapons_count": 53,
		"wff_nuclear_weapons_weight": 0.033611575887445365,
		"wff_mil_asset": 148238200.4354832,
		"wff_mil_count": 123,
		"wff_mil_weight": 0.050758220028727846,
		"wff_hi_asset": 120148867.26459615,
		"wff_hi_count": 58,
		"wff_hi_weight": 0.041140155660976334,
		"wff_all_asset": 157425843.87741905,
		"wff_all_count": 128,
		"wff_all_weight": 0.053904159644840806,
		"t_asset": 12954735.130929762,
		"t_count": 9,
		"t_weight": 0.004435828917633204,
		"t_m_asset": 19049869.884212293,
		"t_m_count": 6,
		"t_m_weight": 0.006522863096427822,
		"t_all_asset": 32004605.015142053,
		"t_all_count": 15,
		"t_all_weight": 0.010958692014061026,
		"ip_divest_asset": 74344575.52368256,
		"ip_divest_count": 51,
		"ip_divest_weight": 0.025456314980131015,
		"pp_divest_asset": 3572680.258726205,
		"pp_divest_count": 12,
		"pp_divest_weight": 0.0012233209127740447,
		"borders_divest_asset": 25212836.78183864,
		"borders_divest_count": 25,
		"borders_divest_weight": 0.008633123669616794,
		"pff_prisons_asset": 195627389.52435097,
		"pff_prisons_count": 41,
		"pff_prisons_weight": 0.0669847451733219,
		"pff_borders_asset": 196471834.49310687,
		"pff_borders_count": 50,
		"pff_borders_weight": 0.06727389144871074,
		"pff_high_asset": 25276484.232126858,
		"pff_high_count": 29,
		"pff_high_weight": 0.008654917183545769,
		"pff_extreme_asset": 24133.559534266627,
		"pff_extreme_count": 3,
		"pff_extreme_weight": 0.000008263568508778865,
		"pff_all_asset": 244887086.67389393,
		"pff_all_count": 72,
		"pff_all_weight": 0.08385175070306863,
		"pff_prisons_high_asset": 3572680.258726205,
		"pff_prisons_high_count": 12,
		"pff_prisons_high_weight": 0.0012233209127740447,
		"pff_borders_high_asset": 25212836.78183864,
		"pff_borders_high_count": 25,
		"pff_borders_high_weight": 0.008633123669616794,
		"fund_family_label": "Fidelity Investments",
		"fund_legal_name": "Fidelity Freedom Blend 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"fossil_bank_score": 19.3158,
		"fossil_insure_score": 20.1884,
		"grade_gender_equality": 3,
		"gef_grp_norm": 45.18518518518518,
		"gef_percent_rated": 0.7056827670732486,
		"gef_score": 53.866745257270196,
		"strategy_name": "Fidelity Freedom Blend Series",
		"net_assets": 2736251096,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 23903967934,
		"ticker": "FHEDX",
		"investment_vehicle_name": "Fidelity Freedom Blend 2050 K6",
		"legal_type": "FO",
		"prospectus_date": "2024-05-30",
		"investment_vehicle_id": "F000010OFJ",
		"tickers": "FHEDX, FFBWX, FHAPX, FHWEX, FHWDX, FHJKX, FHVEX, FHXEX, FHYEX",
		"strategy_fund_legal_names": "Fidelity Freedom Blend 2010 Fund, Fidelity Freedom Blend 2015 Fund, Fidelity Freedom Blend 2020 Fund, Fidelity Freedom Blend 2025 Fund, Fidelity Freedom Blend 2030 Fund, Fidelity Freedom Blend 2035 Fund, Fidelity Freedom Blend 2040 Fund, Fidelity Freedom Blend 2045 Fund, Fidelity Freedom Blend 2050 Fund, Fidelity Freedom Blend 2055 Fund, Fidelity Freedom Blend 2060 Fund, Fidelity Freedom Blend 2065 Fund, Fidelity Freedom Blend 2070 Fund, Fidelity Freedom Blend Income Fund",
		"strategy_tickers": "FHABX, FJAYX, FJAWX, FJAZX, FJAVX, FHAYX, FHFEX, FHPDX, FFBHX, FJAUX, FJASX, FJAQX, FJATX, FJAPX, FHAWX, FHEEX, FHODX, FFBJX, FJAOX, FJALX, FJAJX, FJANX, FJAIX, FHAVX, FHCEX, FHNDX, FFBLX, FJAHX, FJAEX, FJADX, FJAGX, FJABX, FHAUX, FHBEX, FHLDX, FFBNX, FJAMX, FJTMX, FJEFX, FTYJX, FJLMX, FHATX, FHAEX, FHKDX, FFBPX, FHJGX, FHVCX, FHGDX, FHBCX, FHSDX, FHASX, FHZDX, FHJDX, FFBRX, FHDEX, FHZEX, FHJFX, FHOEX, FHHFX, FHARX, FHYDX, FHHDX, FFBTX, FHGFX, FHDFX, FHCFX, FHEFX, FHBFX, FHAQX, FHXDX, FHFDX, FFBUX, FHJKX, FHXEX, FHWEX, FHYEX, FHVEX, FHAPX, FHWDX, FHEDX, FFBWX, FHUEX, FHREX, FHQEX, FHTEX, FHPEX, FHAOX, FHVDX, FHDDX, FFBZX, FHNEX, FHLEX, FHKEX, FHMEX, FHJEX, FHANX, FHTDX, FHCDX, FFCBX, FAZAX, FAXDX, FAXFX, FAXEX, FAXGX, FFBSX, FFBKX, FFBQX, FFCHX, FRBYX, FRCHX, FRCKX, FRCLX, FRBZX, FRCFX, FRCJX, FRCPX, FRCNX, FHAMX, FHAKX, FHAJX, FHALX, FHAHX, FHBZX, FHHEX, FHRDX, FFBCX",
		"strategy_name_query": "fidelity-freedom-blend-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0085
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00549
					},
					{
						"standard_name": "Imperial Oil Ltd",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00156
					},
					{
						"standard_name": "Canadian Natural Resources Ltd",
						"long_weight": 0.00151
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Vale SA",
						"long_weight": 0.00133
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00126
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00077
					},
					{
						"standard_name": "Anglo American PLC",
						"long_weight": 0.0007
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.0007
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0085
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00549
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00383
					},
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.00267
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00161
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0072
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00056
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00033
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00015
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0072
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00134
					},
					{
						"standard_name": "PG&E Corp",
						"long_weight": 0.00099
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00083
					},
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.00073
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0085
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0072
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00549
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00383
					},
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.00267
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00669
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00455
					},
					{
						"standard_name": "Banco Santander SA",
						"long_weight": 0.00293
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00276
					},
					{
						"standard_name": "China Construction Bank Corp",
						"long_weight": 0.00264
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0072
					},
					{
						"standard_name": "Tokio Marine Holdings Inc",
						"long_weight": 0.00245
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00244
					},
					{
						"standard_name": "Hannover Rueck SE",
						"long_weight": 0.00196
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.00191
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00077
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00071
					},
					{
						"standard_name": "Tyson Foods Inc",
						"long_weight": 0.00031
					},
					{
						"standard_name": "First Resources Ltd",
						"long_weight": 0.00025
					},
					{
						"standard_name": "Sumitomo Forestry Co Ltd",
						"long_weight": 0.00024
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00629
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00455
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00189
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.00174
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00147
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01454
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00549
					},
					{
						"standard_name": "Lvmh Moet Hennessy Louis Vuitton SE",
						"long_weight": 0.00341
					},
					{
						"standard_name": "Compass Group PLC",
						"long_weight": 0.00324
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00295
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 4,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00077
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00002
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00272
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00032
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.0001
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01807
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01454
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01378
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0072
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00272
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01807
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01454
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01378
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00295
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00177
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00177
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00104
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00089
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00077
					},
					{
						"standard_name": "Thomson Reuters Corp",
						"long_weight": 0.00066
					}
				]
			},
			"is_pff_extreme": {
				"count": 3,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00512
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00489
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00438
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00375
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00361
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00489
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00438
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00375
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00221
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00177
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00512
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00438
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00375
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00361
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00226
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00204
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00107
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00058
					},
					{
						"standard_name": "ITC Ltd",
						"long_weight": 0.00039
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00017
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00256
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00196
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00115
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00081
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00004
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"Glencore PLC"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"Airbus SE",
				"RTX Corp",
				"Lockheed Martin Corp"
			],
			"gff": [
				"Northrop Grumman Corp",
				"Olin Corp",
				"NOF Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FS0000AREA",
		"percent_rated": 0.8313003360625512,
		"percent_rated_long": 0.8313200342625441,
		"long_equity_assets": 1880454117.4612265,
		"long_cbond_assets": 11081328.622664811,
		"long_equity_weight": 0.8331623136732331,
		"long_cbond_weight": 0.004909742443648431,
		"c2_asset": 64106471.44700464,
		"c2_count": 142,
		"c2_weight": 0.02840329661662949,
		"co_asset": 28641500.30105738,
		"co_count": 162,
		"co_weight": 0.01269002973075391,
		"og_asset": 133689229.41989659,
		"og_count": 451,
		"og_weight": 0.059232940948887244,
		"mc50_asset": 21223445.601896025,
		"mc50_count": 31,
		"mc50_weight": 0.009403353624850301,
		"ut_asset": 64422219.38544104,
		"ut_count": 253,
		"ut_weight": 0.028543193293970596,
		"ff_hi_asset": 83595017.1819604,
		"ff_hi_count": 161,
		"ff_hi_weight": 0.03703797783745282,
		"ff_all_asset": 177223038.4347963,
		"ff_all_count": 649,
		"ff_all_weight": 0.0785212228086069,
		"cl_asset": 278106907.6752359,
		"cl_count": 192,
		"cl_weight": 0.1232192758630206,
		"fossil_bank_asset": 85495235.05510001,
		"fossil_bank_count": 63,
		"fossil_bank_weight": 0.037879896768080956,
		"fossil_insure_asset": 39213974.104512796,
		"fossil_insure_count": 25,
		"fossil_insure_weight": 0.017374316708853067,
		"df_p_asset": 10463309.407204371,
		"df_p_count": 69,
		"df_p_weight": 0.004635920118144042,
		"df_c_asset": 145622140.615344,
		"df_c_count": 149,
		"df_c_weight": 0.0645199893315826,
		"df_f_asset": 60070455.60128439,
		"df_f_count": 35,
		"df_f_weight": 0.026615081595152662,
		"df_all_asset": 212121623.04033875,
		"df_all_count": 235,
		"df_all_weight": 0.09398354397022618,
		"equileap_count": 3424,
		"dei_asset": 1066023886.9231654,
		"dei_count": 2918,
		"dei_weight": 0.4723172556100141,
		"rji_asset": 1066023886.9231654,
		"rji_count": 2918,
		"rji_weight": 0.4723172556100141,
		"hrc_asset": 832943255.8377836,
		"hrc_count": 749,
		"hrc_weight": 0.3690475208878011,
		"wff_gun_manufacturers_asset": 1496594.4779527117,
		"wff_gun_manufacturers_count": 12,
		"wff_gun_manufacturers_weight": 0.0006630877649730138,
		"wff_gun_retailers_asset": 6691244.6250979975,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.00296465242168568,
		"wff_civ_asset": 8187839.10305071,
		"wff_civ_count": 15,
		"wff_civ_weight": 0.003627740186658694,
		"wff_major_military_contractors_asset": 70291510.06624304,
		"wff_major_military_contractors_count": 204,
		"wff_major_military_contractors_weight": 0.031143667167717513,
		"wff_cluster_munitions_asset": 26178165.141957678,
		"wff_cluster_munitions_count": 30,
		"wff_cluster_munitions_weight": 0.01159861356619522,
		"wff_nuclear_weapons_asset": 39676860.1759816,
		"wff_nuclear_weapons_count": 74,
		"wff_nuclear_weapons_weight": 0.017579405057827374,
		"wff_mil_asset": 70291510.06624304,
		"wff_mil_count": 204,
		"wff_mil_weight": 0.031143667167717513,
		"wff_hi_asset": 47147764.68995384,
		"wff_hi_count": 84,
		"wff_hi_weight": 0.0208894970362993,
		"wff_all_asset": 77154661.74623251,
		"wff_all_count": 210,
		"wff_all_weight": 0.03418448548904423,
		"t_asset": 10151650.090722814,
		"t_count": 18,
		"t_weight": 0.004497834963719663,
		"t_m_asset": 12493905.07929759,
		"t_m_count": 8,
		"t_m_weight": 0.005535604812700767,
		"t_all_asset": 22645555.1700204,
		"t_all_count": 26,
		"t_all_weight": 0.01003343977642043,
		"ip_divest_asset": 38395377.31729386,
		"ip_divest_count": 54,
		"ip_divest_weight": 0.017011625597768903,
		"pp_divest_asset": 3676137.3336352985,
		"pp_divest_count": 17,
		"pp_divest_weight": 0.0016287656570994685,
		"borders_divest_asset": 19218857.05808691,
		"borders_divest_count": 29,
		"borders_divest_weight": 0.008515191763513475,
		"pff_prisons_asset": 149290935.28891912,
		"pff_prisons_count": 49,
		"pff_prisons_weight": 0.06614550171725819,
		"pff_borders_asset": 145876411.74166802,
		"pff_borders_count": 57,
		"pff_borders_weight": 0.06463264782079606,
		"pff_high_asset": 19743871.580637813,
		"pff_high_count": 34,
		"pff_high_weight": 0.008747807018657863,
		"pff_extreme_asset": 491702.2201332475,
		"pff_extreme_count": 5,
		"pff_extreme_weight": 0.00021785575918096227,
		"pff_all_asset": 185970538.0136374,
		"pff_all_count": 83,
		"pff_all_weight": 0.08239692863960181,
		"pff_prisons_high_asset": 3676137.3336352985,
		"pff_prisons_high_count": 17,
		"pff_prisons_high_weight": 0.0016287656570994685,
		"pff_borders_high_asset": 19218857.05808691,
		"pff_borders_high_count": 29,
		"pff_borders_high_weight": 0.008515191763513475,
		"fund_family_label": "State Street",
		"fund_legal_name": "State Street Target Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-02-28",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"fossil_bank_score": 13.8745,
		"fossil_insure_score": 14.1015,
		"grade_gender_equality": 5,
		"gef_grp_norm": 17.037037037037038,
		"gef_percent_rated": 0.7000540011073629,
		"gef_score": 52.93687646004952,
		"strategy_name": "State Street Target Retirement Series",
		"net_assets": 2256954651,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 19878988614,
		"ticker": "SSDLX",
		"investment_vehicle_name": "State Street Target Retirement 2050 K",
		"legal_type": "FO",
		"prospectus_date": "2025-04-30",
		"investment_vehicle_id": "F00000T8XK",
		"tickers": "SSDLX, SSAUX, SSDJX",
		"strategy_fund_legal_names": "State Street Target Retirement 2025 Fund, State Street Target Retirement 2030 Fund, State Street Target Retirement 2035 Fund, State Street Target Retirement 2040 Fund, State Street Target Retirement 2045 Fund, State Street Target Retirement 2050 Fund, State Street Target Retirement 2055 Fund, State Street Target Retirement 2060 Fund, State Street Target Retirement 2065 Fund, State Street Target Retirement 2070 Fund, State Street Target Retirement Fund",
		"strategy_tickers": "SSBRX, SSBSX, SSAHX, SSBWX, SSBYX, SSAJX, SSCJX, SSCKX, SSAZX, SSCNX, SSCQX, SSAKX, SSDDX, SSDEX, SSAOX, SSDJX, SSDLX, SSAUX, SSDOX, SSDQX, SSAWX, SSDWX, SSDYX, SSAYX, SSFJX, SSFKX, SSFPX, SSGQX, SSGNX, SSGUX, SSFNX, SSFOX, SSFQX",
		"strategy_name_query": "state-street-target-retirement-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0036
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00255
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00195
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.0016
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00141
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00141
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00055
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00044
					},
					{
						"standard_name": "Vale SA",
						"long_weight": 0.00042
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0036
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00255
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00202
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00195
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.0016
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00066
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00041
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00023
					},
					{
						"standard_name": "China Shenhua Energy Co Ltd",
						"long_weight": 0.00019
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00102
					},
					{
						"standard_name": "Enel SpA",
						"long_weight": 0.00076
					},
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.00073
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00071
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0036
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00255
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00202
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00195
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00233
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00192
					},
					{
						"standard_name": "Royal Bank of Canada",
						"long_weight": 0.00183
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00183
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.0018
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.0017
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00117
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00097
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00087
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00064
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00044
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00027
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00018
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00477
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00233
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00192
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00183
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.0018
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01246
					},
					{
						"standard_name": "Nestle SA",
						"long_weight": 0.00305
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00292
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00278
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00278
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00049
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00006
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0.00004
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0.00001
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00265
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00025
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00007
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01937
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01246
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.0114
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00678
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00292
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01937
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01246
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.0114
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00233
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00179
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00123
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00121
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.0012
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00066
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00051
					}
				]
			},
			"is_pff_extreme": {
				"count": 5,
				"list": [
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00007
					},
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00007
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00004
					},
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0.00002
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0.00002
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.0015
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.0014
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00123
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.0012
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.0011
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.0014
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00123
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.0012
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00109
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00096
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.0015
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00123
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.0012
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00109
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00096
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00172
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00094
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00071
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00038
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00034
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.0018
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00142
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00125
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00097
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00005
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"JBS SA",
				"Tyson Foods Inc"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"RTX Corp"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FS00009GKH",
		"percent_rated": 0.8882173012925059,
		"percent_rated_long": 0.8882649950294292,
		"long_equity_assets": 1707680165.8279397,
		"long_cbond_assets": 57328018.30500274,
		"long_equity_weight": 0.8877565866477524,
		"long_cbond_weight": 0.029802609919670955,
		"c2_asset": 57623160.426348075,
		"c2_count": 101,
		"c2_weight": 0.029956042844327825,
		"co_asset": 26137316.75030271,
		"co_count": 103,
		"co_weight": 0.013587775724460674,
		"og_asset": 112145172.04178092,
		"og_count": 250,
		"og_weight": 0.05829991888004834,
		"mc50_asset": 24817899.112194438,
		"mc50_count": 25,
		"mc50_weight": 0.012901861744659928,
		"ut_asset": 67267945.65555927,
		"ut_count": 170,
		"ut_weight": 0.03496999205178023,
		"ff_hi_asset": 81284010.68584216,
		"ff_hi_count": 117,
		"ff_hi_weight": 0.042256399833816016,
		"ff_all_asset": 156959654.4126638,
		"ff_all_count": 370,
		"ff_all_weight": 0.08159722753191294,
		"cl_asset": 309283709.03059036,
		"cl_count": 148,
		"cl_weight": 0.16078458679153984,
		"fossil_bank_asset": 76168442.26657148,
		"fossil_bank_count": 53,
		"fossil_bank_weight": 0.0395970145170972,
		"fossil_insure_asset": 43886680.478468224,
		"fossil_insure_count": 23,
		"fossil_insure_weight": 0.0228149804866862,
		"df_p_asset": 9699421.383149805,
		"df_p_count": 43,
		"df_p_weight": 0.005042352421648306,
		"df_c_asset": 162878877.1405132,
		"df_c_count": 129,
		"df_c_weight": 0.08467440150724906,
		"df_f_asset": 63710845.75631639,
		"df_f_count": 34,
		"df_f_weight": 0.03312079398289835,
		"df_all_asset": 232239654.20515537,
		"df_all_count": 193,
		"df_all_weight": 0.12073237531658274,
		"equileap_count": 2156,
		"dei_asset": 1110320798.7210124,
		"dei_count": 1807,
		"dei_weight": 0.5772126549696586,
		"rji_asset": 1110320798.7210124,
		"rji_count": 1807,
		"rji_weight": 0.5772126549696586,
		"hrc_asset": 929864771.1148949,
		"hrc_count": 679,
		"hrc_weight": 0.4834005756860952,
		"wff_gun_manufacturers_asset": 1429025.9868551784,
		"wff_gun_manufacturers_count": 2,
		"wff_gun_manufacturers_weight": 0.0007428951027878318,
		"wff_gun_retailers_asset": 7793254.636091628,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.004051410371250141,
		"wff_civ_asset": 9222280.622946806,
		"wff_civ_count": 5,
		"wff_civ_weight": 0.0047943054740379725,
		"wff_major_military_contractors_asset": 64526634.6617334,
		"wff_major_military_contractors_count": 120,
		"wff_major_military_contractors_weight": 0.03354489094706668,
		"wff_cluster_munitions_asset": 25016762.473268915,
		"wff_cluster_munitions_count": 22,
		"wff_cluster_munitions_weight": 0.01300524308161607,
		"wff_nuclear_weapons_asset": 38310461.53694927,
		"wff_nuclear_weapons_count": 50,
		"wff_nuclear_weapons_weight": 0.019916120856537992,
		"wff_mil_asset": 64526634.6617334,
		"wff_mil_count": 120,
		"wff_mil_weight": 0.03354489094706668,
		"wff_hi_asset": 42932513.60289352,
		"wff_hi_count": 56,
		"wff_hi_weight": 0.02231894619086016,
		"wff_all_asset": 72319889.29782502,
		"wff_all_count": 123,
		"wff_all_weight": 0.03759630131831682,
		"t_asset": 11271415.090206381,
		"t_count": 9,
		"t_weight": 0.005859570888861506,
		"t_m_asset": 14508530.003018793,
		"t_m_count": 8,
		"t_m_weight": 0.007542421192502284,
		"t_all_asset": 25779945.093225174,
		"t_all_count": 17,
		"t_all_weight": 0.01340199208136379,
		"ip_divest_asset": 44277145.905816235,
		"ip_divest_count": 29,
		"ip_divest_weight": 0.023017968295482562,
		"pp_divest_asset": 3807460.1258542407,
		"pp_divest_count": 10,
		"pp_divest_weight": 0.0019793506259335155,
		"borders_divest_asset": 19778986.575225353,
		"borders_divest_count": 22,
		"borders_divest_weight": 0.010282326843598743,
		"pff_prisons_asset": 180203406.79477066,
		"pff_prisons_count": 39,
		"pff_prisons_weight": 0.09368075153631591,
		"pff_borders_asset": 171809744.85896662,
		"pff_borders_count": 49,
		"pff_borders_weight": 0.08931721273161719,
		"pff_high_asset": 20158891.133458637,
		"pff_high_count": 24,
		"pff_high_weight": 0.010479824466759099,
		"pff_extreme_asset": 386399.4245902806,
		"pff_extreme_count": 3,
		"pff_extreme_weight": 0.00020087405189871224,
		"pff_all_asset": 219755445.12954208,
		"pff_all_count": 69,
		"pff_all_weight": 0.1142423199433683,
		"pff_prisons_high_asset": 3807460.1258542407,
		"pff_prisons_high_count": 10,
		"pff_prisons_high_weight": 0.0019793506259335155,
		"pff_borders_high_asset": 19778986.575225353,
		"pff_borders_high_count": 22,
		"pff_borders_high_weight": 0.010282326843598743,
		"fund_family_label": "JPMorgan",
		"fund_legal_name": "JPMorgan SmartRetirement® Blend 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"fossil_bank_score": 14.3365,
		"fossil_insure_score": 18.8915,
		"grade_gender_equality": 2,
		"gef_grp_norm": 67.4074074074074,
		"gef_percent_rated": 0.7961574385948652,
		"gef_score": 54.31407683685242,
		"strategy_name": "JPMorgan SmartRetirement Blend Series",
		"net_assets": 1923487244,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 17366392026,
		"ticker": "JNYAX",
		"investment_vehicle_name": "JPMorgan SmartRetirement® Blend 2050 R6",
		"legal_type": "FO",
		"prospectus_date": "2024-11-01",
		"investment_vehicle_id": "F00000O314",
		"tickers": "JNYAX, JNTPX, JNTKX, JNABX, JNNRX, JNEAX",
		"strategy_fund_legal_names": "JPMorgan SmartRetirement® Blend 2025 Fund, JPMorgan SmartRetirement® Blend 2030 Fund, JPMorgan SmartRetirement® Blend 2035 Fund, JPMorgan SmartRetirement® Blend 2040 Fund, JPMorgan SmartRetirement® Blend 2045 Fund, JPMorgan SmartRetirement® Blend 2050 Fund, JPMorgan SmartRetirement® Blend 2055 Fund, JPMorgan SmartRetirement® Blend 2060 Fund, JPMorgan SmartRetirement® Blend Income Fund, JPMorgan Smartretirement® Blend 2065 Fund",
		"strategy_tickers": "JBSSX, JBRSX, JBTUX, JBTBX, JBBSX, JBYSX, JRBEX, JRBRX, JUTPX, JUTUX, JRBBX, JRBYX, JPSRX, JPRRX, JPTLX, JPTKX, JPBRX, JPYRX, JOBEX, JOBRX, JNTEX, JNTNX, JOBBX, JOBYX, JMSSX, JNARX, JNTOX, JNTLX, JMBRX, JMYAX, JNEAX, JNNRX, JNTKX, JNTPX, JNABX, JNYAX, JPTBX, JTRBX, JTTUX, JTTLX, JTBBX, JTYBX, JACSX, JATPX, JATQX, JATUX, JAABX, JAAYX, JIRBX, JITLX, JITKX, JIBBX, JIYBX, JIJSX, JSBSX, JSBZX, JSBPX, JSBQX, JSMDX, JSBYX",
		"strategy_name_query": "jpmorgan-smartretirement-blend-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00522
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00282
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00254
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00157
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00153
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00157
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00098
					},
					{
						"standard_name": "Mitsui & Co Ltd",
						"long_weight": 0.00077
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00059
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00057
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00522
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00282
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00254
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.0022
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00153
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00985
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00095
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.00059
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00027
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00024
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00985
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00147
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00102
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00098
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00095
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00985
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00522
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00282
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00254
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.0022
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00279
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00259
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00238
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00232
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.0019
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00985
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00208
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00133
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.0012
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.00114
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00098
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00094
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.00042
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00039
					},
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00028
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00692
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00279
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00259
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00232
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.0019
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01811
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00424
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00403
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00403
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00384
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 2,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00004
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00384
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00017
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00004
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02816
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01811
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01655
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00985
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00424
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.02816
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01811
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01655
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00259
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00259
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00178
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00175
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00129
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00094
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00074
					}
				]
			},
			"is_pff_extreme": {
				"count": 3,
				"list": [
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0.00008
					},
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00007
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0.00005
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00217
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00178
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00129
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00178
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00129
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00119
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00096
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00217
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00178
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00129
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00129
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00249
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00112
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00103
					},
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00045
					},
					{
						"standard_name": "Japan Tobacco Inc",
						"long_weight": 0.00044
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00207
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00205
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.0018
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.0014
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00017
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"JBS SA",
				"Tyson Foods Inc"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"RTX Corp"
			],
			"gff": [
				"Northrop Grumman Corp",
				"Olin Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA0720K",
		"percent_rated": 0.788785547219424,
		"percent_rated_long": 0.8379593714407626,
		"long_equity_assets": 1544193791.6835053,
		"long_cbond_assets": 13503416.762123067,
		"long_equity_weight": 0.8373163578483996,
		"long_cbond_weight": 0.007322029011296076,
		"c2_asset": 67342090.78610711,
		"c2_count": 82,
		"c2_weight": 0.03651525766428956,
		"co_asset": 18305322.667790573,
		"co_count": 61,
		"co_weight": 0.009925791819642035,
		"og_asset": 113624926.59675215,
		"og_count": 274,
		"og_weight": 0.06161144424435295,
		"mc50_asset": 16758675.829577656,
		"mc50_count": 11,
		"mc50_weight": 0.009087145333414216,
		"ut_asset": 39157140.349577464,
		"ut_count": 102,
		"ut_weight": 0.021232383084199544,
		"ff_hi_asset": 82776776.38250765,
		"ff_hi_count": 90,
		"ff_hi_weight": 0.044884488778749364,
		"ff_all_asset": 150011128.00966093,
		"ff_all_count": 364,
		"ff_all_weight": 0.0813413264696789,
		"cl_asset": 188956453.74234217,
		"cl_count": 99,
		"cl_weight": 0.10245885619511365,
		"fossil_bank_asset": 93430125.59641501,
		"fossil_bank_count": 29,
		"fossil_bank_weight": 0.050661110606085594,
		"fossil_insure_asset": 51675533.36576199,
		"fossil_insure_count": 18,
		"fossil_insure_weight": 0.0280202974657222,
		"df_p_asset": 7073024.988938482,
		"df_p_count": 19,
		"df_p_weight": 0.0038352437074960864,
		"df_c_asset": 110236236.90952596,
		"df_c_count": 87,
		"df_c_weight": 0.059773977132344114,
		"df_f_asset": 44166605.33013874,
		"df_f_count": 19,
		"df_f_weight": 0.02394869174628771,
		"df_all_asset": 160155501.32171276,
		"df_all_count": 119,
		"df_all_weight": 0.08684196360476373,
		"equileap_count": 2897,
		"dei_asset": 834657108.1508387,
		"dei_count": 2984,
		"dei_weight": 0.452580533358586,
		"rji_asset": 834657108.1508387,
		"rji_count": 2984,
		"rji_weight": 0.452580533358586,
		"hrc_asset": 742631225.3072445,
		"hrc_count": 750,
		"hrc_weight": 0.4026808527191661,
		"wff_gun_manufacturers_asset": 2376785.539316212,
		"wff_gun_manufacturers_count": 9,
		"wff_gun_manufacturers_weight": 0.001288776979861661,
		"wff_gun_retailers_asset": 4855902.409728806,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.002633041618013922,
		"wff_civ_asset": 7232687.949045017,
		"wff_civ_count": 12,
		"wff_civ_weight": 0.003921818597875583,
		"wff_major_military_contractors_asset": 103171679.06347,
		"wff_major_military_contractors_count": 144,
		"wff_major_military_contractors_weight": 0.05594332460846628,
		"wff_cluster_munitions_asset": 45859638.27185654,
		"wff_cluster_munitions_count": 21,
		"wff_cluster_munitions_weight": 0.024866713942796485,
		"wff_nuclear_weapons_asset": 69490267.18485534,
		"wff_nuclear_weapons_count": 52,
		"wff_nuclear_weapons_weight": 0.03768007470208816,
		"wff_mil_asset": 103171679.06347,
		"wff_mil_count": 144,
		"wff_mil_weight": 0.05594332460846628,
		"wff_hi_asset": 84704885.10125124,
		"wff_hi_count": 56,
		"wff_hi_weight": 0.04592997735577184,
		"wff_all_asset": 108027986.66385913,
		"wff_all_count": 150,
		"wff_all_weight": 0.05857658593515262,
		"t_asset": 5540991.508812855,
		"t_count": 9,
		"t_weight": 0.0030045210996282796,
		"t_m_asset": 11385677.772723434,
		"t_m_count": 9,
		"t_m_weight": 0.006173716210773507,
		"t_all_asset": 16926669.28153629,
		"t_all_count": 18,
		"t_all_weight": 0.009178237310401786,
		"ip_divest_asset": 47353718.777069815,
		"ip_divest_count": 48,
		"ip_divest_weight": 0.02567685710856689,
		"pp_divest_asset": 664938.933166953,
		"pp_divest_count": 14,
		"pp_divest_weight": 0.0003605533506930889,
		"borders_divest_asset": 12671926.699214272,
		"borders_divest_count": 27,
		"borders_divest_weight": 0.006871165761611011,
		"pff_prisons_asset": 120966233.08080657,
		"pff_prisons_count": 46,
		"pff_prisons_weight": 0.06559215964431303,
		"pff_borders_asset": 122398181.17612988,
		"pff_borders_count": 52,
		"pff_borders_weight": 0.06636861242521491,
		"pff_high_asset": 12672308.278190745,
		"pff_high_count": 30,
		"pff_high_weight": 0.006871372667195357,
		"pff_extreme_asset": 387.4216462385968,
		"pff_extreme_count": 4,
		"pff_extreme_weight": 2.100736860407092e-7,
		"pff_all_asset": 148515012.3744769,
		"pff_all_count": 76,
		"pff_all_weight": 0.0805300797846326,
		"pff_prisons_high_asset": 664938.933166953,
		"pff_prisons_high_count": 14,
		"pff_prisons_high_weight": 0.0003605533506930889,
		"pff_borders_high_asset": 12671926.699214272,
		"pff_borders_high_count": 27,
		"pff_borders_high_weight": 0.006871165761611011,
		"fund_family_label": "Fidelity Investments",
		"fund_legal_name": "Fidelity Advisor Freedom 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"fossil_bank_score": 22.1089,
		"fossil_insure_score": 23.1519,
		"grade_gender_equality": 2,
		"gef_grp_norm": 62.59259259259259,
		"gef_percent_rated": 0.6982858832450948,
		"gef_score": 54.22584325951847,
		"strategy_name": "Fidelity Advisor Freedom Series",
		"net_assets": 1729247148,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 17924529972,
		"ticker": "FFFLX",
		"investment_vehicle_name": "Fidelity Advisor Freedom 2050 A",
		"legal_type": "FO",
		"prospectus_date": "2024-05-30",
		"investment_vehicle_id": "FOUSA05HWG",
		"tickers": "FFFLX, FVGLX, FIJRX, FFFQX, FFFPX, FFFYX",
		"strategy_fund_legal_names": "Fidelity Advisor Freedom 2010 Fund, Fidelity Advisor Freedom 2015 Fund, Fidelity Advisor Freedom 2020 Fund, Fidelity Advisor Freedom 2025 Fund, Fidelity Advisor Freedom 2030 Fund, Fidelity Advisor Freedom 2035 Fund, Fidelity Advisor Freedom 2040 Fund, Fidelity Advisor Freedom 2045 Fund, Fidelity Advisor Freedom 2050 Fund, Fidelity Advisor Freedom 2055 Fund, Fidelity Advisor Freedom 2060 Fund, Fidelity Advisor Freedom 2065 Fund, Fidelity Advisor Freedom 2070 Fund, Fidelity Advisor Freedom Income Fund",
		"strategy_tickers": "FACFX, FCFCX, FCIFX, FUGLX, FCFTX, FIJJX, FFVAX, FFVCX, FFVIX, FIGLX, FFVTX, FIJKX, FDAFX, FDCFX, FDIFX, FOGLX, FDTFX, FIJLX, FATWX, FCTWX, FITWX, FPGLX, FTTWX, FIJMX, FAFEX, FCFEX, FEFIX, FDGLX, FTFEX, FIJNX, FATHX, FCTHX, FITHX, FHGLX, FTTHX, FIJOX, FAFFX, FCFFX, FIFFX, FKGLX, FTFFX, FIJPX, FFFZX, FFFJX, FFFIX, FCGLX, FFFTX, FIJQX, FFFLX, FFFYX, FFFPX, FVGLX, FFFQX, FIJRX, FHFAX, FHFCX, FHFIX, FBGLX, FHFTX, FIJSX, FDKPX, FDKSX, FDKQX, FNGLX, FDKTX, FIJTX, FDFZX, FDFYX, FDFSX, FDFRX, FDFVX, FDFQX, FRBJX, FRBLX, FRBNX, FRBPX, FRBKX, FRBOX, FAFAX, FCAFX, FIAFX, FEGLX, FTAFX, FIJUX",
		"strategy_name_query": "fidelity-advisor-freedom-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.01029
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00701
					},
					{
						"standard_name": "Imperial Oil Ltd",
						"long_weight": 0.00237
					},
					{
						"standard_name": "Canadian Natural Resources Ltd",
						"long_weight": 0.00165
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.0014
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Vale SA",
						"long_weight": 0.00149
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00123
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.0008
					},
					{
						"standard_name": "Anglo American PLC",
						"long_weight": 0.00074
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00069
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.01029
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00701
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00562
					},
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.0026
					},
					{
						"standard_name": "Imperial Oil Ltd",
						"long_weight": 0.00237
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0074
					},
					{
						"standard_name": "NTPC Ltd",
						"long_weight": 0.00069
					},
					{
						"standard_name": "American Electric Power Co Inc",
						"long_weight": 0.0004
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00034
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00015
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0074
					},
					{
						"standard_name": "PG&E Corp",
						"long_weight": 0.00154
					},
					{
						"standard_name": "Southern Co",
						"long_weight": 0.00118
					},
					{
						"standard_name": "Constellation Energy Corp",
						"long_weight": 0.00082
					},
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.00077
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.01029
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0074
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00701
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00562
					},
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.0026
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00999
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00599
					},
					{
						"standard_name": "Banco Santander SA",
						"long_weight": 0.00318
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00298
					},
					{
						"standard_name": "China Construction Bank Corp",
						"long_weight": 0.00263
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0074
					},
					{
						"standard_name": "Chubb Ltd",
						"long_weight": 0.0038
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Tokio Marine Holdings Inc",
						"long_weight": 0.00265
					},
					{
						"standard_name": "Hannover Rueck SE",
						"long_weight": 0.00218
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "International Paper Co",
						"long_weight": 0.00101
					},
					{
						"standard_name": "Glencore PLC",
						"long_weight": 0.0008
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00075
					},
					{
						"standard_name": "Sumitomo Forestry Co Ltd",
						"long_weight": 0.00027
					},
					{
						"standard_name": "Tyson Foods Inc",
						"long_weight": 0.00025
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00599
					},
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00535
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00189
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.00181
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00134
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0161
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00701
					},
					{
						"standard_name": "Lowe's Companies Inc",
						"long_weight": 0.00415
					},
					{
						"standard_name": "Compass Group PLC",
						"long_weight": 0.00355
					},
					{
						"standard_name": "Lvmh Moet Hennessy Louis Vuitton SE",
						"long_weight": 0.0035
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00115
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0.00014
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Sturm Ruger & Co Inc",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00168
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00056
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.0004
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01802
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0161
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.0135
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.0074
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00168
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01802
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0161
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.0135
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00339
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00193
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00193
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00115
					},
					{
						"standard_name": "Thomson Reuters Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00067
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00044
					}
				]
			},
			"is_pff_extreme": {
				"count": 4,
				"list": [
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0
					},
					{
						"standard_name": "The GEO Group Inc",
						"long_weight": 0
					},
					{
						"standard_name": "CoreCivic Inc",
						"long_weight": 0
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00842
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00555
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00478
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00477
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00412
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00555
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00478
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00412
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00237
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00193
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00842
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00478
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00477
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00412
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00271
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Imperial Brands PLC",
						"long_weight": 0.00118
					},
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00117
					},
					{
						"standard_name": "ITC Ltd",
						"long_weight": 0.00039
					},
					{
						"standard_name": "KT&G Corp",
						"long_weight": 0.00014
					},
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00008
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00326
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00172
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00066
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00053
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"International Paper Co"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"CoreCivic Inc",
				"The GEO Group Inc",
				"Airbus SE"
			],
			"gff": [
				"Smith & Wesson Brands Inc",
				"Sturm Ruger & Co Inc",
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA08UTQ",
		"percent_rated": 0.6822926069024534,
		"percent_rated_long": 0.699171118502353,
		"long_equity_assets": 804845944.9034245,
		"long_cbond_assets": 111034232.8370053,
		"long_equity_weight": 0.7016551999506769,
		"long_cbond_weight": 0.09679833430976324,
		"c2_asset": 17343854.691361465,
		"c2_count": 55,
		"c2_weight": 0.015120167913429634,
		"co_asset": 6157252.550463238,
		"co_count": 39,
		"co_weight": 0.0053678201360143505,
		"og_asset": 52739967.15713606,
		"og_count": 181,
		"og_weight": 0.04597808119101947,
		"mc50_asset": 9327360.957989218,
		"mc50_count": 10,
		"mc50_weight": 0.00813148324773552,
		"ut_asset": 24662812.38132694,
		"ut_count": 88,
		"ut_weight": 0.021500748885356476,
		"ff_hi_asset": 26527292.747860305,
		"ff_hi_count": 63,
		"ff_hi_weight": 0.023126180873512987,
		"ff_all_asset": 65853145.04264288,
		"ff_all_count": 237,
		"ff_all_weight": 0.05740999497465433,
		"cl_asset": 120778861.92417519,
		"cl_count": 96,
		"cl_weight": 0.10529358698998119,
		"fossil_bank_asset": 29420470.315977853,
		"fossil_bank_count": 31,
		"fossil_bank_weight": 0.02564841894640769,
		"fossil_insure_asset": 9105651.746313266,
		"fossil_insure_count": 18,
		"fossil_insure_weight": 0.00793819977251336,
		"df_p_asset": 2042621.2021434489,
		"df_p_count": 21,
		"df_p_weight": 0.0017807330671032067,
		"df_c_asset": 73296283.34177235,
		"df_c_count": 90,
		"df_c_weight": 0.0638988351366842,
		"df_f_asset": 22088800.720825937,
		"df_f_count": 21,
		"df_f_weight": 0.019256755885502422,
		"df_all_asset": 96384597.34461589,
		"df_all_count": 122,
		"df_all_weight": 0.08402695491013114,
		"equileap_count": 2443,
		"dei_asset": 537299623.9106873,
		"dei_count": 1185,
		"dei_weight": 0.46841147356928525,
		"rji_asset": 537299623.9106873,
		"rji_count": 1185,
		"rji_weight": 0.46841147356928525,
		"hrc_asset": 433702614.6482962,
		"hrc_count": 605,
		"hrc_weight": 0.37809682303449577,
		"wff_gun_manufacturers_asset": 6245.39705284001,
		"wff_gun_manufacturers_count": 4,
		"wff_gun_manufacturers_weight": 0.000005444663473340412,
		"wff_gun_retailers_asset": 39408.05122902309,
		"wff_gun_retailers_count": 2,
		"wff_gun_retailers_weight": 0.00003435547416230644,
		"wff_civ_asset": 45653.4482818631,
		"wff_civ_count": 6,
		"wff_civ_weight": 0.000039800137635646856,
		"wff_major_military_contractors_asset": 23686916.304878566,
		"wff_major_military_contractors_count": 94,
		"wff_major_military_contractors_weight": 0.020649974198613627,
		"wff_cluster_munitions_asset": 9601130.25444493,
		"wff_cluster_munitions_count": 17,
		"wff_cluster_munitions_weight": 0.008370152090712717,
		"wff_nuclear_weapons_asset": 10506469.129993383,
		"wff_nuclear_weapons_count": 37,
		"wff_nuclear_weapons_weight": 0.009159415842078569,
		"wff_mil_asset": 23686916.304878566,
		"wff_mil_count": 94,
		"wff_mil_weight": 0.020649974198613627,
		"wff_hi_asset": 13450775.91368443,
		"wff_hi_count": 40,
		"wff_hi_weight": 0.011726227761935812,
		"wff_all_asset": 23726326.990939733,
		"wff_all_count": 98,
		"wff_all_weight": 0.02068433196979151,
		"t_asset": 1714773.1820024522,
		"t_count": 6,
		"t_weight": 0.0014949190307871423,
		"t_m_asset": 1089843.9820549986,
		"t_m_count": 6,
		"t_m_weight": 0.0009501131266003951,
		"t_all_asset": 2804617.164057451,
		"t_all_count": 12,
		"t_all_weight": 0.0024450321573875372,
		"ip_divest_asset": 12201717.982794618,
		"ip_divest_count": 42,
		"ip_divest_weight": 0.01063731379299778,
		"pp_divest_asset": 3273443.632313408,
		"pp_divest_count": 10,
		"pp_divest_weight": 0.0028537495416389737,
		"borders_divest_asset": 10725342.809447937,
		"borders_divest_count": 21,
		"borders_divest_weight": 0.009350227333761058,
		"pff_prisons_asset": 60201261.03489405,
		"pff_prisons_count": 36,
		"pff_prisons_weight": 0.05248274917231524,
		"pff_borders_asset": 69651082.92012982,
		"pff_borders_count": 41,
		"pff_borders_weight": 0.06072099241174536,
		"pff_high_asset": 10804075.458752848,
		"pff_high_count": 24,
		"pff_high_weight": 0.009418865528611271,
		"pff_extreme_asset": 78732.64930491144,
		"pff_extreme_count": 3,
		"pff_extreme_weight": 0.0000686381948502119,
		"pff_all_asset": 75107640.77218948,
		"pff_all_count": 60,
		"pff_all_weight": 0.06547795517582908,
		"pff_prisons_high_asset": 3273443.632313408,
		"pff_prisons_high_count": 10,
		"pff_prisons_high_weight": 0.0028537495416389737,
		"pff_borders_high_asset": 10725342.809447937,
		"pff_borders_high_count": 21,
		"pff_borders_high_weight": 0.009350227333761058,
		"fund_family_label": "American Century Investments",
		"fund_legal_name": "American Century Investments One Choice 2050 Portfolio",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 3,
		"grade_tobacco": 3,
		"fossil_bank_score": 8.4208,
		"fossil_insure_score": 6.0288,
		"grade_gender_equality": 4,
		"gef_grp_norm": 31.48148148148148,
		"gef_percent_rated": 0.6257753983811896,
		"gef_score": 53.55907978798107,
		"strategy_name": "American Century One Choice Series",
		"net_assets": 1118691512,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 0,
		"strategy_net_assets": 11289965712,
		"ticker": "ARFWX",
		"investment_vehicle_name": "American Century One Choice 2050 R",
		"legal_type": "FO",
		"prospectus_date": "2024-12-01",
		"investment_vehicle_id": "FOUSA06UA8",
		"tickers": "ARFWX, ARFEX, ARFVX, ARFSX, ARFMX, ARFDX",
		"strategy_fund_legal_names": "American Century Investments One Choice 2025 Portfolio, American Century Investments One Choice 2030 Portfolio, American Century Investments One Choice 2035 Portfolio, American Century Investments One Choice 2040 Portfolio, American Century Investments One Choice 2045 Portfolio, American Century Investments One Choice 2050 Portfolio, American Century Investments One Choice 2055 Portfolio, American Century Investments One Choice 2060 Portfolio, American Century Investments One Choice 2065 Portfolio, American Century Investments One Choice In Retirement Portfolio",
		"strategy_tickers": "ARWAX, ARWCX, ARWFX, ARWIX, ARWRX, ARWDX, ARCMX, ARWOX, ARCSX, ARCVX, ARCRX, ARCUX, ARYAX, ARLCX, ARLIX, ARYIX, ARYRX, ARLDX, ARDMX, ARNOX, ARDSX, ARDVX, ARDRX, ARDUX, AROAX, AROCX, AOOIX, AROIX, ARORX, ARDOX, ARFMX, ARFDX, ARFSX, ARFVX, ARFWX, ARFEX, AREMX, AREFX, ARENX, AREVX, AREOX, AREUX, ARGMX, ARGHX, ARGNX, ARGVX, ARGRX, ARGDX, ARHMX, ARHEX, ARHUX, ARHVX, ARHFX, ARHSX, ARTAX, ATTCX, ATTIX, ARTOX, ARSRX, ARDTX",
		"strategy_name_query": "american-century-one-choice-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00347
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00159
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00154
					},
					{
						"standard_name": "Repsol SA",
						"long_weight": 0.00069
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00062
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Vistra Corp",
						"long_weight": 0.00095
					},
					{
						"standard_name": "NorthWestern Energy Group Inc",
						"long_weight": 0.00094
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.0007
					},
					{
						"standard_name": "Sumitomo Corp",
						"long_weight": 0.00058
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00052
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Enterprise Products Partners LP",
						"long_weight": 0.00505
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00347
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00221
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00182
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00246
					},
					{
						"standard_name": "Evergy Inc",
						"long_weight": 0.00099
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00054
					},
					{
						"standard_name": "CLP Holdings Ltd",
						"long_weight": 0.00013
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00246
					},
					{
						"standard_name": "Atmos Energy Corp",
						"long_weight": 0.0022
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00182
					},
					{
						"standard_name": "Evergy Inc",
						"long_weight": 0.00099
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Enterprise Products Partners LP",
						"long_weight": 0.00505
					},
					{
						"standard_name": "Duke Energy Corp",
						"long_weight": 0.00399
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00347
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00246
					},
					{
						"standard_name": "Siemens AG",
						"long_weight": 0.00221
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Truist Financial Corp",
						"long_weight": 0.00537
					},
					{
						"standard_name": "Barclays PLC",
						"long_weight": 0.00217
					},
					{
						"standard_name": "Societe Generale SA",
						"long_weight": 0.00209
					},
					{
						"standard_name": "China Construction Bank Corp",
						"long_weight": 0.00143
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.00139
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00246
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00131
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00084
					},
					{
						"standard_name": "Ping An Insurance (Group) Co. of China Ltd",
						"long_weight": 0.00082
					},
					{
						"standard_name": "Axis Capital Holdings Ltd",
						"long_weight": 0.00077
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00052
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00045
					},
					{
						"standard_name": "Mondi PLC",
						"long_weight": 0.00042
					},
					{
						"standard_name": "WH Group Ltd",
						"long_weight": 0.00016
					},
					{
						"standard_name": "Associated British Foods PLC",
						"long_weight": 0.00015
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00638
					},
					{
						"standard_name": "Barclays PLC",
						"long_weight": 0.00217
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.00139
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00137
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00127
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0123
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00708
					},
					{
						"standard_name": "Unilever PLC",
						"long_weight": 0.00371
					},
					{
						"standard_name": "Mondelez International Inc",
						"long_weight": 0.00331
					},
					{
						"standard_name": "Reckitt Benckiser Group PLC",
						"long_weight": 0.00286
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 4,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Olin Corp",
						"long_weight": 0
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 2,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01863
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01316
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0123
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00246
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00164
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01863
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01316
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.0123
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00275
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.0021
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00275
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00186
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00136
					},
					{
						"standard_name": "Regions Financial Corp",
						"long_weight": 0.00102
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00091
					}
				]
			},
			"is_pff_extreme": {
				"count": 3,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.00007
					},
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00196
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00186
					},
					{
						"standard_name": "Adecco Group AG",
						"long_weight": 0.00115
					},
					{
						"standard_name": "Parker Hannifin Corp",
						"long_weight": 0.00114
					},
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.00108
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00196
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00186
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00091
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00088
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00085
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00186
					},
					{
						"standard_name": "Adecco Group AG",
						"long_weight": 0.00115
					},
					{
						"standard_name": "Eaton Corp PLC",
						"long_weight": 0.00108
					},
					{
						"standard_name": "L3Harris Technologies Inc",
						"long_weight": 0.00091
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00088
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "British American Tobacco PLC",
						"long_weight": 0.00112
					},
					{
						"standard_name": "KT&G Corp",
						"long_weight": 0.00022
					},
					{
						"standard_name": "Turning Point Brands Inc",
						"long_weight": 0.00013
					},
					{
						"standard_name": "Philip Morris International Inc",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Altria Group Inc",
						"long_weight": 0.00001
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00083
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00009
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"Tyson Foods Inc",
				"Mitsubishi Corp"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [
				"Philip Morris International Inc",
				"British American Tobacco PLC",
				"Altria Group Inc"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Duke Energy Corp"
			],
			"pff": [
				"Palantir Technologies Inc",
				"RTX Corp",
				"Motorola Solutions Inc"
			],
			"gff": [
				"Northrop Grumman Corp",
				"Olin Corp",
				"NOF Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"Chubb Ltd",
				"American International Group Inc"
			]
		}
	},
	{
		"fund_id": "FSUSA06IQM",
		"percent_rated": 0.7919509132313552,
		"percent_rated_long": 0.7919509132313552,
		"long_equity_assets": 161292294.06817678,
		"long_cbond_assets": 15761871.888027132,
		"long_equity_weight": 0.8105523971864376,
		"long_cbond_weight": 0.07920913467561996,
		"c2_asset": 1449879.8199615674,
		"c2_count": 3,
		"c2_weight": 0.0072861730344373505,
		"co_asset": 522236.93765494635,
		"co_count": 2,
		"co_weight": 0.002624430411638858,
		"og_asset": 5735136.616588774,
		"og_count": 14,
		"og_weight": 0.028821145855875873,
		"mc50_asset": 522674.73718605225,
		"mc50_count": 1,
		"mc50_weight": 0.0026266305133949594,
		"ut_asset": 4923994.887317398,
		"ut_count": 9,
		"ut_weight": 0.024744863867841412,
		"ff_hi_asset": 1972554.5571476198,
		"ff_hi_count": 4,
		"ff_hi_weight": 0.00991280354783231,
		"ff_all_asset": 8085533.339169265,
		"ff_all_count": 20,
		"ff_all_weight": 0.0406327436066121,
		"cl_asset": 29135548.50556431,
		"cl_count": 27,
		"cl_weight": 0.1464167201598897,
		"fossil_bank_asset": 4950492.066314687,
		"fossil_bank_count": 10,
		"fossil_bank_weight": 0.024878021822342652,
		"fossil_insure_asset": 2220857.108217253,
		"fossil_insure_count": 4,
		"fossil_insure_weight": 0.011160614109147331,
		"df_p_asset": 829475.7177094074,
		"df_p_count": 4,
		"df_p_weight": 0.00416841694317468,
		"df_c_asset": 16112720.258439442,
		"df_c_count": 18,
		"df_c_weight": 0.08097227524801735,
		"df_f_asset": 5533334.224137964,
		"df_f_count": 6,
		"df_f_weight": 0.027807015491471593,
		"df_all_asset": 22475530.200286813,
		"df_all_count": 28,
		"df_all_weight": 0.11294770768266363,
		"equileap_count": 189,
		"dei_asset": 109665789.51400033,
		"dei_count": 105,
		"dei_weight": 0.5511104488497344,
		"rji_asset": 109665789.51400033,
		"rji_count": 105,
		"rji_weight": 0.5511104488497344,
		"hrc_asset": 93122146.91352682,
		"hrc_count": 78,
		"hrc_weight": 0.4679726322201228,
		"wff_gun_manufacturers_asset": 0,
		"wff_gun_manufacturers_count": 0,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_asset": 1788524.211320224,
		"wff_gun_retailers_count": 1,
		"wff_gun_retailers_weight": 0.00898798417671968,
		"wff_civ_asset": 1788524.211320224,
		"wff_civ_count": 1,
		"wff_civ_weight": 0.00898798417671968,
		"wff_major_military_contractors_asset": 3304185.1304248297,
		"wff_major_military_contractors_count": 5,
		"wff_major_military_contractors_weight": 0.01660473114159794,
		"wff_cluster_munitions_asset": 1012903.780252218,
		"wff_cluster_munitions_count": 1,
		"wff_cluster_munitions_weight": 0.005090209621890589,
		"wff_nuclear_weapons_asset": 1167217.0449360108,
		"wff_nuclear_weapons_count": 2,
		"wff_nuclear_weapons_weight": 0.005865689859987047,
		"wff_mil_asset": 3304185.1304248297,
		"wff_mil_count": 5,
		"wff_mil_weight": 0.01660473114159794,
		"wff_hi_asset": 2180120.825188229,
		"wff_hi_count": 3,
		"wff_hi_weight": 0.010955899481877637,
		"wff_all_asset": 5092709.341745053,
		"wff_all_count": 6,
		"wff_all_weight": 0.025592715318317617,
		"t_asset": 0,
		"t_count": 0,
		"t_weight": 0,
		"t_m_asset": 2406237.538368092,
		"t_m_count": 2,
		"t_m_weight": 0.012092218144655076,
		"t_all_asset": 2406237.538368092,
		"t_all_count": 2,
		"t_all_weight": 0.012092218144655076,
		"ip_divest_asset": 28746.99117214455,
		"ip_divest_count": 1,
		"ip_divest_weight": 0.0001444640783435694,
		"pp_divest_asset": 79323.63620144116,
		"pp_divest_count": 1,
		"pp_divest_weight": 0.0003986301010105647,
		"borders_divest_asset": 0,
		"borders_divest_count": 0,
		"borders_divest_weight": 0,
		"pff_prisons_asset": 14644907.996697493,
		"pff_prisons_count": 6,
		"pff_prisons_weight": 0.07359598517633115,
		"pff_borders_asset": 17461529.25539791,
		"pff_borders_count": 7,
		"pff_borders_weight": 0.08775053066404609,
		"pff_high_asset": 79323.63620144116,
		"pff_high_count": 1,
		"pff_high_weight": 0.0003986301010105647,
		"pff_extreme_asset": 79323.63620144116,
		"pff_extreme_count": 1,
		"pff_extreme_weight": 0.0003986301010105647,
		"pff_all_asset": 20442657.11202695,
		"pff_all_count": 10,
		"pff_all_weight": 0.10273178159404131,
		"pff_prisons_high_asset": 79323.63620144116,
		"pff_prisons_high_count": 1,
		"pff_prisons_high_weight": 0.0003986301010105647,
		"pff_borders_high_asset": 0,
		"pff_borders_high_count": 0,
		"pff_borders_high_weight": 0,
		"fund_family_label": "Franklin Templeton Investments",
		"fund_legal_name": "Putnam Sustainable Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 5,
		"grade_military": 3,
		"grade_tobacco": 2,
		"fossil_bank_score": 12.1746,
		"fossil_insure_score": 6.2189,
		"grade_gender_equality": 2,
		"gef_grp_norm": 72.22222222222221,
		"gef_percent_rated": 0.728169912563536,
		"gef_score": 54.551982616177014,
		"strategy_name": "Putnam Sustainable Retirement Series",
		"net_assets": 198990583,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 1,
		"strategy_net_assets": 2235570368,
		"ticker": "PRRUX",
		"investment_vehicle_name": "Putnam Sustainable Retirement 2050 Y",
		"legal_type": "FO",
		"prospectus_date": "2024-11-30",
		"investment_vehicle_id": "FOUSA05GFW",
		"tickers": "PRRUX, PRRJX, PADWX, PAEHX, N, PREUX, PRRKX, PAEJX",
		"strategy_fund_legal_names": "Putnam Sustainable Retirement 2025 Fund, Putnam Sustainable Retirement 2030 Fund, Putnam Sustainable Retirement 2035 Fund, Putnam Sustainable Retirement 2040 Fund, Putnam Sustainable Retirement 2045 Fund, Putnam Sustainable Retirement 2050 Fund, Putnam Sustainable Retirement 2055 Fund, Putnam Sustainable Retirement 2060 Fund, Putnam Sustainable Retirement 2065 Fund, Putnam Sustainable Retirement Maturity Fund",
		"strategy_tickers": "PRROX, PADHX, PADJX, PADKX, PRMFX, PRRPX, PRRQX, PADOX, PADNX, PADRX, PREZX, PRRTX, PRRWX, PADUX, PADSX, PADVX, PREGX, PRRYX, PRRZX, PAAUX, PAAYX, PABTX, PREHX, PRZZX, PRVLX, PACGX, PACFX, PACHX, PREKX, PRVYX, PRRJX, PRRKX, PADWX, PAEHX, PAEJX, PREUX, PRRUX, PRRFX, PRRVX, PAEOX, PAEPX, PAESX, PREVX, PRTLX, PRTFX, PRTRX, PAEVX, PAEUX, PAEWX, PEFGX, PRTYX, PCJQX, PCJRX, PCJUX, PCJVX, PCJWX, PCJIX, PCJYX, PCJSX, PRMAX, PRMCX, PRMKX, PACKX, PACPX, PACQX, PREWX, PRMYX",
		"strategy_name_query": "putnam-sustainable-retirement-series",
		"holdings": {
			"is_c2": {
				"count": 3,
				"list": [
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00297
					},
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00229
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00202
					}
				]
			},
			"is_co": {
				"count": 2,
				"list": [
					{
						"standard_name": "BHP Group Ltd",
						"long_weight": 0.00229
					},
					{
						"standard_name": "Grupo Mexico SAB de CV",
						"long_weight": 0.00033
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00835
					},
					{
						"standard_name": "KKR & Co Inc",
						"long_weight": 0.00557
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00319
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00297
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00263
					}
				]
			},
			"is_mc50": {
				"count": 1,
				"list": [
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00263
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00835
					},
					{
						"standard_name": "Constellation Energy Corp",
						"long_weight": 0.00768
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00319
					},
					{
						"standard_name": "NRG Energy Inc",
						"long_weight": 0.00263
					},
					{
						"standard_name": "Fortum Oyj",
						"long_weight": 0.00139
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00835
					},
					{
						"standard_name": "Constellation Energy Corp",
						"long_weight": 0.00768
					},
					{
						"standard_name": "KKR & Co Inc",
						"long_weight": 0.00557
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00319
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00297
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00997
					},
					{
						"standard_name": "Intesa Sanpaolo",
						"long_weight": 0.00582
					},
					{
						"standard_name": "Barclays PLC",
						"long_weight": 0.00249
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00228
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.00199
					}
				]
			},
			"is_fossil_insure": {
				"count": 4,
				"list": [
					{
						"standard_name": "Swiss Re AG",
						"long_weight": 0.00612
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00376
					},
					{
						"standard_name": "Aviva PLC",
						"long_weight": 0.00086
					},
					{
						"standard_name": "The People's Insurance Co (Group) of China Ltd",
						"long_weight": 0.00042
					}
				]
			},
			"is_df_p": {
				"count": 4,
				"list": [
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00319
					},
					{
						"standard_name": "Samsung C&T Corp",
						"long_weight": 0.00052
					},
					{
						"standard_name": "Ptt PCL",
						"long_weight": 0.0004
					},
					{
						"standard_name": "Sime Darby Bhd",
						"long_weight": 0.00007
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.01124
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00997
					},
					{
						"standard_name": "Barclays PLC",
						"long_weight": 0.00249
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00228
					},
					{
						"standard_name": "United Overseas Bank Ltd",
						"long_weight": 0.00115
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02475
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00899
					},
					{
						"standard_name": "The Home Depot Inc",
						"long_weight": 0.00837
					},
					{
						"standard_name": "Unilever PLC",
						"long_weight": 0.00784
					},
					{
						"standard_name": "Chipotle Mexican Grill Inc",
						"long_weight": 0.007
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 0,
				"list": []
			},
			"is_wff_gun_retailers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00899
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03165
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02475
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00899
					},
					{
						"standard_name": "The Kroger Co",
						"long_weight": 0.00559
					},
					{
						"standard_name": "Capgemini SE",
						"long_weight": 0.00221
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.03165
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.02475
					},
					{
						"standard_name": "Thermo Fisher Scientific Inc",
						"long_weight": 0.00939
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00784
					},
					{
						"standard_name": "Accenture PLC",
						"long_weight": 0.0072
					}
				]
			},
			"is_pff_high": {
				"count": 1,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.0004
					}
				]
			},
			"is_pff_extreme": {
				"count": 1,
				"list": [
					{
						"standard_name": "Sodexo",
						"long_weight": 0.0004
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "Fortive Corp",
						"long_weight": 0.00572
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00509
					},
					{
						"standard_name": "NEC Corp",
						"long_weight": 0.00471
					},
					{
						"standard_name": "Bharat Electronics Ltd",
						"long_weight": 0.00094
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00014
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 1,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00509
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 2,
				"list": [
					{
						"standard_name": "Fortive Corp",
						"long_weight": 0.00572
					},
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00014
					}
				]
			},
			"is_t": {
				"count": 0,
				"list": []
			},
			"is_t_m": {
				"count": 2,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00719
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.0049
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"ITOCHU Corp",
				"Samsung C&T Corp",
				"Ptt PCL"
			],
			"wff": [
				"Fortive Corp",
				"CRH PLC",
				"NEC Corp"
			],
			"tff": [],
			"fff": [
				"NextEra Energy Inc",
				"Constellation Energy Corp",
				"KKR & Co Inc"
			],
			"pff": [
				"Sodexo"
			],
			"gff": [],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Intesa Sanpaolo"
			],
			"ffi": [
				"Swiss Re AG",
				"Allianz SE",
				"Aviva PLC"
			]
		}
	},
	{
		"fund_id": "FS0000D088",
		"percent_rated": 0.8649548474703415,
		"percent_rated_long": 0.8658915512960276,
		"long_equity_assets": 24251791.31517276,
		"long_cbond_assets": 1466868.4201409814,
		"long_equity_weight": 0.8628951866268757,
		"long_cbond_weight": 0.052192173464841056,
		"c2_asset": 658116.2576378108,
		"c2_count": 29,
		"c2_weight": 0.023416222891596093,
		"co_asset": 92166.34236371676,
		"co_count": 9,
		"co_weight": 0.003279340983975037,
		"og_asset": 1407014.1503013805,
		"og_count": 63,
		"og_weight": 0.05006251794074189,
		"mc50_asset": 30175,
		"mc50_count": 1,
		"mc50_weight": 0.0010736469697467579,
		"ut_asset": 317576.0000246441,
		"ut_count": 25,
		"ut_weight": 0.011299569514192392,
		"ff_hi_asset": 688291.2576378108,
		"ff_hi_count": 30,
		"ff_hi_weight": 0.024489869861342852,
		"ff_all_asset": 1575902.1347531518,
		"ff_all_count": 75,
		"ff_all_weight": 0.05607166699569738,
		"cl_asset": 3755447.499387005,
		"cl_count": 68,
		"cl_weight": 0.13362136960264778,
		"fossil_bank_asset": 868151.4513989795,
		"fossil_bank_count": 33,
		"fossil_bank_weight": 0.030889417566719608,
		"fossil_insure_asset": 320010.43717414094,
		"fossil_insure_count": 15,
		"fossil_insure_weight": 0.011386188439415133,
		"df_p_asset": 42517.625381311496,
		"df_p_count": 8,
		"df_p_weight": 0.0015128059536527896,
		"df_c_asset": 1876601.1252056672,
		"df_c_count": 62,
		"df_c_weight": 0.06677074106049448,
		"df_f_asset": 574541.2676795773,
		"df_f_count": 25,
		"df_f_weight": 0.020442568054304527,
		"df_all_asset": 2480540.2569337664,
		"df_all_count": 92,
		"df_all_weight": 0.08825930506020821,
		"equileap_count": 812,
		"dei_asset": 16042436.102481375,
		"dei_count": 423,
		"dei_weight": 0.5708007591975184,
		"rji_asset": 16042436.102481375,
		"rji_count": 423,
		"rji_weight": 0.5708007591975184,
		"hrc_asset": 13858655.169957252,
		"hrc_count": 319,
		"hrc_weight": 0.4931003522117595,
		"wff_gun_manufacturers_asset": 9235,
		"wff_gun_manufacturers_count": 1,
		"wff_gun_manufacturers_weight": 0.00032858756472614115,
		"wff_gun_retailers_asset": 70932,
		"wff_gun_retailers_count": 2,
		"wff_gun_retailers_weight": 0.002523808677981012,
		"wff_civ_asset": 80167,
		"wff_civ_count": 3,
		"wff_civ_weight": 0.002852396242707153,
		"wff_major_military_contractors_asset": 1054631.783513856,
		"wff_major_military_contractors_count": 39,
		"wff_major_military_contractors_weight": 0.037524514285609614,
		"wff_cluster_munitions_asset": 350075.7467833115,
		"wff_cluster_munitions_count": 13,
		"wff_cluster_munitions_weight": 0.012455932550645756,
		"wff_nuclear_weapons_asset": 685361.764857799,
		"wff_nuclear_weapons_count": 19,
		"wff_nuclear_weapons_weight": 0.024385636520956617,
		"wff_mil_asset": 1054631.783513856,
		"wff_mil_count": 39,
		"wff_mil_weight": 0.037524514285609614,
		"wff_hi_asset": 714469.4865842668,
		"wff_hi_count": 22,
		"wff_hi_weight": 0.02542130900572394,
		"wff_all_asset": 1125563.783513856,
		"wff_all_count": 41,
		"wff_all_weight": 0.04004832296359063,
		"t_asset": 0,
		"t_count": 0,
		"t_weight": 0,
		"t_m_asset": 281188.6207208801,
		"t_m_count": 4,
		"t_m_weight": 0.010004881874539961,
		"t_all_asset": 281188.6207208801,
		"t_all_count": 4,
		"t_all_weight": 0.010004881874539961,
		"ip_divest_asset": 633869.5809770233,
		"ip_divest_count": 17,
		"ip_divest_weight": 0.022553509687841866,
		"pp_divest_asset": 33572.003484277215,
		"pp_divest_count": 4,
		"pp_divest_weight": 0.0011945146581349405,
		"borders_divest_asset": 208485.97309522296,
		"borders_divest_count": 12,
		"borders_divest_weight": 0.007418072352887829,
		"pff_prisons_asset": 1843474.018575244,
		"pff_prisons_count": 20,
		"pff_prisons_weight": 0.06559205613422334,
		"pff_borders_asset": 1967609.5956015387,
		"pff_borders_count": 27,
		"pff_borders_weight": 0.07000888417439058,
		"pff_high_asset": 211010.9765795002,
		"pff_high_count": 13,
		"pff_high_weight": 0.0075079136897393366,
		"pff_extreme_asset": 0,
		"pff_extreme_count": 0,
		"pff_extreme_weight": 0,
		"pff_all_asset": 2362992.5990858157,
		"pff_all_count": 37,
		"pff_all_weight": 0.08407687965343832,
		"pff_prisons_high_asset": 33572.003484277215,
		"pff_prisons_high_count": 4,
		"pff_prisons_high_weight": 0.0011945146581349405,
		"pff_borders_high_asset": 208485.97309522296,
		"pff_borders_high_count": 12,
		"pff_borders_high_weight": 0.007418072352887829,
		"fund_family_label": "Natixis Funds",
		"fund_legal_name": "Natixis Target Retiremet 2050",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-02-28",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"fossil_bank_score": 15.7292,
		"fossil_insure_score": 8.4445,
		"grade_gender_equality": 3,
		"gef_grp_norm": 40.370370370370374,
		"gef_percent_rated": 0.8041392701791724,
		"gef_score": 53.784338091364006,
		"strategy_name": "Natixis Target Retirement Series",
		"net_assets": 28074705,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 1,
		"strategy_net_assets": 185544477,
		"ticker": "NSFKX",
		"investment_vehicle_name": "Natixis Target Retirement 2050 N",
		"legal_type": "FO",
		"prospectus_date": "2024-06-01",
		"investment_vehicle_id": "F00000YBTC",
		"tickers": "NSFKX",
		"strategy_fund_legal_names": "Natixis Target Retiremet 2015, Natixis Target Retiremet 2020, Natixis Target Retiremet 2025, Natixis Target Retiremet 2030, Natixis Target Retiremet 2035, Natixis Target Retiremet 2040, Natixis Target Retiremet 2045, Natixis Target Retiremet 2050, Natixis Target Retiremet 2055, Natixis Target Retiremet 2060, Natixis Target Retiremet 2065",
		"strategy_tickers": "NSFBX, NSFDX, NSFEX, NSFFX, NSFGX, NSFHX, NSFJX, NSFKX, NSFLX, NSFMX, NSFOX",
		"strategy_name_query": "natixis-target-retirement-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00403
					},
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00372
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00276
					},
					{
						"standard_name": "APA Corp",
						"long_weight": 0.0018
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00174
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Idacorp Inc",
						"long_weight": 0.0007
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00059
					},
					{
						"standard_name": "FirstEnergy Corp",
						"long_weight": 0.00058
					},
					{
						"standard_name": "Alliant Energy Corp",
						"long_weight": 0.00043
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00027
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Phillips 66",
						"long_weight": 0.00457
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00403
					},
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00372
					},
					{
						"standard_name": "Mitsubishi Heavy Industries Ltd",
						"long_weight": 0.00322
					},
					{
						"standard_name": "Siemens Energy AG",
						"long_weight": 0.0032
					}
				]
			},
			"is_mc50": {
				"count": 1,
				"list": [
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00107
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "National Grid PLC",
						"long_weight": 0.0013
					},
					{
						"standard_name": "PPL Corp",
						"long_weight": 0.00107
					},
					{
						"standard_name": "New Jersey Resources Corp",
						"long_weight": 0.00078
					},
					{
						"standard_name": "ONE Gas Inc",
						"long_weight": 0.00075
					},
					{
						"standard_name": "Idacorp Inc",
						"long_weight": 0.0007
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Phillips 66",
						"long_weight": 0.00457
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00403
					},
					{
						"standard_name": "EOG Resources Inc",
						"long_weight": 0.00372
					},
					{
						"standard_name": "Mitsubishi Heavy Industries Ltd",
						"long_weight": 0.00322
					},
					{
						"standard_name": "Siemens Energy AG",
						"long_weight": 0.0032
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Citigroup Inc",
						"long_weight": 0.00525
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00481
					},
					{
						"standard_name": "Wells Fargo & Co",
						"long_weight": 0.00278
					},
					{
						"standard_name": "Credit Agricole SA",
						"long_weight": 0.00255
					},
					{
						"standard_name": "Intesa Sanpaolo",
						"long_weight": 0.00242
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "American International Group Inc",
						"long_weight": 0.00469
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.0008
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00076
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00074
					},
					{
						"standard_name": "The Hartford Insurance Group Inc",
						"long_weight": 0.0007
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00052
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00027
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00025
					},
					{
						"standard_name": "UPM-Kymmene Oyj",
						"long_weight": 0.00012
					},
					{
						"standard_name": "Mondi PLC",
						"long_weight": 0.0001
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "Citigroup Inc",
						"long_weight": 0.00525
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00481
					},
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00269
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.0009
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00087
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01423
					},
					{
						"standard_name": "The Kroger Co",
						"long_weight": 0.00409
					},
					{
						"standard_name": "Starbucks Corp",
						"long_weight": 0.00339
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00307
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00289
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00033
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 2,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00184
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00069
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01536
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01423
					},
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01362
					},
					{
						"standard_name": "General Motors Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "The Kroger Co",
						"long_weight": 0.00409
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01536
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01423
					},
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01362
					},
					{
						"standard_name": "General Motors Co",
						"long_weight": 0.00485
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00353
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "The Carlyle Group Inc",
						"long_weight": 0.00221
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00117
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00087
					},
					{
						"standard_name": "Aramark",
						"long_weight": 0.00065
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00046
					}
				]
			},
			"is_pff_extreme": {
				"count": 0,
				"list": []
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00527
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00418
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00387
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00325
					},
					{
						"standard_name": "Mitsubishi Heavy Industries Ltd",
						"long_weight": 0.00322
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00387
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00325
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00117
					},
					{
						"standard_name": "Lockheed Martin Corp",
						"long_weight": 0.00087
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00056
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Boeing Co",
						"long_weight": 0.00527
					},
					{
						"standard_name": "Rolls-Royce Holdings PLC",
						"long_weight": 0.00418
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00387
					},
					{
						"standard_name": "Safran SA",
						"long_weight": 0.00325
					},
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00138
					}
				]
			},
			"is_t": {
				"count": 0,
				"list": []
			},
			"is_t_m": {
				"count": 4,
				"list": [
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00469
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00254
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00185
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00092
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"ITOCHU Corp",
				"Mitsubishi Corp",
				"Marubeni Corp"
			],
			"wff": [
				"RTX Corp",
				"Lockheed Martin Corp",
				"Northrop Grumman Corp"
			],
			"tff": [],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Phillips 66"
			],
			"pff": [
				"The Carlyle Group Inc",
				"RTX Corp",
				"Lockheed Martin Corp"
			],
			"gff": [
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Chubb Ltd",
				"American International Group Inc",
				"The Travelers Companies Inc"
			]
		}
	},
	{
		"fund_id": "FS0000G106",
		"percent_rated": 0.9260602688891912,
		"percent_rated_long": 0.932887471538215,
		"long_equity_assets": 8513732.015307607,
		"long_cbond_assets": 86207.1397906109,
		"long_equity_weight": 0.9318948892415334,
		"long_cbond_weight": 0.009436049060806402,
		"c2_asset": 183946.90415197465,
		"c2_count": 66,
		"c2_weight": 0.020134434530334918,
		"co_asset": 34824.41747450352,
		"co_count": 64,
		"co_weight": 0.003811806221637438,
		"og_asset": 495448.94771131827,
		"og_count": 228,
		"og_weight": 0.054230781685649695,
		"mc50_asset": 31467.17497976967,
		"mc50_count": 5,
		"mc50_weight": 0.0034443296417824712,
		"ut_asset": 220578.53052711688,
		"ut_count": 118,
		"ut_weight": 0.02414405397128311,
		"ff_hi_asset": 214952.3490919136,
		"ff_hi_count": 69,
		"ff_hi_weight": 0.023528224189938732,
		"ff_all_asset": 615205.9620597474,
		"ff_all_count": 325,
		"ff_all_weight": 0.0673391282276208,
		"cl_asset": 1558060.561363324,
		"cl_count": 127,
		"cl_weight": 0.17054197520578365,
		"fossil_bank_asset": 372567.4144539363,
		"fossil_bank_count": 51,
		"fossil_bank_weight": 0.04078043198955577,
		"fossil_insure_asset": 153627.4557812098,
		"fossil_insure_count": 20,
		"fossil_insure_weight": 0.01681573258734013,
		"df_p_asset": 57848.34648887453,
		"df_p_count": 42,
		"df_p_weight": 0.006331956226379745,
		"df_c_asset": 735560.5822364769,
		"df_c_count": 93,
		"df_c_weight": 0.08051288742483788,
		"df_f_asset": 267379.95481993066,
		"df_f_count": 31,
		"df_f_weight": 0.029266837731598817,
		"df_all_asset": 1035980.230985953,
		"df_all_count": 157,
		"df_all_weight": 0.11339617935768342,
		"equileap_count": 2571,
		"dei_asset": 5520965.118083588,
		"dei_count": 1238,
		"dei_weight": 0.6043130284077873,
		"rji_asset": 5520965.118083588,
		"rji_count": 1238,
		"rji_weight": 0.6043130284077873,
		"hrc_asset": 4685686.884833038,
		"hrc_count": 479,
		"hrc_weight": 0.5128852602725742,
		"wff_gun_manufacturers_asset": 8849.408150802748,
		"wff_gun_manufacturers_count": 6,
		"wff_gun_manufacturers_weight": 0.0009686372807739228,
		"wff_gun_retailers_asset": 0,
		"wff_gun_retailers_count": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_asset": 8849.408150802748,
		"wff_civ_count": 6,
		"wff_civ_weight": 0.0009686372807739228,
		"wff_major_military_contractors_asset": 257482.10459654723,
		"wff_major_military_contractors_count": 129,
		"wff_major_military_contractors_weight": 0.028183440224951322,
		"wff_cluster_munitions_asset": 104291.39762936975,
		"wff_cluster_munitions_count": 18,
		"wff_cluster_munitions_weight": 0.011415513228267234,
		"wff_nuclear_weapons_asset": 142259.4236776195,
		"wff_nuclear_weapons_count": 50,
		"wff_nuclear_weapons_weight": 0.015571412117888905,
		"wff_mil_asset": 257482.10459654723,
		"wff_mil_count": 129,
		"wff_mil_weight": 0.028183440224951322,
		"wff_hi_asset": 171734.77184983244,
		"wff_hi_count": 55,
		"wff_hi_weight": 0.018797720659303286,
		"wff_all_asset": 257917.35465516942,
		"wff_all_count": 131,
		"wff_all_weight": 0.028231081765047114,
		"t_asset": 399.9107258434254,
		"t_count": 7,
		"t_weight": 0.00004377337234673285,
		"t_m_asset": 53370.01085575637,
		"t_m_count": 7,
		"t_m_weight": 0.005841767190442575,
		"t_all_asset": 53769.921581599796,
		"t_all_count": 14,
		"t_all_weight": 0.005885540562789308,
		"ip_divest_asset": 192233.84956422015,
		"ip_divest_count": 43,
		"ip_divest_weight": 0.021041505843269137,
		"pp_divest_asset": 23937.18983893564,
		"pp_divest_count": 9,
		"pp_divest_weight": 0.002620113580460463,
		"borders_divest_asset": 90672.926277266,
		"borders_divest_count": 14,
		"borders_divest_weight": 0.009924864494023609,
		"pff_prisons_asset": 826900.6536702799,
		"pff_prisons_count": 32,
		"pff_prisons_weight": 0.09051077620018033,
		"pff_borders_asset": 815901.6348947005,
		"pff_borders_count": 34,
		"pff_borders_weight": 0.08930684714002142,
		"pff_high_asset": 92748.66636734999,
		"pff_high_count": 17,
		"pff_high_weight": 0.01015207056274471,
		"pff_extreme_asset": 409.8451392163435,
		"pff_extreme_count": 2,
		"pff_extreme_weight": 0.000044860771977492857,
		"pff_all_asset": 989144.5768192789,
		"pff_all_count": 51,
		"pff_all_weight": 0.10826964886861791,
		"pff_prisons_high_asset": 23937.18983893564,
		"pff_prisons_high_count": 9,
		"pff_prisons_high_weight": 0.002620113580460463,
		"pff_borders_high_asset": 90672.926277266,
		"pff_borders_high_count": 14,
		"pff_borders_high_weight": 0.009924864494023609,
		"fund_family_label": "BlackRock/iShares",
		"fund_legal_name": "BlackRock LifePath ESG Index 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"fossil_bank_score": 15.5304,
		"fossil_insure_score": 12.6325,
		"grade_gender_equality": 1,
		"gef_grp_norm": 83.51851851851852,
		"gef_percent_rated": 0.8243429754832319,
		"gef_score": 54.7934313798442,
		"strategy_name": "BlackRock LifePath ESG Index Series",
		"net_assets": 9068583,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 1,
		"strategy_net_assets": 69284692,
		"ticker": "LEPKX",
		"investment_vehicle_name": "BlackRock LifePath ESG Index 2050 K",
		"legal_type": "FO",
		"prospectus_date": "2025-02-28",
		"investment_vehicle_id": "F00001579S",
		"tickers": "LEPKX, LEBAX, LEGIX",
		"strategy_fund_legal_names": "BlackRock LifePath ESG Index 2030 Fund, BlackRock LifePath ESG Index 2035 Fund, BlackRock LifePath ESG Index 2040 Fund, BlackRock LifePath ESG Index 2045 Fund, BlackRock LifePath ESG Index 2050 Fund, BlackRock LifePath ESG Index 2055 Fund, BlackRock LifePath ESG Index 2060 Fund, BlackRock LifePath ESG Index 2065 Fund, BlackRock LifePath ESG Index Retirement Fund, BlackRock LifePath® ESG Index 2070 Fund",
		"strategy_tickers": "LENIX, LENAX, LENKX, LEJIX, LEJAX, LEJKX, LEKIX, LEKAX, LEKKX, LEHIX, LEHAX, LEHKX, LEGIX, LEBAX, LEPKX, LEEIX, LEVAX, LEVKX, LEZIX, LEZAX, LEZKX, LEWIX, LEWAX, LEWKX, LERIX, LERAX, LERKX, LEYIX, LEYAX, LEYKX",
		"strategy_name_query": "blackrock-lifepath-esg-index-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00261
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00215
					},
					{
						"standard_name": "Chevron Corp",
						"long_weight": 0.00177
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00157
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00153
					}
				]
			},
			"is_co": {
				"count": 5,
				"list": [
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00055
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00051
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00048
					},
					{
						"standard_name": "Anglo American PLC",
						"long_weight": 0.00033
					},
					{
						"standard_name": "Fortis Inc",
						"long_weight": 0.00025
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00261
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00225
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00215
					},
					{
						"standard_name": "NiSource Inc",
						"long_weight": 0.0021
					},
					{
						"standard_name": "Kinder Morgan Inc",
						"long_weight": 0.00192
					}
				]
			},
			"is_mc50": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00336
					},
					{
						"standard_name": "AGL Energy Ltd",
						"long_weight": 0.00004
					},
					{
						"standard_name": "Electric Power Development Co Ltd",
						"long_weight": 0.00002
					},
					{
						"standard_name": "NLC India Ltd",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Enea SA",
						"long_weight": 0.00001
					}
				]
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00336
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00225
					},
					{
						"standard_name": "NiSource Inc",
						"long_weight": 0.0021
					},
					{
						"standard_name": "Public Service Enterprise Group Inc",
						"long_weight": 0.00193
					},
					{
						"standard_name": "Exelon Corp",
						"long_weight": 0.0011
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00336
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.00261
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.00225
					},
					{
						"standard_name": "ConocoPhillips",
						"long_weight": 0.00215
					},
					{
						"standard_name": "NiSource Inc",
						"long_weight": 0.0021
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.003
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00224
					},
					{
						"standard_name": "The Goldman Sachs Group Inc",
						"long_weight": 0.00221
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00182
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00177
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00336
					},
					{
						"standard_name": "The Hartford Insurance Group Inc",
						"long_weight": 0.00242
					},
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00154
					},
					{
						"standard_name": "Allianz SE",
						"long_weight": 0.00151
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00122
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00106
					},
					{
						"standard_name": "Bunge Global SA",
						"long_weight": 0.00098
					},
					{
						"standard_name": "Archer-Daniels-Midland Co",
						"long_weight": 0.00068
					},
					{
						"standard_name": "Mitsubishi Corp",
						"long_weight": 0.00055
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00051
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.00696
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.003
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00224
					},
					{
						"standard_name": "HSBC Holdings PLC",
						"long_weight": 0.00182
					},
					{
						"standard_name": "Commonwealth Bank of Australia",
						"long_weight": 0.00177
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01841
					},
					{
						"standard_name": "Procter & Gamble Co",
						"long_weight": 0.00541
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00498
					},
					{
						"standard_name": "The Home Depot Inc",
						"long_weight": 0.00459
					},
					{
						"standard_name": "Johnson & Johnson",
						"long_weight": 0.00311
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 5,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00091
					},
					{
						"standard_name": "NOF Corp",
						"long_weight": 0.00003
					},
					{
						"standard_name": "Daicel Corp",
						"long_weight": 0.00002
					},
					{
						"standard_name": "Poongsan Corp",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Colt CZ Group SE",
						"long_weight": 0
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 0,
				"list": []
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.0303
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01841
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.0181
					},
					{
						"standard_name": "Costco Wholesale Corp",
						"long_weight": 0.00498
					},
					{
						"standard_name": "Berkshire Hathaway Inc",
						"long_weight": 0.00336
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.0303
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01841
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.0181
					},
					{
						"standard_name": "Salesforce Inc",
						"long_weight": 0.00329
					},
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00266
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Palantir Technologies Inc",
						"long_weight": 0.00224
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00125
					},
					{
						"standard_name": "Axon Enterprise Inc",
						"long_weight": 0.00098
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00093
					}
				]
			},
			"is_pff_extreme": {
				"count": 2,
				"list": [
					{
						"standard_name": "Serco Group PLC",
						"long_weight": 0.00002
					},
					{
						"standard_name": "MITIE Group PLC",
						"long_weight": 0.00002
					}
				]
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00233
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00207
					},
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00206
					},
					{
						"standard_name": "Caterpillar Inc",
						"long_weight": 0.00177
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00233
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00207
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00093
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00091
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "RTX Corp",
						"long_weight": 0.00266
					},
					{
						"standard_name": "Honeywell International Inc",
						"long_weight": 0.00233
					},
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00206
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00093
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00091
					}
				]
			},
			"is_t": {
				"count": 5,
				"list": [
					{
						"standard_name": "Godfrey Phillips India Ltd",
						"long_weight": 0.00001
					},
					{
						"standard_name": "China Tobacco International (HK) Co Ltd",
						"long_weight": 0.00001
					},
					{
						"standard_name": "RLX Technology Inc",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Scandinavian Tobacco Group AS",
						"long_weight": 0.00001
					},
					{
						"standard_name": "Philip Morris CR AS",
						"long_weight": 0
					}
				]
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.00187
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00146
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00141
					},
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00093
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00011
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"ITOCHU Corp",
				"Bunge Global SA"
			],
			"wff": [
				"RTX Corp",
				"Northrop Grumman Corp",
				"Honeywell International Inc"
			],
			"tff": [
				"Godfrey Phillips India Ltd",
				"China Tobacco International (HK) Co Ltd",
				"Scandinavian Tobacco Group AS"
			],
			"fff": [
				"Exxon Mobil Corp",
				"Chevron Corp",
				"Berkshire Hathaway Inc"
			],
			"pff": [
				"RTX Corp",
				"Palantir Technologies Inc",
				"Motorola Solutions Inc"
			],
			"gff": [
				"Northrop Grumman Corp",
				"NOF Corp",
				"Daicel Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"Wells Fargo & Co"
			],
			"ffi": [
				"Berkshire Hathaway Inc",
				"The Hartford Insurance Group Inc",
				"Zurich Insurance Group AG"
			]
		}
	},
	{
		"fund_id": "FS0000I42F",
		"percent_rated": 0.8397908852818519,
		"percent_rated_long": 0.8627735829206685,
		"long_equity_assets": 6714431.6376357395,
		"long_cbond_assets": 775.6499765072085,
		"long_equity_weight": 0.8604328416519299,
		"long_cbond_weight": 0.00009939705241356075,
		"c2_asset": 134847.43879201324,
		"c2_count": 19,
		"c2_weight": 0.017280266031593956,
		"co_asset": 8264.201410501104,
		"co_count": 3,
		"co_weight": 0.0010590308588092465,
		"og_asset": 448386.7142646684,
		"og_count": 73,
		"og_weight": 0.0574593168171073,
		"mc50_asset": 0,
		"mc50_count": 0,
		"mc50_weight": 0,
		"ut_asset": 93715.75133530599,
		"ut_count": 25,
		"ut_weight": 0.012009372435486776,
		"ff_hi_asset": 134847.43879201324,
		"ff_hi_count": 19,
		"ff_hi_weight": 0.017280266031593956,
		"ff_all_asset": 499403.9433390348,
		"ff_all_count": 90,
		"ff_all_weight": 0.06399701081038793,
		"cl_asset": 1083669.1537180294,
		"cl_count": 77,
		"cl_weight": 0.13886872034227277,
		"fossil_bank_asset": 357849.3861226356,
		"fossil_bank_count": 32,
		"fossil_bank_weight": 0.04585724910192347,
		"fossil_insure_asset": 151626.5902133657,
		"fossil_insure_count": 17,
		"fossil_insure_weight": 0.01943046037672038,
		"df_p_asset": 34985.06778604101,
		"df_p_count": 14,
		"df_p_weight": 0.004483224033706622,
		"df_c_asset": 534825.2890993406,
		"df_c_count": 64,
		"df_c_weight": 0.06853614246478468,
		"df_f_asset": 220879.45386162132,
		"df_f_count": 18,
		"df_f_weight": 0.028304992351609014,
		"df_all_asset": 780821.2011903899,
		"df_all_count": 90,
		"df_all_weight": 0.10005972824214913,
		"equileap_count": 1067,
		"dei_asset": 3592353.4858188005,
		"dei_count": 718,
		"dei_weight": 0.4603485573813468,
		"rji_asset": 3592353.4858188005,
		"rji_count": 718,
		"rji_weight": 0.4603485573813468,
		"hrc_asset": 3255799.266268092,
		"hrc_count": 393,
		"hrc_weight": 0.4172202154566489,
		"wff_gun_manufacturers_asset": 11758.344357902262,
		"wff_gun_manufacturers_count": 1,
		"wff_gun_manufacturers_weight": 0.0015067940512317488,
		"wff_gun_retailers_asset": 22793.75039894013,
		"wff_gun_retailers_count": 3,
		"wff_gun_retailers_weight": 0.00292094587987655,
		"wff_civ_asset": 34552.094756842394,
		"wff_civ_count": 4,
		"wff_civ_weight": 0.004427739931108299,
		"wff_major_military_contractors_asset": 360460.94237200543,
		"wff_major_military_contractors_count": 58,
		"wff_major_military_contractors_weight": 0.046191911644644715,
		"wff_cluster_munitions_asset": 190829.4236460046,
		"wff_cluster_munitions_count": 13,
		"wff_cluster_munitions_weight": 0.024454177526833498,
		"wff_nuclear_weapons_asset": 211357.07546849622,
		"wff_nuclear_weapons_count": 30,
		"wff_nuclear_weapons_weight": 0.027084730154857153,
		"wff_mil_asset": 360460.94237200543,
		"wff_mil_count": 58,
		"wff_mil_weight": 0.046191911644644715,
		"wff_hi_asset": 288406.16563924745,
		"wff_hi_count": 32,
		"wff_hi_weight": 0.036958323510207634,
		"wff_all_asset": 383254.69277094555,
		"wff_all_count": 61,
		"wff_all_weight": 0.04911285752452126,
		"t_asset": 0,
		"t_count": 0,
		"t_weight": 0,
		"t_m_asset": 58313.48575675132,
		"t_m_count": 5,
		"t_m_weight": 0.007472685845078952,
		"t_all_asset": 58313.48575675132,
		"t_all_count": 5,
		"t_all_weight": 0.007472685845078952,
		"ip_divest_asset": 163181.98342727884,
		"ip_divest_count": 19,
		"ip_divest_weight": 0.020911246890909042,
		"pp_divest_asset": 13799.748593237096,
		"pp_divest_count": 5,
		"pp_divest_weight": 0.0017683934451884836,
		"borders_divest_asset": 62802.53666508789,
		"borders_divest_count": 15,
		"borders_divest_weight": 0.008047943296168331,
		"pff_prisons_asset": 517017.24848477595,
		"pff_prisons_count": 24,
		"pff_prisons_weight": 0.06625409927525298,
		"pff_borders_asset": 568328.605459282,
		"pff_borders_count": 32,
		"pff_borders_weight": 0.07282948481393674,
		"pff_high_asset": 64227.03528641301,
		"pff_high_count": 16,
		"pff_high_weight": 0.008230488217737838,
		"pff_extreme_asset": 0,
		"pff_extreme_count": 0,
		"pff_extreme_weight": 0,
		"pff_all_asset": 650407.1679656954,
		"pff_all_count": 43,
		"pff_all_weight": 0.08334758888997532,
		"pff_prisons_high_asset": 13799.748593237096,
		"pff_prisons_high_count": 5,
		"pff_prisons_high_weight": 0.0017683934451884836,
		"pff_borders_high_asset": 62802.53666508789,
		"pff_borders_high_count": 15,
		"pff_borders_high_weight": 0.008047943296168331,
		"fund_family_label": "Fidelity Investments",
		"fund_legal_name": "Fidelity Sustainable Target Date 2050 Fund",
		"category_group": "Allocation Funds",
		"portfolio_date": "2025-03-31",
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 3,
		"grade_military": 5,
		"grade_tobacco": 2,
		"fossil_bank_score": 17.6579,
		"fossil_insure_score": 13.5929,
		"grade_gender_equality": 1,
		"gef_grp_norm": 86.48148148148148,
		"gef_percent_rated": 0.7233316738600573,
		"gef_score": 54.99853029698739,
		"strategy_name": "Fidelity Sustainable Target Date Series",
		"net_assets": 7589990,
		"morningstar_category_name": "Target-Date 2050",
		"sustainable_investment": 1,
		"strategy_net_assets": 59099742,
		"ticker": "FSYWX",
		"investment_vehicle_name": "Fidelity Sustainable Target Date 2050",
		"legal_type": "FO",
		"prospectus_date": "2024-05-30",
		"investment_vehicle_id": "F00001F475",
		"tickers": "FSYWX, FSZGX, FSZBX, FSZAX, FSYYX, FSYZX, FSZFX, FSZCX",
		"strategy_fund_legal_names": "Fidelity Sustainable Target Date 2010 Fund, Fidelity Sustainable Target Date 2015 Fund, Fidelity Sustainable Target Date 2020 Fund, Fidelity Sustainable Target Date 2025 Fund, Fidelity Sustainable Target Date 2030 Fund, Fidelity Sustainable Target Date 2035 Fund, Fidelity Sustainable Target Date 2040 Fund, Fidelity Sustainable Target Date 2045 Fund, Fidelity Sustainable Target Date 2050 Fund, Fidelity Sustainable Target Date 2055 Fund, Fidelity Sustainable Target Date 2060 Fund, Fidelity Sustainable Target Date 2065 Fund, Fidelity Sustainable Target Date 2070 Fund, Fidelity Sustainable Target Date Income Fund",
		"strategy_tickers": "FSUZX, FSVCX, FSVGX, FSVEX, FSVHX, FSUYX, FSVKX, FSVMX, FSVOX, FSVPX, FSVUX, FSVTX, FSVWX, FSVNX, FSVZX, FSWBX, FSWEX, FSWGX, FSWJX, FSWHX, FSWKX, FSWDX, FSWMX, FSWNX, FSWQX, FSWRX, FSWUX, FSWSX, FSWVX, FSWOX, FSWYX, FSWZX, FSXBX, FSXCX, FSXEX, FSXDX, FSXFX, FSXAX, FSXHX, FSXJX, FSXLX, FSXNX, FSXQX, FSXOX, FSXRX, FSXKX, FSXTX, FSXUX, FSXWX, FSXYX, FSYBX, FSXZX, FSYDX, FSXVX, FSYFX, FSYGX, FSYLX, FSYOX, FSYQX, FSYPX, FSYSX, FSYHX, FSYUX, FSYVX, FSYYX, FSYZX, FSZBX, FSZAX, FSZCX, FSYWX, FSZFX, FSZGX, FSZJX, FSZKX, FSZMX, FSZLX, FSZNX, FSZHX, FSZQX, FSZRX, FSZTX, FSZVX, FSZYX, FSZWX, FTDLX, FSZSX, FTGKX, FTGNX, FTGUX, FTGYX, FTHBX, FTGZX, FTHDX, FTGPX, FTHGX, FTHHX, FRCQX, FRCWX, FRDCX, FRDDX, FRCRX, FRCVX, FRCYX, FRDEX, FSUEX, FSUFX, FSUJX, FSUHX, FSULX, FSUDX, FSUOX, FSUWX",
		"strategy_name_query": "fidelity-sustainable-target-date-series",
		"holdings": {
			"is_c2": {
				"count": 5,
				"list": [
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0041
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00376
					},
					{
						"standard_name": "TotalEnergies SE",
						"long_weight": 0.00274
					},
					{
						"standard_name": "Equinor ASA",
						"long_weight": 0.00088
					},
					{
						"standard_name": "Suncor Energy Inc",
						"long_weight": 0.00083
					}
				]
			},
			"is_co": {
				"count": 3,
				"list": [
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00043
					},
					{
						"standard_name": "Tenaga Nasional Bhd",
						"long_weight": 0.00042
					},
					{
						"standard_name": "CSX Corp",
						"long_weight": 0.00021
					}
				]
			},
			"is_og": {
				"count": 5,
				"list": [
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.00491
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0041
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00376
					},
					{
						"standard_name": "Mitsubishi Heavy Industries Ltd",
						"long_weight": 0.00275
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00274
					}
				]
			},
			"is_mc50": {
				"count": 0,
				"list": []
			},
			"is_ut": {
				"count": 5,
				"list": [
					{
						"standard_name": "Public Service Enterprise Group Inc",
						"long_weight": 0.00141
					},
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00127
					},
					{
						"standard_name": "NextEra Energy Inc",
						"long_weight": 0.0012
					},
					{
						"standard_name": "NiSource Inc",
						"long_weight": 0.00109
					},
					{
						"standard_name": "Exelon Corp",
						"long_weight": 0.00072
					}
				]
			},
			"is_fff": {
				"count": 5,
				"list": [
					{
						"standard_name": "Reliance Industries Ltd",
						"long_weight": 0.00491
					},
					{
						"standard_name": "Exxon Mobil Corp",
						"long_weight": 0.0041
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00376
					},
					{
						"standard_name": "Mitsubishi Heavy Industries Ltd",
						"long_weight": 0.00275
					},
					{
						"standard_name": "GE Vernova Inc",
						"long_weight": 0.00274
					}
				]
			},
			"is_fossil_bank": {
				"count": 5,
				"list": [
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00541
					},
					{
						"standard_name": "China Construction Bank Corp",
						"long_weight": 0.00367
					},
					{
						"standard_name": "PNC Financial Services Group Inc",
						"long_weight": 0.00302
					},
					{
						"standard_name": "UniCredit SpA",
						"long_weight": 0.003
					},
					{
						"standard_name": "Banco Santander SA",
						"long_weight": 0.00248
					}
				]
			},
			"is_fossil_insure": {
				"count": 5,
				"list": [
					{
						"standard_name": "Zurich Insurance Group AG",
						"long_weight": 0.00279
					},
					{
						"standard_name": "Tokio Marine Holdings Inc",
						"long_weight": 0.00246
					},
					{
						"standard_name": "AXA SA",
						"long_weight": 0.00239
					},
					{
						"standard_name": "The Travelers Companies Inc",
						"long_weight": 0.00227
					},
					{
						"standard_name": "Munchener Ruckversicherungs-Gesellschaft AG",
						"long_weight": 0.00186
					}
				]
			},
			"is_df_p": {
				"count": 5,
				"list": [
					{
						"standard_name": "ITOCHU Corp",
						"long_weight": 0.00127
					},
					{
						"standard_name": "Marubeni Corp",
						"long_weight": 0.00043
					},
					{
						"standard_name": "First Resources Ltd",
						"long_weight": 0.00038
					},
					{
						"standard_name": "Mondi PLC",
						"long_weight": 0.00037
					},
					{
						"standard_name": "Hormel Foods Corp",
						"long_weight": 0.0003
					}
				]
			},
			"is_df_f": {
				"count": 5,
				"list": [
					{
						"standard_name": "JPMorgan Chase & Co",
						"long_weight": 0.0075
					},
					{
						"standard_name": "Bank of America Corp",
						"long_weight": 0.00541
					},
					{
						"standard_name": "Morgan Stanley",
						"long_weight": 0.00192
					},
					{
						"standard_name": "Sumitomo Mitsui Financial Group Inc",
						"long_weight": 0.0019
					},
					{
						"standard_name": "Mitsubishi UFJ Financial Group Inc",
						"long_weight": 0.00178
					}
				]
			},
			"is_df_c": {
				"count": 5,
				"list": [
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01508
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00416
					},
					{
						"standard_name": "Shell PLC",
						"long_weight": 0.00376
					},
					{
						"standard_name": "Lvmh Moet Hennessy Louis Vuitton SE",
						"long_weight": 0.00363
					},
					{
						"standard_name": "Lowe's Companies Inc",
						"long_weight": 0.00301
					}
				]
			},
			"is_wff_gun_manufacturers": {
				"count": 1,
				"list": [
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00151
					}
				]
			},
			"is_wff_gun_retailers": {
				"count": 3,
				"list": [
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00259
					},
					{
						"standard_name": "Academy Sports and Outdoors Inc",
						"long_weight": 0.00032
					},
					{
						"standard_name": "Dick's Sporting Goods Inc",
						"long_weight": 0.00002
					}
				]
			},
			"is_pff_prisons": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01896
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01715
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01508
					},
					{
						"standard_name": "Walmart Inc",
						"long_weight": 0.00259
					},
					{
						"standard_name": "McDonald's Corp",
						"long_weight": 0.00166
					}
				]
			},
			"is_pff_borders": {
				"count": 5,
				"list": [
					{
						"standard_name": "Microsoft Corp",
						"long_weight": 0.01896
					},
					{
						"standard_name": "Alphabet Inc",
						"long_weight": 0.01715
					},
					{
						"standard_name": "Amazon.com Inc",
						"long_weight": 0.01508
					},
					{
						"standard_name": "RELX PLC",
						"long_weight": 0.00416
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00239
					}
				]
			},
			"is_pff_high": {
				"count": 5,
				"list": [
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00239
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00151
					},
					{
						"standard_name": "Motorola Solutions Inc",
						"long_weight": 0.00071
					},
					{
						"standard_name": "Thomson Reuters Corp",
						"long_weight": 0.00068
					},
					{
						"standard_name": "Axon Enterprise Inc",
						"long_weight": 0.0006
					}
				]
			},
			"is_pff_extreme": {
				"count": 0,
				"list": []
			},
			"is_wff_major_military_contractors": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00614
					},
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00605
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00483
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00383
					},
					{
						"standard_name": "Mitsubishi Heavy Industries Ltd",
						"long_weight": 0.00275
					}
				]
			},
			"is_wff_cluster_munitions": {
				"count": 5,
				"list": [
					{
						"standard_name": "CRH PLC",
						"long_weight": 0.00605
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00483
					},
					{
						"standard_name": "Rheinmetall AG",
						"long_weight": 0.00383
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00239
					},
					{
						"standard_name": "Thales",
						"long_weight": 0.00166
					}
				]
			},
			"is_wff_nuclear_weapons": {
				"count": 5,
				"list": [
					{
						"standard_name": "GE Aerospace",
						"long_weight": 0.00614
					},
					{
						"standard_name": "BAE Systems PLC",
						"long_weight": 0.00483
					},
					{
						"standard_name": "Airbus SE",
						"long_weight": 0.00239
					},
					{
						"standard_name": "Thales",
						"long_weight": 0.00166
					},
					{
						"standard_name": "Northrop Grumman Corp",
						"long_weight": 0.00151
					}
				]
			},
			"is_t": {
				"count": 0,
				"list": []
			},
			"is_t_m": {
				"count": 5,
				"list": [
					{
						"standard_name": "Comcast Corp",
						"long_weight": 0.00256
					},
					{
						"standard_name": "The Walt Disney Co",
						"long_weight": 0.00247
					},
					{
						"standard_name": "Sony Group Corp",
						"long_weight": 0.0014
					},
					{
						"standard_name": "AT&T Inc",
						"long_weight": 0.00097
					},
					{
						"standard_name": "Paramount Global",
						"long_weight": 0.00007
					}
				]
			}
		},
		"highlighted_holdings": {
			"dff": [
				"Archer-Daniels-Midland Co",
				"ITOCHU Corp",
				"Marubeni Corp"
			],
			"wff": [
				"Lockheed Martin Corp",
				"Northrop Grumman Corp",
				"GE Aerospace"
			],
			"tff": [],
			"fff": [
				"Exxon Mobil Corp",
				"Reliance Industries Ltd",
				"Shell PLC"
			],
			"pff": [
				"Airbus SE",
				"Northrop Grumman Corp",
				"Motorola Solutions Inc"
			],
			"gff": [
				"Northrop Grumman Corp"
			],
			"ffb": [
				"JPMorgan Chase & Co",
				"Bank of America Corp",
				"China Construction Bank Corp"
			],
			"ffi": [
				"Zurich Insurance Group AG",
				"Tokio Marine Holdings Inc",
				"AXA SA"
			]
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/TargetDateSeries.json
// module id = 1012
// module chunks = 0